<div class="breadcrumb_outer">
  <ul class="breadcrumb">
    <li>
      <a>{{ company_name }}:</a>
    </li>
    <li class="active" *ngFor="let item of breadcrumbsArray; let i = index">
      <a (click)="goToPageLink(item.page_ref)">
        {{ item.page_title }}
      </a>
    </li>
  </ul>
  <div class="right">
    <span>{{ today }}</span>
    <!--here responsiveness has been used commented by Prerna Singh on 21 february 2024-->
  </div>
</div>
<div class="tag_powered_by bottomPowerBy">
  <span>Powered by: <b>Enertics</b></span>
</div>
<div class="Content_outer">
  <div class="row">
    <div class="col-md-12">
      <span class="page-overlay"></span>
<!---------------------------->
      <div class="tab_right">
        <div class="container">
          <div class="row middle-row">
            <div class="txt">
              <span class="un_seen1" *ngIf="Battery">
                <b>Battery Status:</b>
                <span
                  style="cursor: pointer"
                  [matTooltip]="itemtooltiptext()"
                  style="height: 10px; width: 10px"
                  [matTooltipClass]="'tooltip'"
                >
                  <img
                    *ngIf="Batteryred"
                    style="height: 25px; width: 25px"
                    src="./assets/images/batteryred.jpeg"
                  />
                  <img
                    *ngIf="Batteryyellow"
                    style="height: 35px; width: 35px"
                    src="./assets/images/batteryyellow.png"
                  />
                  <img
                    *ngIf="Batterygreen"
                    style="height: 25px; width: 25px"
                    src="./assets/images/batterygreen.jpeg"
                  />
                </span>
                <!-- <span style="margin-left: 10px"> <b>RSSI:</b>{{ rssival }}</span> -->
              </span>
              <!-- <span  class="un_seen btryUnseen" *ngIf="!Battery">
                <b>RSSI:</b>{{ rssival }}
                <style>
                  .tab_right .txt .btryUnseen { margin-left: 275px;}
                </style>
              </span> -->
              <!-- <span class="un_seen btryUnseen"> <b>RSSI:</b>{{ rssival }}</span> -->
            </div>
            <div class="legendbox legendBoxTop">
              <div style="background-color: #cecece"></div>
              <strong>Asset Idle</strong>
              <div style="background-color: #3fbddd"></div>
              <strong>Asset Running</strong>
              <div style="background-color: #999999"></div>
              <strong>Offline</strong>
              <div style="background-color: #72ff13"></div>
              <strong>Healthy</strong>
              <div style="background-color: #faa700"></div>
              <strong>Unsatisfactory</strong>
              <div style="background-color: #ff2a1b"></div>
              <strong>Unacceptable</strong>
              <div style="background-color: #fcda42"></div>
              <strong>Out for service</strong>
            </div>
          </div>
        </div>
      </div>
      <div class="tab_right" *ngIf="connectivityType === 'wifi' || connectivityType === 'Wifi'">
        <div class="txt mainStatusWrap">
          <div class="valWrap">
            <span *ngIf="onoffStatus == 2 && isOutOfService == false" class="sprite_icon wifi_red"></span>
            <span *ngIf="onoffStatus == 2 && isOutOfService == false" class="un_seen"
              ><b>Offline:</b>{{ monitorInfo.offlinestatus_time }}</span
            >
            <span
              *ngIf="(onoffStatus == 0 || onoffStatus == 1) && !isOutOfService"
              class="sprite_icon wifi_black"
            ></span>

            <!-- <span *ngIf="isOutOfService; else outofserviceicon" ></span>
            <ng-template #outofserviceicon>
              <span class="sprite_icon wifi_black"></span>
            </ng-template> -->
            <span *ngIf="onoffStatus == 0 && isOutOfService == false" class="seen"
              ><b>Online</b>{{ overAllService }}</span
            >
            <span *ngIf="onoffStatus == 1 && isOutOfService == false" class="seen"
              ><b>Online</b>{{ overAllService }}</span
            >
            <span *ngIf="isOutOfService == true" class="seen"
              ><b style="background-color:#fcda42; color: black; padding: 5px 3px;">Out for service</b>{{ overAllService }}</span
            >
          </div>
          @if(fromPowerTrain){
          <div class="statusWrap">
            <!-- <span
              *ngIf="overall_powertrain_live_status == 0 && isOutOfService == false"
              class="seen"
              style="padding-left: 16px"
            >
              <img
                matTooltip="Asset Idle"
                style="height: 10px; width: 10px"
                src="./assets/images/red.png"
                [matTooltipClass]="'tooltip'"
            /></span> -->
            <!-- <span
              *ngIf="isOutOfService === true"
              class="seen"
              style="padding-left: 16px"
            >
              <img
                matTooltip="Asset out for service"
                style="height: 10px; width: 10px"
                src="./assets/images/yellow.png"
                [matTooltipClass]="'tooltip'"
            /></span>
            <span *ngIf="(overall_powertrain_live_status == 1)  && isOutOfService == false" class="seen">
              <div class="asset_running_dot blue_bg"
                    matTooltip="Asset Running"
                  [matTooltipClass]="'tooltip1'"
          ></div>
            </span>
            <span *ngIf="(overall_powertrain_live_status == 2 || overall_powertrain_live_status == 0 ) && isOutOfService == false" class="seen">
              <div class="asset_running_dot gray_bg"
             matTooltip="Asset Idle"
            [matTooltipClass]="'tooltip1'"
          ></div>
            </span> -->

            <span *ngIf="role != 'OEM'" class="seen">
              <img
                style="width: 20px; height: 20px; cursor: pointer"
                src="./assets/settings.png"
                [matMenuTriggerFor]="menu"
            /></span>
          </div>
          }@else{
          <div class="statusWrap">
            <!-- <span
              *ngIf="(overallStatus == 2 || overallStatus == 0) && isOutOfService == false"
              class="seen"
              style="padding-left: 16px"
            >
            <div class="asset_running_dot gray_bg"
             matTooltip="Asset Idle"
            [matTooltipClass]="'tooltip1'"
          ></div>
          </span>
            <span
              *ngIf="isOutOfService === true"
              class="seen"
              style="padding-left: 16px"
            >
              <img
                matTooltip="Asset out for service"
                style="height: 10px; width: 10px"
                src="./assets/images/yellow.png"
                [matTooltipClass]="'tooltip'"
            /></span>

            <span *ngIf="(overallStatus == 1) && isOutOfService === false" class="seen">
              <div class="asset_running_dot blue_bg"
             matTooltip="Asset Running"
            [matTooltipClass]="'tooltip1'"
          ></div>
            </span> -->
            <!-- <span *ngIf="onoffStatus === 2 && isOutOfService === false" class="seen">
              <img
                matTooltip="Asset Idle"
                style="height: 10px; width: 10px"
                src="./assets/images/red.png"
                [matTooltipClass]="'tooltip'"
            /></span> -->

            <span *ngIf="role != 'OEM'" class="seen">
              <img
                style="width: 20px; height: 20px; cursor: pointer"
                src="./assets/settings.png"
                [matMenuTriggerFor]="menu"
            /></span>
          </div>
          }

        </div>
      </div>
      <mat-menu #menu="matMenu" class="stroked-menu">
        <div class="menu-item-container" *ngIf="userRoll != 'USER'">
          <button
            mat-stroked-button
            color="primary"
            [disabled]="isOutOfService"
            (click)="editAssets()"
            class="edit-button stroked-menu-button"
            [ngClass]="{'disabled-button': isOutOfService}">
            <mat-icon>edit</mat-icon>
            <span>Edit</span>
          </button>
        </div>

        <div class="menu-item-container" *ngIf="userRoll != 'USER'">
          <button
            mat-stroked-button
            [disabled]="isOutOfService"
            (click)="viewAsset()"
            class="settings-button stroked-menu-button"
            [ngClass]="{'disabled-button': isOutOfService}">
            <mat-icon>settings</mat-icon>
            <span>Settings</span>
          </button>
        </div>

        <div class="menu-item-container">
          <button
            mat-stroked-button
            (click)="getDeviceInfo()"
            class="details-button stroked-menu-button">
            <mat-icon>info</mat-icon>
            <span>Plate Details</span>
          </button>
        </div>

        <div class="menu-item-container">
          <button
            mat-stroked-button
            [disabled]="isOutOfService"
            (click)="serviceBookOpen()"
            class="service-button stroked-menu-button"
            [ngClass]="{'disabled-button': isOutOfService}">
            <mat-icon>build</mat-icon>
            <span>Service</span>
          </button>
        </div>

        <div class="menu-item-container" *ngIf="userRoll === 'CLIENT' || userRoll != 'USER'">
          <button
            mat-stroked-button
            [disabled]="isOutOfService"
            (click)="alertSettings()"
            class="alert-button stroked-menu-button"
            [ngClass]="{'disabled-button': isOutOfService}">
            <mat-icon>notifications</mat-icon>
            <span>Alert Settings</span>
          </button>
        </div>

        <div class="menu-item-container" *ngIf="deviceSerialNo === 1 && userRoll != 'USER'">
          <button
            *ngIf="childCount == 0; else otherDelete"
            mat-stroked-button
            color="warn"
            (click)="showDeleteDialog()"
            class="delete-button stroked-menu-button">
            <mat-icon>delete</mat-icon>
            <span>Delete</span>
          </button>
          <ng-template #otherDelete>
            <button
              mat-stroked-button
              color="warn"
              (click)="showDeleteAlert()"
              class="delete-button stroked-menu-button">
              <mat-icon>delete</mat-icon>
              <span>Delete</span>
            </button>
          </ng-template>
        </div>

        <div class="menu-item-container" *ngIf="deviceSerialNo != 1">
          <button
            mat-stroked-button
            color="warn"
            (click)="showDeleteDialog()"
            class="delete-button stroked-menu-button">
            <mat-icon>delete</mat-icon>
            <span>Delete</span>
          </button>
        </div>
      </mat-menu>
<!---------------------------->
      <ul
      ngbNav
      #ctdTabset="ngbNav"

      class="custom_tab nav-v nav-tabs"
        [activeId]="selectedTabId"
        (navChange)="beforeChange($event)"
      >
        <li  [ngbNavItem]="'tab-1'" id="tab-1">
          <a ngbNavLink >
            Monitoring
          </a>
          <ng-template ngbNavContent>
            <div class="fixed_status_bar">
              <div class="info_box_outer">
                <div class="info_box">
                  <h4 *ngIf="!monitoringDeviceDetailsLoader; else loading">
                    {{ monitoringDeviceDetails?.companyName?.company_name || "N/A" }}
                  </h4>
                  <ng-template #loading>
                    <div class="skeleton skeleton-service-text-device-details"></div>
                  </ng-template>
                  <h6>Customer</h6>
                </div>
                <div class="info_box">
                  <h4 *ngIf="!monitoringDeviceDetailsLoader; else loading">
                    {{ monitoringDeviceDetails?.assetDetails?.site_name || "N/A" }}
                  </h4>
                  <ng-template #loading>
                    <div class="skeleton skeleton-service-text-device-details"></div>
                  </ng-template>
                  <h6>Site</h6>
                </div>
                <div class="info_box">
                  <h4 *ngIf="!monitoringDeviceDetailsLoader; else loading">
                    {{ monitoringDeviceDetails?.assetDetails?.application_name || "N/A" }}
                  </h4>
                  <ng-template #loading>
                    <div class="skeleton skeleton-service-text-device-details"></div>
                  </ng-template>
                  <h6>Application</h6>
                </div>
                <div class="info_box">
                  <div class="inner">
                    <div class="lft">
                      <!-- <h4>{{ monitoringDeviceDetails?.assetDetails?.motor_make || "N/A" }}</h4>
                      <h6>Machine Make</h6> -->
                      <h4 *ngIf="!monitoringDeviceDetailsLoader; else loading">
                        {{ monitoringDeviceDetails?.assetDetails?.equipment_location || "N/A" }}
                      </h4>
                      <ng-template #loading>
                        <div class="skeleton skeleton-service-text-device-details"></div>
                      </ng-template>
                      <h6>Equipment Location</h6>
                    </div>
                    <div
                      class="rgt"
                      (click)="goToImageLink(_imgUrl)"
                      style="cursor: pointer"
                    >
                      <img
                        [src]="_imgUrl"
                        alt="User"
                        class="thumb"
                        onerror="this.src='./assets/img-new/assets.png'"
                      />
                    </div>
                  </div>
                </div>
                <div class="info_box">
                  <h4 *ngIf="!monitoringDeviceDetailsLoader; else loading">
                    {{ monitoringDeviceDetails?.assetDetails?.motor_serial_no || "N/A" }}
                  </h4>
                  <ng-template #loading>
                    <div class="skeleton skeleton-service-text-device-details"></div>
                  </ng-template>
                  <h6>Machine Serial Number</h6>
                </div>
                <div class="info_box">
                  <h4 *ngIf="!monitoringDeviceDetailsLoader; else loading">
                    {{ monitoringDeviceDetails?.assetDetails?.name || "N/A" }}
                  </h4>
                  <ng-template #loading>
                    <div class="skeleton skeleton-service-text-device-details"></div>
                  </ng-template>
                  <h6>Asset Name</h6>
                </div>
              </div>
            </div>
            <div class="inner_gauge_box">
              <div class="chart_boxes_outer m_b_0">
                <div class="ch_box acc" [ngStyle]="{width:(master_product_type && (master_product_type==1 || master_product_type==2)) ? '70%' : '49%'}">
                  <div class="heading">Machine Vibration</div>

                  <div
                    class="inner vibrationInner"
                    *ngIf="machineVibrationLoading"
                  >
                    <!-- <div class="cht" *ngFor="let i of [0, 1, 2, 3]">
                      <ng-container>
                        <div class="spinner-container charts-loader">
                          <div
                            class="spinner-border text-primary"
                            role="status"
                          ></div>
                        </div>
                      </ng-container>
                    </div> -->
                    <div class="cht" *ngFor="let i of [0, 1, 2, 3]">
                      <div class="skeleton skeleton-chart"></div>
                      <div class="skeleton skeleton-chart-text"></div>
                    </div>
                  </div>
                  <div class="inner vibrationInner" *ngIf="!machineVibrationLoading">
                    <div
                      class="cht"
                      *ngFor="let meterdata1 of monitoringMeterShowVelocity"

                    >


                    <app-gauge-chart
                    matTooltip=" Velocity Thresholds as per ISO 10816-3 or customer defined specific thresholds as per their process."

                    [canvasWidth]="200"
                    [canvasHeight]="140"
                    [needleValue]="meterdata1.needleValue"
                    [needleColor]="meterdata1.options.needleColor"
                    [centralLabel]="centralLabel"
                    [options]="meterdata1.options"
                    [name]="meterdata1.name"
                    [bottomLabel]="meterdata1.bottomLabel">
                  </app-gauge-chart>



                    </div>
                    <div class="cht" *ngIf="gaugedisplay">
                      <app-gauge-chart
                      matTooltip="Peak Acceleration Threshold as per the Bernhard Guidlines or customer defined specific thresholds as per their process."

                   [canvasWidth]="200"
                    [canvasHeight]="140"
                    [needleValue]="monitoringmaxaccobj.needleValue"
                    [needleColor]="monitoringmaxaccobj.options.needleColor"
                    [centralLabel]="centralLabel"
                    [options]="monitoringmaxaccobj.options"
                    [name]="monitoringmaxaccobj.name"
                    [bottomLabel]="monitoringmaxaccobj.bottomLabel">
                  </app-gauge-chart>

                    <!-- <div class="cht" *ngIf="gaugedisplay">
                      <rg-gauge-chart
                        matTooltip="Peak Acceleration Threshold as per the Bernhard Guidlines or customer defined specific thresholds as per their process."
                        style="color: orange"
                        [matTooltipClass]="'tooltip'"
                        [ngClass]="{
                          big_font_chartbox: maxaccobj.hasneedle == false
                        }"
                        [canvasWidth]="canvasWidth"
                        [centralLabel]="vall"
                        [needleValue]="maxaccobj.needleValue"
                        [options]="Optionsss"
                        [name]="maxaccobj.name"
                        [bottomLabel]="maxaccobj.bottomLabel"
                      >
                      </rg-gauge-chart> -->
                    </div>
                  </div>

                </div>
                <div class="ch_box temp" [ngStyle]="{width:(master_product_type && (master_product_type==1 || master_product_type==2)) ? '20%' : '49%'}">
                  <div class="heading">Temperature</div>
                  <div class="inner tempInner" *ngIf="tempgaugeLoader">
                    <div *ngIf="master_product_type == 1 || master_product_type == 2; else otherTemplate">
                      <div class="cht" [ngStyle]="{width:(master_product_type && (master_product_type==1 || master_product_type==2)) ? '' : '33.3%'}" *ngFor="let i of [0]">
                        <div class="skeleton skeleton-chart"></div>
                        <div class="skeleton skeleton-chart-text"></div>
                      </div>
                    </div>

                    <ng-template #otherTemplate>
                      <div class="cht" *ngFor="let i of [0,1,2]">
                        <div class="skeleton skeleton-chart"></div>
                        <div class="skeleton skeleton-chart-text"></div>
                      </div>
                    </ng-template>

                  </div>
                  <div class="inner tempInner" style="align-items: center; justify-content:center" *ngIf="displaytempgauge && !tempgaugeLoader">
                    <div
                      class="cht"
                      *ngFor="let meterdata1 of monitoringTempratueResults"
                      style="   align-items: center;
                                justify-content: center;
                                display: flex;"
                    >
                    <app-gauge-chart
                    matTooltip="Temperature Thresholds as per  IEEE 841 or customer defined specific thresholds as per their process."
                    [canvasWidth]="200"
                    [canvasHeight]="140"
                    [needleValue]="meterdata1.needleValue"
                    [needleColor]="meterdata1.options.needleColor"
                    [centralLabel]="centralLabel"
                    [options]="meterdata1.options"
                    [name]="meterdata1.name"
                    [bottomLabel]="meterdata1.bottomLabel">
                  </app-gauge-chart>
                      <!-- <rg-gauge-chart
                        style="color: orange"
                        [matTooltipClass]="'tooltip'"
                        [ngClass]="{
                          big_font_chartbox: meterdata1.hasneedle == false
                        }"
                        [canvasWidth]="meterdata1.canvasWidth"
                        [needleValue]="meterdata1.needleValue"
                        [options]="meterdata1.options"
                        [name]="meterdata1.name"
                        [bottomLabel]="meterdata1.bottomLabel"
                      >
                      </rg-gauge-chart> -->
                    </div>
                    <!-- <div
                      class="cht"
                      matTooltip="Temprature Thresholds as per the ..."
                      style="color: orange"
                      *ngFor="let tempdata of tempratueResults"
                      [matTooltipClass]="'tooltip'"
                    >
                      <div class="img_outer">
                        <span *ngIf="tempdata.value !== 'N/A'">
                          <div
                            *ngIf="
                              tempdata.value > 0 &&
                              tempdata.key == 'Bearing_Temperature'
                            "
                            id="chartContainerm"
                            style="height: 100px; width: 50px; margin: 0 auto"
                          ></div>
                          <div
                            *ngIf="
                              tempdata.value > 0 &&
                              tempdata.key == 'Bearing_Temperature'
                            "
                            class="meterWrap meterTipRemove"
                          >
                            <img src="assets/meter2.png" alt="" class="meter" />
                          </div>
                        </span>

                        <span *ngIf="tempdata.value !== 'N/A'">
                          <div
                            *ngIf="
                              tempdata.value > 0 &&
                              tempdata.key == 'Winding_Temperature'
                            "
                            id="chartContainern"
                            style="height: 120px; width: 50px; margin: 0 auto"
                          ></div>
                          <div
                            *ngIf="
                              tempdata.value > 0 &&
                              tempdata.key == 'Winding_Temperature'
                            "
                            class="meterWrap meterTipRemove"
                          >
                            <img src="assets/meter2.png" alt="" class="meter" />
                          </div>
                        </span>

                        <span *ngIf="tempdata.value !== 'N/A'">
                          <div
                            *ngIf="
                              tempdata.value > 0 &&
                              tempdata.key == 'Ambient_Temperature'
                            "
                            id="chartContainero"
                            style="height: 120px; width: 50px; margin: 0 auto"
                          ></div>
                          <div
                            *ngIf="
                              tempdata.value > 0 &&
                              tempdata.key == 'Ambient_Temperature'
                            "
                            class="meterWrap meterTipRemove"
                          >
                            <img src="assets/meter2.png" alt="" class="meter" />
                          </div>
                        </span>
                      </div>
                      <div class="up" *ngIf="tempdata.bottomLabel === 'N/A'">
                        {{ tempdata.bottomLabel }}
                      </div>
                      <span *ngIf="tempdata.bottomLabel !== 'N/A'">
                        <div
                          class="up"
                          *ngIf="tempdata.key == 'Bearing_Temperature'"
                        >
                          <span *ngIf="tempdata.value > 0; else other_content"
                            >{{ tempdata.value }} °C</span
                          >
                          <ng-template #other_content>N/A</ng-template>
                        </div>
                        <div
                          class="up"
                          *ngIf="tempdata.key == 'Winding_Temperature'"
                        >
                          <span *ngIf="tempdata.value > 0; else other_content"
                            >{{ tempdata.value }} °C</span
                          >
                          <ng-template #other_content>N/A</ng-template>
                        </div>

                        <div
                          class="up"
                          *ngIf="tempdata.key == 'Ambient_Temperature'"
                        >
                          <span *ngIf="tempdata.value > 0; else other_content"
                            >{{ tempdata.value }} °C</span
                          >
                          <ng-template #other_content>N/A</ng-template>
                        </div>
                      </span>

                      <div class="below">{{ tempdata.name }}</div>
                    </div> -->
                  </div>
                </div>

              @if (master_product_type && master_product_type==1) {
                <div class="summaryBox summary_box">
                  <div class="heading">Anomaly Status</div>

                  <!-- Updated at -->
                  <div class="detail">
                    <div class="left">Updated at</div>
                    <div class="right" *ngIf="!anomalyLoader; else updatedLoading">
                      {{ overAllService || "N/A" }}
                    </div>
                    <ng-template #updatedLoading>
                      <div class="skeleton skeleton-service-text-anomaly-status"></div>
                    </ng-template>
                  </div>

                  <!-- Status -->
                  <div class="detail">
                    <div class="left">Status</div>
                    <div class="right" *ngIf="!anomalyLoader; else statusLoading">
                      <span
                        [ngClass]="{
                          'label_green': overall_health_status === 'Good',
                          'label_red': overall_health_status === 'Unacceptable',
                          'label_yellow': overall_health_status === 'Unsatisfactory',
                          'label_white': overall_health_status === 'N/A'
                        }"
                      >
                        {{ overall_health_status }}
                      </span>
                    </div>
                    <ng-template #statusLoading>
                      <div class="skeleton skeleton-service-text-status"></div>
                    </ng-template>
                  </div>

                  <!-- Recommended Action -->
                  <div class="detail">
                    <div class="left">Recommended Action</div>
                    <div class="right" *ngIf="!anomalyLoader; else actionLoading">
                      {{ recommened_action || "N/A" }}
                    </div>
                    <ng-template #actionLoading>
                      <div class="skeleton skeleton-service-text-recommended-action"></div>
                    </ng-template>
                  </div>

                  <!-- Asset Report -->
                  <div *ngIf="role != 'OEM'" class="detail">
                    <div class="left">Asset Report</div>
                    <div class="right">
                      <button
                        *ngIf="anomalyLoader; else reportButton"
                        class="skeleton skeleton-button"
                      ></button>
                      <ng-template #reportButton>
                        <button
                          [disabled]="onoffStatus === 2 || downloadDisabled"
                          *ngIf="
                            (hideDownloadBtn && onoffStatus === 2) ||
                            downloadDisabled
                          "
                          mat-raised-button
                          color="primary"
                          (click)="getDeviceReport()"
                        >
                          <span matTooltip="{{ msgDownload }}">Generate Report</span>
                        </button>
                        <button
                          [disabled]="onoffStatus === 2 || downloadDisabled"
                          *ngIf="
                            hideDownloadBtn &&
                            !downloadDisabled &&
                            (onoffStatus === 0 || onoffStatus === 1)
                          "
                          (click)="getDeviceReport()"
                          mat-raised-button
                          color="primary"
                          ><span>Generate Report</span>
                        </button>
                        <Button
                        *ngIf="hideDownloadBtn === false"
                        [disabled]=true
                        style="background-color: #80868b"
                          ><span>Generating Report</span>
                        </Button>
                        <!-- <span
                          *ngIf="hideDownloadBtn === false"
                          style="color: green"
                        >
                          {{ showReportMsg }}
                        </span> -->
                      </ng-template>
                    </div>
                  </div>
                </div>
                }
                <div
                  class="ch_box orien"
                  style="
                    padding-left: 0px !important;
                    padding-right: 0px !important;
                  "
                  *ngIf="master_product_type && (master_product_type==3 || master_product_type==2)"
                >
                  <div class="container">
                    <div class="row">
                      <div
                        class="col-sm"
                        style="
                          padding-left: unset !important;
                          padding-right: unset !important;
                        "
                      >
                        <div class="chatGraphTab">
                          <div class="heading">Machine Acoustics</div>
                          <div class="cht chtTab">
                            <div *ngIf="acousticgaugeLoader">
                              <!-- <ng-container>
                                <div class="spinner-container charts-loader">
                                  <div
                                    class="spinner-border text-primary"
                                    role="status"
                                  ></div>
                                </div>
                              </ng-container> -->
                              <div class="skeleton skeleton-chart-acoustic" style="display: block;"></div>
                              <div class="skeleton skeleton-chart-acoustic-text"></div>
                            </div>
                            <!-- acousticgauge -->
                            <div *ngIf="!acousticgaugeLoader">
                              <app-gauge-chart
                              matTooltip=" Machine acoustics thresholds as per the ISO 29821 or customer defined specific thresholds as per their process."

                             [canvasWidth]="160"
                              [canvasHeight]="140"
                              [needleValue]="MonitoringMagacoustic.needleValue"
                              [needleColor]="MonitoringMagacoustic.options.needleColor"
                              [centralLabel]="centralLabel"
                              [options]="MonitoringMagacoustic.options"
                              [name]="MonitoringMagacoustic.name"
                              [bottomLabel]="MonitoringMagacoustic.bottomLabel">
                            </app-gauge-chart>
                              <!-- <rg-gauge-chart
                                style="color: orange"
                                [matTooltipClass]="'tooltip'"
                                [ngClass]="{
                                  big_font_chartbox:
                                  MonitoringMagacoustic?.hasneedle == false
                                }"
                                [canvasWidth]="canvasWidth"
                                [needleValue]="MonitoringMagacoustic?.needleValue"
                                [centralLabel]="centralLabel"
                                [options]="MonitoringMagacoustic?.options"
                                [name]="MonitoringMagacoustic?.name"
                                [bottomLabel]="MonitoringMagacoustic?.bottomLabel"
                              >
                              </rg-gauge-chart> -->
                              <!-- <rg-gauge-chart
                                matTooltip=" Machine acoustics thresholds as per the ISO 29821 or customer defined specific thresholds as per their process."
                                style="color: orange"
                                [matTooltipClass]="'tooltip'"
                                [ngClass]="{
                                  big_font_chartbox:
                                    magacoustic?.hasneedle == false
                                }"
                                [canvasWidth]="canvasWidth"
                                [needleValue]="magacoustic?.needleValue"
                                [centralLabel]="centralLabel"
                                [options]="magacoustic?.options"
                                [name]="magacoustic?.name"
                                [bottomLabel]="magacoustic?.bottomLabel"
                              >
                              </rg-gauge-chart> -->
                              <!-- <div  id="chartContainermagacoustic" matTooltip="Machine Acoustic threshold as per the ISO 29821"
                              style="color: orange" style="height: 115px; width: 60px;" [matTooltipClass]="'tooltip'" ></div> -->

                              <!-- <div id="below_right" class="belowText">
                                {{ ultrasoundValue }} dB
                              </div>
                              <div id="below_right">Δ Ultrasound</div> -->
                            </div>
                            <div *ngIf="audibleLoader; else audibleId">
                              <!-- <ng-container>
                                <div class="spinner-container charts-loader">
                                  <div
                                    class="spinner-border text-primary"
                                    role="status"
                                  ></div>
                                </div>
                              </ng-container> -->
                              <div class="skeleton skeleton-chart-acoustic" style="display: block;"></div>
                              <div class="skeleton skeleton-chart-acoustic-text"></div>
                            </div>
                            <ng-template #audibleId>
                              <div
                                [matTooltip]="
                                  'Values are calculated for 1.5m from surface of asset.'
                                "
                                matTooltipClass="tooltip"
                              >
                                <div class="img_outer" >
                                  <img
                                  style="
                                  width: 70px;
                                  min-width: 86px;
                                  height: 91px;
                                  margin-bottom: 0px !important;
                                  "
                                    src="./assets/ultrasonic_sensor.png"
                                    alt="ultrasonic sensor"
                                  />

                                  <div id="below_left" class="extra-bold-text" style="text-shadow: 0.3px 0.3px 0 #191919;padding-bottom: 1px; font-size: 16px;">
                                    {{ monitoringAudibleValue }} dB-A
                                  </div>
                                  <!-- <div id="below_left" class="belowText">
                                    {{ audibleValue }} dB-A
                                  </div> -->
                                  <div style="margin-top: -5px !important;" id="below_left">Audible</div>
                                </div>
                              </div>
                            </ng-template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="chart_boxes_outer m_b_0">
                <div class="chartBoxWrap ch_box acc">
                  <div class="heading">
                    Machine Health Status (12 hours)
                    <span
                      matTooltip="The status bar is calculated from the peak sensor value recorded in the 30 mins window.
                                The Peak value may or may not correspond to an Unacceptable condition.
                                Please check the 24 Hours Machine Alert Summary for actual Unacceptable condition alerts
                                 "
                      style="color: orange"
                      [matTooltipClass]="'tooltip'"
                      >*</span
                    >
                  </div>
                    <div
                      id="stackvelocitychartContainer"
                      style="height: 100px; width: 100%; display: block"
                    >
                    <div *ngIf="stackvelocitychartLoader" class="skeleton skeleton-health-status"></div>
                  </div>

                  <div class="heading">
                    Asset Health Bar
                  </div>
                </div>
                <!-- <svg style="height: 0; width: 0;">
                  <defs>

                    <linearGradient id="gauge-gradientGreen" x1="20%" y1="10%" x2="90%" y2="0%">
                      <stop offset="20%" style="stop-color:#1b9d28; stop-opacity:1" />
                      <stop offset="80%" style="stop-color:#f8c901; stop-opacity:1" />
                    </linearGradient>


                    <linearGradient id="gauge-gradient" x1="10%" y1="0%" x2="80%" y2="0%">
                      <stop offset="20%" style="stop-color:#f8c901; stop-opacity:1" />
                      <stop offset="80%" style="stop-color:#de1618; stop-opacity:1" />
                    </linearGradient>
                  </defs>
                </svg> -->
                <!-- <div
                  class="chartBoxWrap ch_box mrpm"
                  style="padding-bottom: 0; display: flex; width: 490px"
                  *ngIf="assetType === 'GEAR'"
                >
                  <div class="left">
                    <div class="heading">Pinion Gear RPM</div>

                    <div
                      class=""
                      *ngIf="!pinionrpmshowgaudge.length; else pionionGaugeId"
                      style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      "
                    >
                      <ng-container>
                        <div class="spinner-container charts-loader">
                          <div
                            class="spinner-border text-primary"
                            role="status"
                          ></div>
                        </div>
                      </ng-container>
                    </div>
                    <ng-template #pionionGaugeId>
                      <div class="img_outer">
                        <div
                          *ngFor="let meterdatapinion of pinionrpmshowgaudge"
                        >
                          <div
                            [ngClass]="{
                              'pinion-1x': rpmValueClass === '1x',
                              'pinion-10x': rpmValueClass === '10x'
                            }"
                          ></div>
                          <rg-gauge-chart
                            [ngClass]="{
                              big_font_chartbox:
                                meterdatapinion.hasneedle == false
                            }"
                            [canvasWidth]="canvasWidth"
                            [needleValue]="meterdatapinion.needleValue"
                            [centralLabel]="centralLabel"
                            [options]="meterdatapinion.options"
                            [name]="meterdatapinion.name"
                            [bottomLabel]="meterdatapinion.bottomLabel"
                          >
                          </rg-gauge-chart>
                        </div>
                        <div class="bottom_label">
                          <span
                            *ngIf="
                              pinion_gear_actual_rpm != -1;
                              else nextPinGear
                            "
                            >{{ pinion_gear_actual_rpm + " RPM" }}</span
                          >
                          <ng-template #nextPinGear>
                            <span>N/A</span>
                          </ng-template>
                        </div>
                      </div>
                    </ng-template>
                  </div>
                  <div class="right">
                    <div class="heading">Output Gear RPM</div>
                    <div
                      class=""
                      *ngIf="!outer_rpmshowgaudge.length; else outerRpmGaugeId"
                      style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      "
                    >
                      <ng-container>
                        <div class="spinner-container charts-loader">
                          <div
                            class="spinner-border text-primary"
                            role="status"
                          ></div>
                        </div>
                      </ng-container>
                    </div>
                    <ng-template #outerRpmGaugeId>
                      <div class="img_outer">
                        <div *ngFor="let meterdataouter of outer_rpmshowgaudge">
                          <div
                            [ngClass]="{
                              'pinion-1x': rpmValueClass === '1x',
                              'pinion-10x': rpmValueClass === '10x'
                            }"
                          ></div>
                          <rg-gauge-chart
                            [ngClass]="{
                              big_font_chartbox:
                                meterdataouter.hasneedle == false
                            }"
                            [canvasWidth]="canvasWidth"
                            [needleValue]="meterdataouter.needleValue"
                            [centralLabel]="centralLabel"
                            [options]="meterdataouter.options"
                            [name]="meterdataouter.name"
                            [bottomLabel]="meterdataouter.bottomLabel"
                          >
                          </rg-gauge-chart>
                        </div>
                        <div class="bottom_label">
                          <span
                            *ngIf="
                              outer_gear_actual_rpm != -1;
                              else nextOutGear
                            "
                            >{{ outer_gear_actual_rpm + " RPM" }}</span
                          >
                          <ng-template #nextOutGear>
                            <span>N/A</span>
                          </ng-template>
                        </div>
                      </div>
                    </ng-template>
                  </div>
                </div> -->
                <div
                  class="chartBoxWrap ch_box temp machineOperating"
                  *ngIf="assetType === 'GEAR'"
                >
                  <div class="heading">Machine Operating Parameters</div>
                  <div class="row">
                    <div class="col-sm-9 settxt">
                      Machine Type:<span> {{ assetType }}</span>
                    </div>
                    <div class="col-sm-3 settxt">Rated</div>
                  </div>
                  <div class="row">
                    <div class="col-sm-9 settxt">Rated Power (KW)</div>
                    <div class="col-sm settxt rateValue">
                      <div *ngIf="machineOperatngParametersLoader" class="skeleton skeleton-machine-operating-text"></div>
                      <span *ngIf="!machineOperatngParametersLoader">
                        {{ monitoring_gear_rated_power || "N/A" }}
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-9 settxt">Number of Stages</div>
                    <div class="col-sm settxt rateValue">
                      <div *ngIf="machineOperatngParametersLoader" class="skeleton skeleton-machine-operating-text"></div>
                      <span *ngIf="!machineOperatngParametersLoader">
                        {{ monitoring_number_of_stages }}
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-9 settxt">Pinion Gear RPM</div>
                    <div class="col-sm settxt rateValue">
                      <div *ngIf="machineOperatngParametersLoader" class="skeleton skeleton-machine-operating-text"></div>
                      <span *ngIf="!machineOperatngParametersLoader">
                        {{ monitoring_pinion_gear_rpm }}
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-9 settxt">Output Gear RPM</div>
                    <div class="col-sm settxt rateValue">
                      <div *ngIf="machineOperatngParametersLoader" class="skeleton skeleton-machine-operating-text"></div>
                      <span *ngIf="!machineOperatngParametersLoader">
                        {{ monitoring_output_gear_rpm }}
                      </span>
                    </div>
                  </div>
                </div>


                <div
                  class="chartBoxWrap ch_box temp machineOperating"
                  *ngIf="
                    assetType === 'MOTOR' ||
                    assetType === 'FAN_BLOWER' ||
                    assetType === 'PUMP' ||
                    assetType === 'COMPRESSOR' ||
                    assetType === 'JOURNAL_BEARING'
                  "
                >
                  <div class="heading">Machine Operating Parameters</div>
                  <div class="row">
                    <div
                      *ngIf="assetType !== 'MOTOR'; else forDCMOTOR"
                      class="col-sm-9 settxt"
                    >
                      Machine Type:<span> {{ assetType }}</span>
                    </div>
                    <ng-template #forDCMOTOR>
                      <div class="col-sm-9 settxt">
                        Machine Type:<span>
                          {{
                            replaceUnderscoresWithSpacesAndCapitalize(sub_type)
                          }}</span
                        >
                      </div>
                    </ng-template>
                    <div class="col-sm-3 settxt">Calculated</div>
                  </div>
                  <div class="row" *ngIf="assetType != 'JOURNAL_BEARING'">
                    <div class="col-sm-9 settxt">Line Frequency (+/- 3%)</div>
                    <!-- <div class="col-sm-3 settxt rateValue">
                      {{ nLineFrequency || "N/A" }}
                    </div> -->
                    <div class="col-sm settxt rateValue">
                      <!-- <span *ngIf="sub_type != 'DC_MOTOR'; else forlinefreq">{{
                        nOpertingLineFrequency || "N/A"
                      }}</span> -->
                      <div *ngIf="machineOperatngParametersLoader" class="skeleton skeleton-machine-operating-text"></div>
                      <span *ngIf="!machineOperatngParametersLoader && sub_type != 'DC_MOTOR'">
                        {{ monitoring_operatingLF || "N/A" }}
                      </span>
                    </div>
                  </div>
                  <div class="row" *ngIf="sub_type != 'SYNCHRONOUS_MOTOR'">
                    <div
                      *ngIf="
                        sub_type != 'DC_MOTOR' &&
                          assetType != 'JOURNAL_BEARING';
                        else forsync
                      "
                      class="col-sm-9 settxt"
                    >
                      Synchronous RPM
                    </div>
                    <ng-template #forsync>
                      <div class="col-sm-9 settxt">Rated RPM</div>
                    </ng-template>
                    <!-- <div class="col-sm-3 settxt rateValue">
                      {{ syncRPM || "N/A" }}
                    </div> -->
                    <div class="col-sm settxt rateValue">
                      <!-- {{ operatingSyncRPM || "N/A" }} -->
                      <div *ngIf="machineOperatngParametersLoader" class="skeleton skeleton-machine-operating-text"></div>
                      <span *ngIf="!machineOperatngParametersLoader">{{ monitoring_operatingSyncRPM || "N/A" }}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-9 settxt">
                      Operating RPM (+/- 3%)<span
                        matTooltip="Not a Measured parameter.
                                    Estimated Values For fixed Speed Machines Only.
                                     "
                        style="color: orange"
                        [matTooltipClass]="'tooltip'"
                        >*</span
                      >
                    </div>
                    <!-- <div class="col-sm-3 settxt rateValue">
                      {{ ratedRPM || "N/A" }}
                    </div> -->
                    <div
                      class="col-sm settxt rateValue"
                      *ngIf="sub_type == 'SYNCHRONOUS_MOTOR'; else sync2"
                    >
                      <!-- {{ opr_rpm || "N/A" }} -->
                      <div *ngIf="machineOperatngParametersLoader" class="skeleton skeleton-machine-operating-text"></div>
                      <span *ngIf="!machineOperatngParametersLoader">
                        {{ monitoring_actual_rpm || "N/A" }}
                      </span>
                    </div>
                  </div>
                  <ng-template #sync2>
                    <div class="col-sm settxt rateValue">
                      <!-- {{ actualRPM || "N/A" }} -->
                      <div *ngIf="machineOperatngParametersLoader" class="skeleton skeleton-machine-operating-text"></div>
                      <span *ngIf="!machineOperatngParametersLoader">
                        {{ monitoring_actual_rpm || "N/A" }}
                      </span>
                    </div>
                  </ng-template>

                  <div class="row">
                    <div class="col-sm-9 settxt">Line Current (A)</div>
                    <!-- <div class="col-sm-3 settxt rateValue">
                      {{ ratedLineCurrent || "N/A" }}
                    </div> -->
                    <!-- <div class="col-sm settxt rateValue">
                      {{ operatingLineCurrent || "N/A" }}
                    </div> -->
                    <div class="col-sm settxt rateValue">
                      <div *ngIf="machineOperatngParametersLoader" class="skeleton skeleton-machine-operating-text"></div>
                      <span *ngIf="!machineOperatngParametersLoader">
                        {{ monitoring_operating_ph_line_current || "N/A" }}
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-9 settxt">
                      Est. Output Power
                      <span
                        matTooltip="Estimated Value for fixed speed.
                                    Induction Motor Only Considering Constant V/F Ratio.
                                    "
                        style="color: orange"
                        [matTooltipClass]="'tooltip'"
                        >*</span
                      >
                    </div>
                    <div class="col-sm-3 settxt rateValue outputPower">
                      <div *ngIf="machineOperatngParametersLoader" class="skeleton skeleton-machine-operating-text"></div>
                      <span *ngIf="!machineOperatngParametersLoader">N/A</span>
                    </div>
                  </div>
                </div>

                <div class="chartBoxWrap ch_box orien">
                  <div class="settingArea">
                    <div class="heading settingBtn">
                      Machine Alert Summary (24 Hours)
                    </div>
                    <!-- <Button
                      *ngIf="this.role == 'CLIENT'"
                      type="button"
                      (click)="UpdateMAchinealertSettingsforasset()"
                      >Settings</Button
                    > -->
                  </div>
                  <div class="progress_data">
                    <div class="table-responsive" style="max-height: 150px">
                      <table class="table table-hover alertSummary">
                        <thead>
                          <tr>
                            <th>Alert Type</th>
                            <th>Alert Details</th>
                            <th>Alert Category</th>
                            <th style="text-align: right">TimeStamp</th>
                            <th style="text-align: right">Acknowledged By</th>
                            <th style="text-align: right">Acknowledged At</th>
                          </tr>
                        </thead>
                        <tbody *ngIf="noalertmessage == ''; else elseBlock">
                          <tr *ngFor="let report of errordata">
                            <td>
                              <span class="circleSpan"></span>
                            </td>
                            <td>
                              <span
                                style="cursor: pointer"
                                (click)="OnClickAlert(report)"
                                >{{ report.error | titlecase }}
                              </span>
                            </td>
                            <td>
                              <span *ngIf="report.category != null;else elsecategory">{{report.category}}</span>
                              <ng-template #elsecategory>
                                <span>Asset Health</span>
                              </ng-template>
                            </td>
                            <td class="text-right">
                              <span
                                style="cursor: pointer"
                                (click)="
                                  taketopredominantalert(
                                    $event,
                                    report.device_raw_matric_id
                                  )
                                "
                                >{{ report.time }}
                              </span>
                            </td>
                            <td>
                              <span>{{
                                report.full_name
                                  ? report.full_name
                                  : "Take Action"
                              }}</span>
                            </td>
                            <td>
                              <span *ngIf="report.ack_time; else noAckTime">
                                {{ report.ack_time }}
                              </span>
                              <ng-template #noAckTime>
                                <span>
                                  <img
                                    src="./assets/img-new/time.png"
                                    alt="time"
                                    style="width: 30px; height: 30px"
                                  />
                                </span>
                              </ng-template>
                            </td>
                          </tr>
                        </tbody>
                        <tbody>
                          <ng-template #elseBlock>
                            <tr>
                              <td colspan="5" class="errorDisplay">
                                {{ noalertmessage }}
                              </td>
                            </tr>
                          </ng-template>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div class="new_header">
                <div class="title">
                  Machine Summary <span>(Last 24 Hours)</span>
                </div>
              </div>
              <div class="summary_boxes_outer">
                <div class="summaryBox summary_box_first">
                  <div class="container">
                    <div class="heading">Operational</div>
                    <div class="row">
                      <div class="col-sm-5 settxt"></div>
                      <div class="col-sm settxt">
                        <div>Connectivity</div>
                      </div>
                      <div class="col-sm settxt">
                        <div>
                          Asset
                          <span
                            matTooltip="{{ getMoreInformation() }}"
                            style="color: orange"
                            [matTooltipClass]="'tooltip'"
                            >*</span
                          >
                        </div>
                      </div>
                    </div>
                    <!-- <div class="row">
                      <div class="col-sm-5 settxt">Number of Starts</div>
                      <div class="col-sm settxt rateValue">
                        {{ deviceStarts }}
                      </div>
                      <div class="col-sm settxt rateValue">
                        {{ assetStarts }}
                      </div>
                    </div> -->
                    <div class="row">
                      <div class="col-sm-5 settxt">Number of Lost/Stops</div>
                      <div class="col-sm settxt rateValue">
                        <div *ngIf="monitoringMachineUtlizationLoader" class="skeleton skeleton-operational-text"></div>
                      <span *ngIf="!monitoringMachineUtlizationLoader">
                        {{ monitoringDeviceStops }}
                      </span>
                        <!-- {{ deviceStops }} -->
                      </div>
                      <div class="col-sm settxt rateValue">
                        <div *ngIf="monitoringMachineUtlizationLoader" class="skeleton skeleton-operational-text"></div>
                      <span *ngIf="!monitoringMachineUtlizationLoader">
                        {{ monitoringAssetStops }}
                      </span>
                        <!-- {{ assetStops }} -->
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-5 settxt">Machine Utilization</div>
                      <div class="col-sm settxt rateValue">
                        <div *ngIf="monitoringMachineUtlizationLoader" class="skeleton skeleton-operational-text"></div>
                      <span *ngIf="!monitoringMachineUtlizationLoader">
                        {{ monitoringDeviceUtilization }}%
                      </span>
                        <!-- {{ deviceUtilization }}% -->
                      </div>
                      <div class="col-sm settxt rateValue">
                        <div *ngIf="monitoringMachineUtlizationLoader" class="skeleton skeleton-operational-text"></div>
                      <span *ngIf="!monitoringMachineUtlizationLoader">
                        {{ monitoringAssetUtilization }}%
                      </span>
                        <!-- {{ assetUtilization }}% -->
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-5 settxt">Average Run Time</div>
                      <div class="col-sm settxt rateValue">
                        <div *ngIf="monitoringMachineUtlizationLoader" class="skeleton skeleton-operational-text"></div>
                      <span *ngIf="!monitoringMachineUtlizationLoader">
                        {{ monitoringDeviceAverageRun }}
                      </span>
                        <!-- {{ deviceAverageRunTime }} -->
                      </div>
                      <div class="col-sm settxt rateValue">
                        <div *ngIf="monitoringMachineUtlizationLoader" class="skeleton skeleton-operational-text"></div>
                      <span *ngIf="!monitoringMachineUtlizationLoader">
                        {{ monitoringAssetAverageRun }}
                      </span>
                        <!-- {{ assetAverageRunTime }} -->
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-5 settxt">Weekly Run Time</div>
                      <div class="col-sm settxt rateValue">
                        <div *ngIf="monitoringMachineUtlizationLoader" class="skeleton skeleton-operational-text"></div>
                      <span *ngIf="!monitoringMachineUtlizationLoader">
                        {{ monitoringDeviceWeeklyRunningStatus }}
                      </span>
                        <!-- {{ deviceAverageRunTime }} -->
                      </div>
                    </div>
                  </div>
                </div>
                @if (master_product_type && master_product_type!=1) {
                <div class="summaryBox summary_box over_health">
                  <div class="heading">Anomaly Status</div>

                  <!-- Updated at -->
                  <div class="detail">
                    <div class="left">Updated at</div>
                    <div class="right" *ngIf="!anomalyLoader; else updatedLoading">
                      {{ overAllService || "N/A" }}
                    </div>
                    <ng-template #updatedLoading>
                      <div class="skeleton skeleton-service-text-anomaly-status"></div>
                    </ng-template>
                  </div>

                  <!-- Status -->
                  <div class="detail">
                    <div class="left">Status</div>
                    <div class="right" *ngIf="!anomalyLoader; else statusLoading">
                      <span
                        [ngClass]="{
                          'label_green': overall_health_status === 'Good',
                          'label_red': overall_health_status === 'Unacceptable',
                          'label_yellow': overall_health_status === 'Unsatisfactory',
                          'label_white': overall_health_status === 'N/A'
                        }"
                      >
                        {{ overall_health_status }}
                      </span>
                    </div>
                    <ng-template #statusLoading>
                      <div class="skeleton skeleton-service-text-status"></div>
                    </ng-template>
                  </div>

                  <!-- Recommended Action -->
                  <div class="detail">
                    <div class="left">Recommended Action</div>
                    <div class="right" *ngIf="!anomalyLoader; else actionLoading">
                      {{ recommened_action || "N/A" }}
                    </div>
                    <ng-template #actionLoading>
                      <div class="skeleton skeleton-service-text-recommended-action"></div>
                    </ng-template>
                  </div>

                  <!-- Asset Report -->
                  <div *ngIf="role != 'OEM'" class="detail">
                    <div class="left">Asset Report</div>
                    <div class="right">
                      <button
                        *ngIf="anomalyLoader; else reportButton"
                        class="skeleton skeleton-button"
                      ></button>
                      <ng-template #reportButton>
                        <button
                          [disabled]="onoffStatus === 2 || downloadDisabled"
                          *ngIf="
                            (hideDownloadBtn && onoffStatus === 2) ||
                            downloadDisabled
                          "
                          mat-raised-button
                          color="primary"
                          (click)="getDeviceReport()"
                        >
                          <span matTooltip="{{ msgDownload }}">Generate Report</span>
                        </button>
                        <button
                          [disabled]="onoffStatus === 2 || downloadDisabled"
                          *ngIf="
                            hideDownloadBtn &&
                            !downloadDisabled &&
                            (onoffStatus === 0 || onoffStatus === 1)
                          "
                          (click)="getDeviceReport()"
                          mat-raised-button
                          color="primary"
                          ><span>Generate Report</span>
                        </button>
                        <Button
                        *ngIf="hideDownloadBtn === false"
                        [disabled]=true
                        style="background-color: #80868b"
                          ><span>Generating Report</span>
                        </Button>
                        <!-- <span
                          *ngIf="hideDownloadBtn === false"
                          style="color: green"
                        >
                          {{ showReportMsg }}
                        </span> -->
                      </ng-template>
                    </div>
                  </div>
                </div>
                }



                <!-- <div class="summaryBox summary_box indices">
                  <div
                    class="heading d-flex justify-content-between"
                    style="
                      margin-bottom: 0px !important;
                      padding: 0px 0px !important;
                    "
                  >
                    Machine Health Index
                    <Button type="button" (click)="UpdateHealthIndices()"
                      >Update</Button
                    >
                  </div>
                  <div
                    class="detail"
                    style="align-items: center; justify-content: center"
                    *ngIf="machineHealthLoader; else machineHealthId"
                  >
                    <ng-container>
                      <div class="spinner-container charts-loader">
                        <div
                          class="spinner-border text-primary"
                          role="status"
                        ></div>
                      </div>
                    </ng-container>
                  </div>
                  <ng-template #machineHealthId>
                    <div class="detail" *ngFor="let indices of indicesValues">
                      <div class="left">{{ indices.label }}</div>
                      <div class="right">{{ indices.value }}</div>
                      <div class="right">
                        <span
                          [ngStyle]="{ 'background-color': indices.color=='#009e27'?'#72ff13': indices.color}"
                          class="round_indicators"
                          matTooltip="{{ getIndicesCondition() }}"
                          [matTooltipClass]="'tooltip'"
                        ></span>
                      </div>
                    </div>
                  </ng-template>

                  <div class="detail" #machineHealthId>
                    <div class="left"><span>Overall Health Index</span></div>
                    <div class="right">{{ overallhealthindiexnumber }}</div>
                    <div class="right healthIndex">
                      <span
                        *ngIf="spanred"
                        [ngStyle]="{ 'background-color': '#f44336' }"
                        class="round_indicators"
                        matTooltipClass="cutline"
                        matTooltip="{{ getIndicesCondition() }}"
                        [matTooltipClass]="'tooltip'"
                      ></span>
                      <span
                        *ngIf="spanwhite"
                        [ngStyle]="{ 'background-color': '00FFFFFF' }"
                        class="round_indicators"
                        matTooltipClass="cutline"
                        matTooltip="{{ getIndicesCondition() }}"
                        [matTooltipClass]="'tooltip'"
                      ></span>
                      <span
                        *ngIf="spanyellow"
                        [ngStyle]="{ 'background-color': '#ffcc00' }"
                        class="round_indicators"
                        matTooltipClass="cutline"
                        matTooltip="{{ getIndicesCondition() }}"
                        [matTooltipClass]="'tooltip'"
                      ></span>

                      <span
                        *ngIf="spangreen"
                        [ngStyle]="{ 'background-color': '#72ff13' }"
                        class="round_indicators"
                        matTooltip="{{ getIndicesCondition() }}"
                        matTooltipClass="cutline"
                        [matTooltipClass]="'tooltip'"
                      ></span>
                    </div>
                  </div>
                </div> -->

                <div class="summaryBox summary_box indices">
                  <div
                    class="heading d-flex justify-content-between"
                    style="margin-bottom: 0px !important; padding: 0px 0px !important;"
                  >
                    Machine Health Index
                    <!-- <button mat-raised-button color="accent" type="button" (click)="UpdateHealthIndices()">Update</button> -->
                    <button mat-raised-button color="primary" (click)="UpdateHealthIndices()">
                      <span>Update</span>
                    </button>
                  </div>

                  <!-- Loader -->
                  <div *ngIf="monitoringIndicesLoader; else machineHealthId">
                    <div *ngFor="let key of monitoringIndicesKeys" class="detail">
                      <div class="left">{{ key }}</div>
                      <div class="right">
                        <div class="skeleton skeleton-machine-health-index-text"></div>
                      </div>
                      <div class="right">
                        <div class="skeleton skeleton-machine-health-index-circle"></div>
                      </div>
                    </div>
                    <div class="detail">
                      <div class="left"><span>Overall Health Index</span></div>
                      <div class="right">
                        <div class="skeleton skeleton-machine-health-index-text"></div>
                      </div>
                      <div class="right healthIndex">
                        <div class="skeleton skeleton-machine-health-index-circle"></div>
                      </div>
                    </div>
                  </div>

                  <!-- Data Loaded -->
                  <ng-template #machineHealthId>
                    <div class="detail" *ngFor="let indices of monitoringIndicesValues">
                      <div class="left">{{ indices.label }}</div>
                      <div class="right">{{ indices.value }}</div>
                      <div class="right">
                        <span
                          [ngStyle]="{ 'background-color': indices.color=='#009e27'?'#72ff13': indices.color }"
                          class="round_indicators"
                          matTooltip="{{ getIndicesCondition() }}"
                          [matTooltipClass]="'tooltip'"
                        ></span>
                      </div>
                    </div>
                    <div class="detail">
                      <div class="left"><span>Overall Health Index</span></div>
                      <div class="right">{{ monitoringOverallHealthIndex }}</div>
                      <div class="right healthIndex">
                        <span
                          class="round_indicators"
                          [ngStyle]="{ 'background-color': monitoringOverallHealthIndexColor }"
                          matTooltip="{{ getIndicesCondition() }}"
                          [matTooltipClass]="'tooltip'"
                        ></span>
                      </div>
                    </div>
                  </ng-template>
                </div>



                <div class="summaryBox summary_box service">
                  <div
                    class="heading d-flex justify-content-between"
                    style="margin-bottom: 0px !important; padding: 0px 0px !important;"
                  >
                    Service Status
                    <button
                      type="button"
                      mat-raised-button color="primary"
                      [ngClass]="{ 'disabled-btn': isOutOfService, 'updateStatus': !isOutOfService }"
                      [disabled]="isOutOfService"
                      (click)="serviceBookOpen()"
                    >
                      Update
                    </button>
                  </div>

                  <!-- Loader -->
                  <div *ngIf="serviceLoader; else serviceId">
                    <div class="detail">
                      <div class="left">{{ isOutOfService ? "Asset out for service" : "Asset in service" }}</div>
                      <div class="right">
                        <div class="skeleton skeleton-service-text"></div>
                      </div>
                    </div>
                    <div class="detail">
                      <div class="left">Service Type</div>
                      <div class="right">
                        <div class="skeleton skeleton-service-text-l"></div>
                      </div>
                    </div>
                    <div class="detail">
                      <div class="left">Last Service Date</div>
                      <div class="right">
                        <div class="skeleton skeleton-service-text-s"></div>
                      </div>
                    </div>
                    <div class="detail">
                      <div class="left">Service Performed</div>
                      <div class="right">
                        <div class="skeleton skeleton-service-text-l"></div>
                      </div>
                    </div>
                    <div class="detail">
                      <div class="left">Next Service Due</div>
                      <div class="right">
                        <div class="skeleton skeleton-service-text-s"></div>
                      </div>
                    </div>
                  </div>

                  <!-- Data Loaded -->
                  <ng-template #serviceId>
                    <div class="detail">
                      <div class="left">
                        {{ isOutOfService ? "Asset out for service" : "Asset in service" }}
                      </div>
                      <div class="right rateValue">
                        <div *ngIf="userRoll !== 'USER'" class="toggle-container">
                          <input
                            type="checkbox"
                            id="toggle"
                            class="toggle-checkbox"
                            (change)="onOutOfServiceChange($event)"
                            [checked]="isOutOfService"
                          />
                          <label for="toggle" class="toggle-label"></label>
                        </div>
                      </div>
                    </div>
                    <div class="detail">
                      <div class="left">Service Type</div>
                      <div class="right rateValue">{{ serviceCategory || "N/A" }}</div>
                    </div>
                    <div class="detail">
                      <div class="left">Last Service Date</div>
                      <div class="right rateValue">{{ lastServiceDate || "N/A" }}</div>
                    </div>
                    <div class="detail">
                      <div class="left">Service Performed</div>
                      <div class="right rateValue">
                        <span class="read_more">{{ servicePerformed || "N/A" }}</span>
                        <span
                          *ngIf="sperformedArr.length > 0"
                          class="dropdown-toggle read_more_toggle"
                          [matMenuTriggerFor]="menu"
                        >
                          +{{ sperformedArr.length }}
                        </span>
                        <mat-menu #menu="matMenu">
                          <ul class="read_more_ul">
                            <li *ngFor="let sperFor of sperformedArr">{{ sperFor }}</li>
                          </ul>
                        </mat-menu>
                      </div>
                    </div>
                    <div class="detail">
                      <div class="left">Next Service Due</div>
                      <div class="right">{{ nextServiceDate || "N/A" }}</div>
                    </div>
                  </ng-template>
                </div>

              </div>
              <div class="detail trendBtn">
                <button mat-raised-button color="primary" type="button" (click)="Showtrendsgraph()">{{
                  trendsgraph
                }}</button>
              </div>

              <div *ngIf="TrendzchartOn">
                <div *ngIf="averageTableOff" class="btn-group tab_btn_group tab_btn_date_grp" style="margin-bottom: 12px;">
                  <div>
                    <!-- Hourly -->
                    <button
                      *ngIf="accColor1 === 'active'"
                      type="button"
                      mat-raised-button
                      color="primary">
                      Hourly
                    </button>
                    <button
                      *ngIf="accColor1 !== 'active'"
                      type="button"
                      mat-stroked-button
                      color="primary"
                      (click)="selectFilter('Hourly')">
                      Hourly
                    </button>

                    <!-- Daily -->
                    <button
                      *ngIf="accColor2 === 'active'"
                      type="button"
                      mat-raised-button
                      color="primary">
                      Daily
                    </button>
                    <button
                      *ngIf="accColor2 !== 'active'"
                      type="button"
                      mat-stroked-button
                      color="primary"
                      (click)="selectFilter('Daily')">
                      Daily
                    </button>

                    <!-- Weekly -->
                    <button
                      *ngIf="accColor3 === 'active'"
                      type="button"
                      mat-raised-button
                      color="primary">
                      Weekly
                    </button>
                    <button
                      *ngIf="accColor3 !== 'active'"
                      type="button"
                      mat-stroked-button
                      color="primary"
                      (click)="selectFilter('Weekly')">
                      Weekly
                    </button>
                  </div>

                  <div class="date-picker2">
                    <mat-form-field appearance="outline">
                      <mat-label>Start Date</mat-label>
                      <input matInput [matDatepicker]="startPicker" (dateChange)="onStartDateChange($event.value)">
                      <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                      <mat-datepicker #startPicker></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>End Date</mat-label>
                      <input matInput [matDatepicker]="endPicker" (dateChange)="onEndDateChange($event.value)">
                      <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                      <mat-datepicker #endPicker></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>


                <div class="new_header header_absolute">
                  <div class="absolute_inner">
                    <div class="title" *ngIf="listLayoutOn">
                      Sensor Data Table
                    </div>
                    <div class="title" *ngIf="chartLayoutOn">
                      Vibration - Acceleration Trend<span>
                        (m/sec<sup>2</sup>)</span
                      >
                      <!-- <div class="xScale_button_container">
                        <button class="active2" (click)="downloadChart('chartContainer')">
                          Download Chart Image
                        </button>
                      </div> -->
                      <div>
                        <button mat-raised-button color="primary" (click)="downloadChart('chartContainer')">Download Chart Image</button>
                      </div>
                    </div>
                    <div class="tools">
                      <div class="btn-group tab_btn_group">
                        <button
                          type="button"
                          class="btn"
                          (click)="gridLayout()"
                        >
                          <span
                            class="sprite_icon wave_grey"
                            [ngClass]="{ wave_blue: chartLayoutOn }"
                          ></span>
                        </button>
                        <button
                          type="button"
                          class="btn"
                          (click)="listLayout()"
                        >
                          <span
                            class="sprite_icon list_grey"
                            [ngClass]="{ list_blue: listLayoutOn }"
                          ></span>
                        </button>
                        <button
                          type="button"
                          class="btn"
                          (click)="downloadChartData1()"
                        >
                          <span
                            class="sprite_icon download_grey"
                            [ngClass]="{ download_blue: downloadChartDataOn }"
                          ></span>
                        </button>
                      </div>
                    </div>
                    <div
                      *ngIf="averageTableOff"
                      class="avgTable"
                      style="
                        display: inline-block;
                        float: right;
                        text-align: right;
                      "
                    >
                      <!-- <h5 class="fft_heading"> Moving Average Value</h5> -->
                      <div class="table-responsive">
                        <table class="moving_avg">
                          <thead>
                            <tr>
                              <th></th>
                              <th>Axial</th>
                              <th>Tangential</th>
                              <th>Radial</th>
                            </tr>
                          </thead>
                          <tbody *ngIf="!visibilityVAT; else elseBlock">
                            <tr>
                              <th style="text-align: left">1 Day Avg.</th>
                              <td>{{ xaavg }}</td>
                              <td>{{ yaavg }}</td>
                              <td>{{ zaavg }}</td>
                            </tr>
                            <tr>
                              <th style="text-align: left">7 Days Avg.</th>
                              <td>{{ xaavg_day }}</td>
                              <td>{{ yaavg_day }}</td>
                              <td>{{ zaavg_day }}</td>
                            </tr>
                            <tr>
                              <th style="text-align: left">30 Days Avg.</th>
                              <td>{{ xaavg_week }}</td>
                              <td>{{ yaavg_week }}</td>
                              <td>{{ zaavg_week }}</td>
                            </tr>
                          </tbody>
                          <tbody>
                            <ng-template #elseBlock>
                              <tr>
                                <td colspan="4" class="errorDisplay">
                                  No data available for last 24 Hour!
                                </td>
                              </tr>
                            </ng-template>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- <div class="line_chart_outer" *ngIf="chartLayoutOn">
                    <div id="chartContainer" style="height: 370px;width: 100%;margin-left: auto;margin-right: auto;">

                      <div *ngIf="AccelartionLoading; else AccelartionDiv"><img  class="chart_load" src="./assets/chart_loader.gif" id="loader" /></div>
                      <ng-template #AccelartionDiv>
                          <p *ngIf="visibilityVAT" class="no_avl_data_msg">
                              No data available for last 24 hour
                          </p>
                      </ng-template>

                  </div>
                </div> -->

                <div class="line_chart_outer" *ngIf="chartLayoutOn">

                  <div *ngIf="AccelartionLoading; else AccelartionDiv"><img  class="chart_load" src="./assets/chart_loader.gif" id="loader" /></div>

                  <ng-template #AccelartionDiv>
                    <p *ngIf="visibilityVAT" class="no_avl_data_msg">
                      No data available for last 24 hour
                  </p>
                  </ng-template>

                  <div id="chartContainer" style="width: 100%;margin-left: auto;margin-right: auto;"></div>

                </div>


                <div *ngIf="averageTableOff" class="btn-group tab_btn_group">
                  <!-- <button
                    type="button"
                    [ngClass]="velColor1"
                    [disabled]="velColor1 == 'active'"
                    class="btn"
                    (click)="selectItemFilterForvelocity('Hourly')"
                  >
                    Hourly
                  </button>
                  <button
                    type="button"
                    [ngClass]="velColor2"
                    [disabled]="velColor2 == 'active'"
                    class="btn"
                    (click)="selectItemFilterForvelocity('Daily')"
                  >
                    Daily
                  </button>

                  <button
                    type="button"
                    [ngClass]="velColor3"
                    [disabled]="velColor3 == 'active'"
                    class="btn"
                    (click)="selectItemFilterForvelocity('Weekly')"
                  >
                    Weekly
                  </button> -->
                </div>

                <div class="new_header header_absolute">
                  <div class="absolute_inner">
                    <div class="title" *ngIf="chartLayoutOn">
                      Vibration - Velocity Trend<span> (mm/sec)</span>
                      <!-- <div class="xScale_button_container">
                        <button class="active2" (click)="downloadChart('monitoringVelocityChartContainer')">Download Chart Image</button>
                      </div> -->
                      <div>
                        <button mat-raised-button color="primary" (click)="downloadChart('monitoringVelocityChartContainer')">Download Chart Image</button>
                      </div>
                    </div>
                    <div
                      *ngIf="averageTableOff"
                      class="col-sm-3"
                      style="display: inline-block; float: right"
                    >
                      <!-- <h5 class="fft_heading"> Moving Average Value</h5> -->
                      <div class="table-responsive">
                        <table class="moving_avg">
                          <thead>
                            <tr>
                              <th></th>
                              <th>Axial</th>
                              <th>Tangential</th>
                              <th>Radial</th>
                            </tr>
                          </thead>
                          <tbody *ngIf="!visibilityMVChart; else elseBlock">
                            <tr>
                              <th style="text-align: left">1 Day Avg.</th>
                              <td>{{ xvavg }}</td>
                              <td>{{ yvavg }}</td>
                              <td>{{ zvavg }}</td>
                            </tr>
                            <tr>
                              <th style="text-align: left">7 Days Avg.</th>
                              <td>{{ xvavg_day }}</td>
                              <td>{{ yvavg_day }}</td>
                              <td>{{ zvavg_day }}</td>
                            </tr>
                            <tr>
                              <th style="text-align: left">30 Days Avg.</th>
                              <td>{{ xvavg_week }}</td>
                              <td>{{ yvavg_week }}</td>
                              <td>{{ zvavg_week }}</td>
                            </tr>
                          </tbody>
                          <tbody>
                            <ng-template #elseBlock>
                              <tr>
                                <td colspan="4" class="errorDisplay">
                                  No data available for last 24 Hour!
                                </td>
                              </tr>
                            </ng-template>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="line_chart_outer" *ngIf="chartLayoutOn">

                  <div *ngIf="VelocityLoading; else VelocityDiv"><img  class="chart_load" src="./assets/chart_loader.gif" id="loader" /></div>
                  <ng-template #VelocityDiv>
                    <p class="no_avl_data_msg" *ngIf="visibilityMVChart">
                      No data available for last 24 hour
                    </p>
                  </ng-template>
                  <div id="monitoringVelocityChartContainer" style="width: 100%;margin-left: auto;margin-right: auto;"></div>
                </div>

                <div *ngIf="averageTableOff" class="btn-group tab_btn_group">
                  <!-- <button
                    type="button"
                    [ngClass]="acoColor1"
                    [disabled]="acoColor1 == 'active'"
                    class="btn"
                    (click)="selectFilterAcoustics('Hourly')"
                  >
                    Hourly
                  </button>
                  <button
                    type="button"
                    [ngClass]="acoColor2"
                    [disabled]="acoColor2 == 'active'"
                    class="btn"
                    (click)="selectFilterAcoustics('Daily')"
                  >
                    Daily
                  </button>

                  <button
                    type="button"
                    [ngClass]="acoColor3"
                    [disabled]="acoColor3 == 'active'"
                    class="btn"
                    (click)="selectFilterAcoustics('Weekly')"
                  >
                    Weekly
                  </button> -->
                </div>
                <!-- <div class="tableAvg">
                  <div class="table-container">
                    <table>
                      <tr>
                        <th></th>
                        <th>Delta Ultrasound</th>
                      </tr>
                      <tr>
                        <td>Hour</td>
                        <td>{{xmavg}}</td>
                      </tr>

                    </table>
                  </div>
                </div> -->
                <div class="new_header header_absolute" *ngIf="[2,3].includes(master_product_type)">
                  <div class="absolute_inner">
                    <div class="title" *ngIf="chartLayoutOn">
                      Machine Acoustics<span> (dB)</span>
                      <!-- <div class="xScale_button_container">
                        <button class="active2" (click)="downloadChart('monitoringMachineAcousticsChart')">Download Chart Image</button>
                      </div> -->
                      <div>
                        <button mat-raised-button color="primary" (click)="downloadChart('monitoringMachineAcousticsChart')">Download Chart Image</button>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="line_chart_outer" *ngIf="chartLayoutOn && [2,3].includes(master_product_type)">

                    <div *ngIf="AcousticsLoading; else AcousticsDiv"><img  class="chart_load" src="./assets/chart_loader.gif" id="loader" /></div>
                    <ng-template #AcousticsDiv>
                      <p class="no_avl_data_msg" *ngIf="visibilityAcousticsChart">
                        No data available for last 24 hour
                      </p>
                    </ng-template>

                    <div id="monitoringMachineAcousticsChart" style="width: 100%;margin-left: auto;margin-right: auto;"></div>
                </div>

                <div *ngIf="averageTableOff" class="btn-group tab_btn_group">
                  <!-- <button
                    type="button"
                    [ngClass]="audiColor1"
                    [disabled]="audiColor1 == 'active'"
                    class="btn"
                    (click)="selectFileterAudible('Hourly')"
                  >
                    Hourly
                  </button>
                  <button
                    type="button"
                    [ngClass]="audiColor2"
                    [disabled]="audiColor2 == 'active'"
                    class="btn"
                    (click)="selectFileterAudible('Daily')"
                  >
                    Daily
                  </button>

                  <button
                    type="button"
                    [ngClass]="audiColor3"
                    [disabled]="audiColor3 == 'active'"
                    class="btn"
                    (click)="selectFileterAudible('Weekly')"
                  >
                    Weekly
                  </button> -->
                </div>

                <div class="new_header header_absolute" *ngIf="[2,3].includes(master_product_type)">
                  <div class="absolute_inner">
                    <div class="title" *ngIf="chartLayoutOn">
                      Audible (dB-A)
                      <!-- <div class="xScale_button_container">
                        <button class="active2" (click)="downloadChart('audibleChartId')">Download Chart Image</button>
                      </div> -->
                      <div>
                        <button mat-raised-button color="primary" (click)="downloadChart('audibleChartId')">Download Chart Image</button>
                      </div>
                    </div>
                    <div
                      *ngIf="averageTableOff"
                      class="col-sm-3"
                      style="display: inline-block; float: right"
                    >
                      <!-- <h5 class="fft_heading"> Moving Average Value</h5> -->
                      <div class="table-responsive">
                        <table class="moving_avg">
                          <thead>
                            <tr>
                              <th></th>
                              <th>Audible</th>
                            </tr>
                          </thead>
                          <tbody *ngIf="!msgAudibleChart; else elseBlock">
                            <tr>
                              <th style="text-align: left">1 Day Avg.</th>
                              <td>{{ xauavg }}</td>
                            </tr>
                            <tr>
                              <th style="text-align: left">7 Days Avg.</th>
                              <td>{{ xauavg_day }}</td>
                            </tr>
                            <tr>
                              <th style="text-align: left">30 Days Avg.</th>
                              <td>{{ xauavg_week }}</td>
                            </tr>
                          </tbody>
                          <tbody>
                            <ng-template #elseBlock>
                              <tr>
                                <td colspan="4" class="errorDisplay">
                                  No data available for last 24 Hour!
                                </td>
                              </tr>
                            </ng-template>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="line_chart_outer" *ngIf="chartLayoutOn && [2,3].includes(this.master_product_type)" >

                    <div *ngIf="AudibleLoading; else AudibleDiv"><img  class="chart_load" src="./assets/chart_loader.gif" id="loader" /></div>
                    <ng-template #AudibleDiv>
                      <p class="no_avl_data_msg" *ngIf="msgAudibleChart">
                        No data available for last 24 hour
                      </p>
                    </ng-template>
                    <div id="audibleChartId" style="width: 100%;margin-left: auto;margin-right: auto;"></div>

                </div>
                <div *ngIf="averageTableOff" class="btn-group tab_btn_group">
                  <!-- <button
                    type="button"
                    [ngClass]="tempColor1"
                    [disabled]="tempColor1 == 'active'"
                    class="btn"
                    (click)="selectFileterTemperature('Hourly')"
                  >
                    Hourly
                  </button>
                  <button
                    type="button"
                    [ngClass]="tempColor2"
                    [disabled]="tempColor2 == 'active'"
                    class="btn"
                    (click)="selectFileterTemperature('Daily')"
                  >
                    Daily
                  </button>

                  <button
                    type="button"
                    [ngClass]="tempColor3"
                    [disabled]="tempColor3 == 'active'"
                    class="btn"
                    (click)="selectFileterTemperature('Weekly')"
                  >
                    Weekly
                  </button> -->
                </div>

                <div class="new_header header_absolute">
                  <div class="absolute_inner">
                    <div class="title" *ngIf="chartLayoutOn">
                      Temperature Trend<span>(°C)</span>
                      <!-- <div class="xScale_button_container">
                        <button class="active2" (click)="downloadChart('tempChartContainer')">Download Chart Image</button>
                      </div> -->
                      <div>
                        <button mat-raised-button color="primary" (click)="downloadChart('tempChartContainer')">Download Chart Image</button>
                      </div>
                    </div>
                    <div
                      *ngIf="averageTableOff"
                      class="col-sm-3"
                      style="display: inline-block; float: right"
                    >
                      <!-- <h5 class="fft_heading"> Moving Average Value</h5> -->
                      <div class="table-responsive">
                        <table class="moving_avg">
                          <thead>
                            <tr>
                              <th></th>
                              <th>Machine Skin</th>
                              <th>DE Bearing</th>
                              <th>NDE Bearing</th>
                            </tr>
                          </thead>
                          <tbody *ngIf="!showTempChartEmpty; else elseBlock">
                            <tr>
                              <th style="text-align: left">1 Day Avg.</th>
                              <td>{{ xtavg }}</td>
                              <td>{{ ytavg }}</td>
                              <td>{{ ztavg }}</td>
                            </tr>
                            <tr>
                              <th style="text-align: left">7 Days Avg.</th>
                              <td>{{ xtavg_day }}</td>
                              <td>{{ ytavg_day }}</td>
                              <td>{{ ztavg_day }}</td>
                            </tr>
                            <tr>
                              <th style="text-align: left">30 Days Avg.</th>
                              <td>{{ xtavg_week }}</td>
                              <td>{{ ytavg_week }}</td>
                              <td>{{ ztavg_week }}</td>
                            </tr>
                          </tbody>
                          <tbody>
                            <ng-template #elseBlock>
                              <tr>
                                <td colspan="4" class="errorDisplay">
                                  No data available for last 24 Hour!
                                </td>
                              </tr>
                            </ng-template>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="line_chart_outer same" *ngIf="chartLayoutOn">

                    <div *ngIf="TemperatureLoading; else TemperatureDiv"><img  class="chart_load" src="./assets/chart_loader.gif" id="loader" /></div>
                    <ng-template #TemperatureDiv>
                      <p class="no_avl_data_msg" *ngIf="showTempChartEmpty">
                        No data available for last 24 hour
                      </p>
                    </ng-template>
                    <div id="tempChartContainer" style="width: 100%;margin-left: auto;margin-right: auto;"></div>

                </div>
              </div>
              <div class="line_chart_outer tb" *ngIf="listLayoutOn">
                <div class="new_header">
                  <div class="title"></div>
                </div>
                <div class="table-responsive" *ngIf="[2,3].includes(master_product_type)">
                  <table class="table line_chart_tb monitor">
                    <thead>
                      <tr>
                        <th class="middle_align" rowspan="2">Time Stamp</th>
                        <th colspan="3" class="text-center">
                          Velocity (mm/sec)
                        </th>
                        <th colspan="3" class="text-center">
                          Acceleration (m/sec<sup>2</sup>)
                        </th>
                        <th colspan="3" class="text-center">
                          Temperature (°C)
                        </th>
                        <th colspan="3" class="text-center" *ngIf="[2,3].includes(master_product_type)">
                          Machine Acoustics (dB)
                        </th>
                      </tr>
                      <tr>
                        <td>Tangential</td>
                        <td>Axial</td>
                        <td>Radial</td>
                        <td>Tangential</td>
                        <td>Axial</td>
                        <td>Radial</td>
                        <td>DE Bearing</td>
                        <td>Machine Skin</td>
                        <td>NDE Bearing</td>
                        <td>dB</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <table class="table child_tb">
                            <tr *ngFor="let time of listSenData">
                              <td>{{ time.x }}</td>
                            </tr>
                          </table>
                        </td>
                        <td>
                          <table class="table child_tb">
                            <tr *ngFor="let datay1 of listSenVelocityData1">
                              <td>{{ datay1.y }}</td>
                            </tr>
                          </table>
                        </td>
                        <td>
                          <table class="table child_tb">
                            <tr *ngFor="let datay2 of listSenVelocityData2">
                              <td>{{ datay2.y }}</td>
                            </tr>
                          </table>
                        </td>
                        <td>
                          <table class="table child_tb">
                            <tr *ngFor="let datay3 of listSenVelocityData3">
                              <td>{{ datay3.y }}</td>
                            </tr>
                          </table>
                        </td>

                        <td>
                          <table class="table child_tb">
                            <tr *ngFor="let datay1 of listSenData">
                              <td>{{ datay1.y }}</td>
                            </tr>
                          </table>
                        </td>
                        <td>
                          <table class="table child_tb">
                            <tr *ngFor="let datay2 of listSenData2">
                              <td>{{ datay2.y }}</td>
                            </tr>
                          </table>
                        </td>
                        <td>
                          <table class="table child_tb">
                            <tr *ngFor="let datay3 of listSenData3">
                              <td>{{ datay3.y }}</td>
                            </tr>
                          </table>
                        </td>
                        <td>
                          <table class="table child_tb">
                            <tr *ngFor="let datay1 of listTempData1">
                              <td>{{ datay1.y }}</td>
                            </tr>
                          </table>
                        </td>
                        <td>
                          <table class="table child_tb">
                            <tr *ngFor="let datay2 of listTempData2">
                              <td>{{ datay2.y }}</td>
                            </tr>
                          </table>
                        </td>
                        <td>
                          <table class="table child_tb">
                            <tr *ngFor="let datay3 of listTempData3">
                              <td>{{ datay3.y }}</td>
                            </tr>
                          </table>
                        </td>
                        <td style="border-left: 1px solid #e8e8e8 !important">
                          <table class="table child_tb">
                            <tr *ngFor="let datay3 of listAcousticsData3">
                              <td>{{ datay3.y }}</td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </ng-template>
        </li>

        <li
          [ngbNavItem]="'tab-2'"
          id="tab-2"
          [matTooltip]="
            !softwareStatusMap['diagnostics'] ? 'Diagnostics service is not subscribed' :
            null
          "
          [ngClass]="{ 'opacity-50': !softwareStatusMap['diagnostics'] }"
        >
          <a
            ngbNavLink
            (click)="!softwareStatusMap['diagnostics']
              ? (role === 'USER'
                  ? $event.stopImmediatePropagation()
                  : checkSubscriptionController($event, 'diagnostics')
                )
              : null
            "
            [attr.title]="!softwareStatusMap['diagnostics'] ? 'Diagnostics service is not subscribed' : null"
            [style.opacity]="!softwareStatusMap['diagnostics'] ? 0.6 : 1"
            [style.pointer-events]="role === 'USER' && !softwareStatusMap['diagnostics'] ? 'none' : 'auto'"
          >
            Diagnostics
          </a>
          <ng-template ngbNavContent>
            <div class="fixed_status_bar">
              <div class="info_box_outer">
                <div class="info_box">
                  <h4 *ngIf="!monitoringDeviceDetailsLoader; else loading">
                    {{ monitoringDeviceDetails?.companyName?.company_name || "N/A" }}
                  </h4>
                  <ng-template #loading>
                    <div class="skeleton skeleton-service-text-device-details"></div>
                  </ng-template>
                  <h6>Customer</h6>
                </div>
                <div class="info_box">
                  <h4 *ngIf="!monitoringDeviceDetailsLoader; else loading">
                    {{ monitoringDeviceDetails?.assetDetails?.site_name || "N/A" }}
                  </h4>
                  <ng-template #loading>
                    <div class="skeleton skeleton-service-text-device-details"></div>
                  </ng-template>
                  <h6>Site</h6>
                </div>
                <div class="info_box">
                  <h4 *ngIf="!monitoringDeviceDetailsLoader; else loading">
                    {{ monitoringDeviceDetails?.assetDetails?.application_name || "N/A" }}
                  </h4>
                  <ng-template #loading>
                    <div class="skeleton skeleton-service-text-device-details"></div>
                  </ng-template>
                  <h6>Application</h6>
                </div>
                <div class="info_box">
                  <div class="inner">
                    <div class="lft">
                      <!-- <h4>{{ monitoringDeviceDetails?.assetDetails?.motor_make || "N/A" }}</h4>
                      <h6>Machine Make</h6> -->
                      <h4 *ngIf="!monitoringDeviceDetailsLoader; else loading">
                        {{ monitoringDeviceDetails?.assetDetails?.motor_make || "N/A" }}
                      </h4>
                      <ng-template #loading>
                        <div class="skeleton skeleton-service-text-device-details"></div>
                      </ng-template>
                      <h6>Machine Make</h6>
                    </div>
                    <div
                      class="rgt"
                      (click)="goToImageLink(_imgUrl)"
                      style="cursor: pointer"
                    >
                      <img
                        [src]="_imgUrl"
                        alt="User"
                        class="thumb"
                        onerror="this.src='./assets/img-new/assets.png'"
                      />
                    </div>
                  </div>
                </div>
                <div class="info_box">
                  <h4 *ngIf="!monitoringDeviceDetailsLoader; else loading">
                    {{ monitoringDeviceDetails?.assetDetails?.motor_serial_no || "N/A" }}
                  </h4>
                  <ng-template #loading>
                    <div class="skeleton skeleton-service-text-device-details"></div>
                  </ng-template>
                  <h6>Machine Serial Number</h6>
                </div>
                <div class="info_box">
                  <h4 *ngIf="!monitoringDeviceDetailsLoader; else loading">
                    {{ monitoringDeviceDetails?.assetDetails?.name || "N/A" }}
                  </h4>
                  <ng-template #loading>
                    <div class="skeleton skeleton-service-text-device-details"></div>
                  </ng-template>
                  <h6>Asset Name</h6>
                </div>
              </div>
            </div>

            <div class="inner_gauge_box">
              <div
                class="new_header"
                *ngIf="
                  assetType === 'FAN_BLOWER' ||
                  assetType === 'PUMP' ||
                  assetType === 'COMPRESSOR' ||
                  assetType === 'JOURNAL_BEARING'
                "
              >
                <div class="title font_20 m_b_0">
                  Machine Diagnostics Frequency Chart
                </div>
                <!-- <div class="lf_rg_detail">
                  <ul>
                    <li *ngIf="rpmData?.rpm_toggle === 'fixed'">
                      Rated RPM: <span>{{ rpmData?.rated_rpm?.toFixed(1) }}</span>
                    </li>
                    <li *ngIf="rpmData?.rpm_toggle === 'variable'">
                      Min Rated RPM: <span>{{ rpmData?.min_rated_rpm?.toFixed(1) }}</span>
                    </li>
                    <li *ngIf="rpmData?.rpm_toggle === 'variable'">
                      Max Rated RPM: <span>{{ rpmData?.max_rated_rpm?.toFixed(1) }}</span>
                    </li>
                    <li *ngIf="sub_type == 'SYNCHRONOUS_MOTOR'; else notsync">
                    
                      Actual RPM:<span>{{ rpmData?.actual_rpm?.toFixed(1) }} </span>
                    </li>
                    <ng-template #notsync>
                      <li>
                      
                        Actual RPM:<span>{{ rpmData?.actual_rpm?.toFixed(1) }}</span>
                      </li>
                    </ng-template>
                  </ul>
                  <span class="right">{{ fftLabelValue }}</span>
                </div> -->
                    <div class="lf_rg_detail">
                      <ul>
                        <!-- Fixed RPM -->
                        <li *ngIf="rpmData?.rpm_toggle === 'fixed'">
                          Rated RPM:
                          <span>
                            {{ (rpmData?.rated_rpm !== null && rpmData?.rated_rpm !== 0) ? rpmData.rated_rpm.toFixed(1) : 'NA' }}
                          </span>
                        </li>

                        <!-- Variable RPM - Min -->
                        <li *ngIf="rpmData?.rpm_toggle === 'variable'">
                          Min Rated RPM:
                          <span>
                            {{ (rpmData?.min_rated_rpm !== null && rpmData?.min_rated_rpm !== 0) ? rpmData.min_rated_rpm.toFixed(1) : 'NA' }}
                          </span>
                        </li>

                        <!-- Variable RPM - Max -->
                        <li *ngIf="rpmData?.rpm_toggle === 'variable'">
                          Max Rated RPM:
                          <span>
                            {{ (rpmData?.max_rated_rpm !== null && rpmData?.max_rated_rpm !== 0) ? rpmData.max_rated_rpm.toFixed(1) : 'NA' }}
                          </span>
                        </li>

                        <!-- Actual RPM for Synchronous Motor -->
                        <li *ngIf="sub_type == 'SYNCHRONOUS_MOTOR'; else notsync">
                          Actual RPM:
                          <span>
                            {{ (rpmData?.actual_rpm !== null && rpmData?.actual_rpm !== 0) ? rpmData.actual_rpm.toFixed(1) : 'NA' }}
                          </span>
                        </li>

                        <!-- Actual RPM for Non-Synchronous Motor -->
                        <ng-template #notsync>
                          <li>
                            Actual RPM:
                            <span>
                              {{ (rpmData?.actual_rpm !== null && rpmData?.actual_rpm !== 0) ? rpmData.actual_rpm.toFixed(1) : 'NA' }}
                            </span>
                          </li>
                        </ng-template>
                      </ul>

                      <span class="right">{{ fftLabelValue }}</span>
                    </div>

              </div>

              <div class="new_header" *ngIf="assetType === 'MOTOR'">
                <div class="title font_20 m_b_0">
                  Machine Diagnostics Frequency Chart
                </div>
                <div class="lf_rg_detail">
                <ul>
                  <!-- Fixed RPM -->
                  <li *ngIf="rpmData?.rpm_toggle === 'fixed'">
                    Rated RPM: 
                    <span>{{ (rpmData?.rated_rpm !== null && rpmData?.rated_rpm !== 0) ? rpmData.rated_rpm.toFixed(1) : 'NA' }}</span>
                  </li>

                  <!-- Variable RPM - Min -->
                  <li *ngIf="rpmData?.rpm_toggle === 'variable'">
                    Min Rated RPM: 
                    <span>{{ (rpmData?.min_rated_rpm !== null && rpmData?.min_rated_rpm !== 0) ? rpmData.min_rated_rpm.toFixed(1) : 'NA' }}</span>
                  </li>

                  <!-- Variable RPM - Max -->
                  <li *ngIf="rpmData?.rpm_toggle === 'variable'">
                    Max Rated RPM: 
                    <span>{{ (rpmData?.max_rated_rpm !== null && rpmData?.max_rated_rpm !== 0) ? rpmData.max_rated_rpm.toFixed(1) : 'NA' }}</span>
                  </li>

                  <!-- Actual RPM -->
                  <li>
                    Actual RPM:
                    <span *ngIf="sub_type == 'SYNCHRONOUS_MOTOR'; else notsync">
                      {{ (rpmData?.actual_rpm !== null && rpmData?.actual_rpm !== 0) ? rpmData.actual_rpm.toFixed(1) : 'NA' }}
                    </span>
                    <ng-template #notsync>
                      <span>{{ (rpmData?.actual_rpm !== null && rpmData?.actual_rpm !== 0) ? rpmData.actual_rpm.toFixed(1) : 'NA' }}</span>
                    </ng-template>
                  </li>

                  <!-- Rated Line Frequency -->
                  <li *ngIf="sub_type != 'DC_MOTOR'; else forActualRPM">
                    Rated Line Freq: 
                    <span>{{ (rpmData?.line_frequency !== null && rpmData?.line_frequency !== 0) ? rpmData.line_frequency.toFixed(1) : 'NA' }}</span>
                  </li>
                  <ng-template #forActualRPM>
                    <li>Rated Line Freq: <span>NA</span></li>
                  </ng-template>

                  <!-- Operating Line Frequency -->
                  <li *ngIf="sub_type != 'DC_MOTOR'; else operatingline">
                    Operating Line Freq: 
                    <span>{{ (rpmData?.operating_freq !== null && rpmData?.operating_freq !== 0) ? rpmData.operating_freq.toFixed(1) : 'NA' }}</span>
                  </li>
                  <ng-template #operatingline>
                    <li>Operating Line Freq: <span>NA</span></li>
                  </ng-template>

                  <!-- KW Rating -->
                  <li>
                    KW Rating: 
                    <span>{{ (rpmData?.rated_power !== null && rpmData?.rated_power !== 0) ? rpmData.rated_power.toFixed(1) : 'NA' }}</span>
                  </li>
                </ul>

                <span class="right">{{ fftLabelValue }}</span>
            </div>

              </div>
              <div class="new_header" *ngIf="assetType === 'GEAR'">
                <div class="title font_20 m_b_0">
                  Machine Diagnostic Frequency Chart
                </div>
                <div class="lf_rg_detail">
                  <ul>
                    <li>
                      Pinion Rated RPM: <span>{{ rpmData?.pinion?.rated_rpm?.toFixed(1) }}</span>
                    </li>
                    <li>
                      Pinion Actual RPM:
                      <!-- <span>{{ pinionActualForDiagnosticslabel }}</span> -->
                      <span>{{ rpmData?.pinion?.actual_rpm?.toFixed(1) || "N/A" }}</span>
                    </li>
                    <li>
                      Output Rated RPM: <span>{{ rpmData?.output?.rated_rpm?.toFixed(1) }}</span>
                    </li>
                    <li>
                      Output Actual RPM:
                      <span>{{ rpmData?.output?.actual_rpm?.toFixed(1) }}</span>
                    </li>
                    <li>
                      KW Rating: <span>{{ rpmData?.rated_power?.toFixed(1) }}</span>
                    </li>
                  </ul>
                  <span class="right">{{ fftLabelValue }}</span>
                </div>
              </div>

              <ul
              ngbNav
              #ctdTabset="ngbNav"
              class="simple_custom_tab"
                [activeId]="innerTab"
                (navChange)="insideTabChange($event.nextId)"
              >
                <li [ngbNavItem]="'diagSummary'" id="diagSummary">
                  <a ngbNavLink>Diagnostics Summary</a>
                  <ng-template ngbNavContent>
                    <div class="row">
                      <div class="col-md-12 diagSubTab">
                        <div class="col-md-9">
                          <!-- <img *ngIf="loader" class="chart_load" src="./assets/chart_loader.gif"
                              id="loader"/> -->
                          <div class="inner_sub">
                            <div class="left_block">
                              <!-- <img
                                *ngIf="loader"
                                style="
                                  padding-left: 400px;
                                  padding-top: 116px;
                                  position: absolute;
                                "
                                src="./assets/chart_loader.gif"
                                id="loader"
                              /> -->
                              <span *ngIf="machineDiagnosticsLoader && diagnosticsSummaryLoader; else showContent">
                                <div class="skeleton skeleton-diagnostics-text"></div>
                              </span>

                              <ng-template #showContent>
                                <span *ngIf="selectedFFTUID !== undefined; else showNewMessage">
                                  <span
                                    style="
                                      font-size: 11;
                                      font-family: 'Roboto-Medium', sans-serif !important;
                                    "
                                  >
                                    Machine Diagnostics Analysis was performed at:
                                  </span>
                                  <span>
                                    {{ diagosticsCreateAtFFT }}
                                  </span>
                                </span>

                                <ng-template #showNewMessage>
                                  <span
                                    style="
                                      font-size: 11;
                                      font-family: 'Roboto-Medium', sans-serif !important;
                                    "
                                    class="red_color_bg"
                                  >
                                    Machine Diagnostics Analysis is incomplete. Please run SA-On Demand for
                                    further processing.
                                  </span>
                                </ng-template>
                              </ng-template>




                              <br />
                              <span
                                style="display: inline-block; width: 15px"
                              ></span
                              ><span
                                style="
                                  font-size: 11;
                                  font-family: 'Roboto-Medium' !important;
                                "
                              >
                                Mechanical Health Diagnostics:
                              </span>
                              <br />
                              <!-- <span
                                *ngIf="
                                  mechFaultPreCondition != '';
                                  else showFaultAsOne
                                "
                              >
                                <span
                                  style="display: inline-block; width: 40px"
                                ></span
                                ><span>The Predominant Condition is: </span>
                                <span class="red_color_bg"
                                  >{{ mechFaultPreCondition }}
                                </span>
                              </span> -->
                              <span>
                                <span style="display: inline-block; width: 40px"></span>
                                <span>
                                  The Predominant Condition is:
                                </span>

                                <!-- Show Skeleton Loader or Data -->
                                <ng-container *ngIf="!diagnosticsSummaryLoader; else showSkeleton">
                                  <span
                                    *ngIf="
                                      diagnosticsMechanicalFaultPredominantError != 'N/A';
                                      else showFaultAsOne
                                    "
                                    class="red_color_bg"
                                  >
                                    {{ diagnosticsMechanicalFaultPredominantError }}
                                  </span>

                                  <ng-template #showFaultAsOne>
                                    <span class="green_color_bg" style="margin-left: 4px">None</span>
                                  </ng-template>
                                </ng-container>
                                <ng-template #showSkeleton>
                                  <div
                                    class="skeleton skeleton-diagnostics-text"
                                  ></div>
                                </ng-template>
                              </span>
                              <br />

                              <!-- <span
                                *ngIf="
                                  mechobserveableError != '';
                                  else showFaultAs
                                "
                              >
                                <span
                                  style="display: inline-block; width: 40px"
                                ></span
                                ><span
                                  >Other evolving conditions to observe are:
                                </span>
                                <span class="yellow_color_bg"
                                  >{{ mechobserveableError }}
                                </span>
                              </span> -->
                              <span>
                                <span style="display: inline-block; width: 40px"></span>
                                <span>
                                  Other evolving conditions to observe are:
                                </span>
                                <ng-container *ngIf="!diagnosticsSummaryLoader; else showSkeleton">
                                  <span
                                    *ngIf="
                                      diagnosticsMechanicalFaultObservableError != 'N/A';
                                      else showFaultAs
                                    "
                                    class="yellow_color_bg"
                                  >
                                    {{ diagnosticsMechanicalFaultObservableError }}
                                  </span>

                                  <ng-template #showFaultAs>
                                    <span class="green_color_bg" style="margin-left: 4px">None</span>
                                  </ng-template>
                                </ng-container>

                                <!-- Skeleton Loader -->
                                <ng-template #showSkeleton>
                                  <div
                                    class="skeleton skeleton-diagnostics-text"
                                  ></div>
                                </ng-template>
                              </span>

                              <br />

                              <!-- <span *ngIf="assetType == 'MOTOR'">
                                <span
                                  style="display: inline-block; width: 15px"
                                >
                                </span>
                                <span
                                  style="
                                    font-size: 11;
                                    font-family: 'Roboto-Medium' !important;
                                  "
                                  >Electrical Health Diagnostics:
                                </span>
                                <br /> -->
                                <!-- <span
                                  *ngIf="
                                    elecPredominantError != '';
                                    else showFaultAsOne
                                  "
                                >
                                  <span
                                    style="display: inline-block; width: 40px"
                                  ></span
                                  ><span
                                    >The predominant machine health condition
                                    is:</span
                                  >
                                  <span class="red_color_bg"
                                    >{{ elecPredominantError }}
                                  </span>
                                </span> -->
                                <!-- <span
                                  *ngIf="
                                    diagnosticsElectricalFaultPredominantError != 'N/A';
                                    else showFaultAsOne
                                  "
                                >
                                  <span
                                    style="display: inline-block; width: 40px"
                                  ></span
                                  ><span
                                    >The predominant machine health condition
                                    is:</span
                                  >
                                  <span class="red_color_bg"
                                    >{{ diagnosticsElectricalFaultPredominantError }}
                                  </span>
                                </span> -->

                                <!-- <ng-template #showFaultAsOne>
                                  <span
                                    style="display: inline-block; width: 40px"
                                  ></span
                                  ><span>The Predominant Condition is: </span>
                                  <span
                                    class="green_color_bg"
                                    style="margin-left: 4px"
                                    >None</span
                                  >
                                </ng-template> -->
                                <!-- <br /> -->

                                <!-- <span
                                  *ngIf="
                                    elecObserveableError != '';
                                    else showFaultAs
                                  "
                                >
                                  <span
                                    style="display: inline-block; width: 40px"
                                  ></span
                                  ><span
                                    >Other evolving conditions to observe are:
                                  </span>
                                  <span class="yellow_color_bg"
                                    >{{ elecObserveableError }}
                                  </span>
                                </span> -->
                                <!-- <span
                                  *ngIf="
                                    diagnosticsElectricalFaultObservableError != 'N/A';
                                    else showFaultAs
                                  "
                                >
                                  <span
                                    style="display: inline-block; width: 40px"
                                  ></span
                                  ><span
                                    >Other evolving conditions to observe are:
                                  </span>
                                  <span class="yellow_color_bg"
                                    >{{ diagnosticsElectricalFaultObservableError }}
                                  </span>
                                </span>

                                <ng-template #showFaultAs>
                                  <span>
                                    <span
                                      style="display: inline-block; width: 40px"
                                    ></span
                                    ><span
                                      >Other evolving conditions to observe are:
                                    </span>
                                    <span
                                      class="green_color_bg"
                                      style="margin-right: 2px"
                                      >None</span
                                    >
                                  </span>
                                </ng-template>
                              </span> -->
                              <span *ngIf="assetType == 'MOTOR'">
                                <span style="display: inline-block; width: 15px"></span>
                                <span
                                  style="font-size: 11; font-family: 'Roboto-Medium' !important"
                                >
                                  Electrical Health Diagnostics:
                                </span>
                                <br />

                                <!-- The Predominant Condition Static Text -->
                                <span>
                                  <span style="display: inline-block; width: 40px"></span>
                                  <span>The Predominant Condition is:</span>

                                  <!-- Show Skeleton Loader or Data for Predominant Machine Health Condition -->
                                  <ng-container *ngIf="!diagnosticsSummaryLoader; else showSkeleton">
                                    <span
                                      *ngIf="diagnosticsElectricalFaultPredominantError != 'N/A'; else showFaultAsOne"
                                    >
                                      <span class="red_color_bg">{{ diagnosticsElectricalFaultPredominantError }}</span>
                                    </span>

                                    <ng-template #showFaultAsOne>
                                      <span class="green_color_bg" style="margin-left: 4px">None</span>
                                    </ng-template>
                                  </ng-container>

                                  <!-- Skeleton Loader for Predominant Condition -->
                                  <ng-template #showSkeleton>
                                    <div class="skeleton skeleton-diagnostics-text"></div>
                                  </ng-template>
                                </span>

                                <br />

                                <!-- Other Evolving Conditions Static Text -->
                                <span>
                                  <span style="display: inline-block; width: 40px"></span>
                                  <span>Other evolving conditions to observe are:</span>

                                  <!-- Show Skeleton Loader or Data for Other Evolving Conditions -->
                                  <ng-container *ngIf="!diagnosticsSummaryLoader; else showSkeleton">
                                    <span
                                      *ngIf="diagnosticsElectricalFaultObservableError != 'N/A'; else showFaultAs"
                                    >
                                      <span class="yellow_color_bg">{{ diagnosticsElectricalFaultObservableError }}</span>
                                    </span>

                                    <ng-template #showFaultAs>
                                      <span class="green_color_bg" style="margin-right: 2px">None</span>
                                    </ng-template>
                                  </ng-container>

                                  <!-- Skeleton Loader for Other Evolving Conditions -->
                                  <ng-template #showSkeleton>
                                    <div class="skeleton skeleton-diagnostics-text"></div>
                                  </ng-template>
                                </span>
                              </span>

                              <br />
                              <div *ngIf="assetType != 'JOURNAL_BEARING'">
                                <span style="display: inline-block; width: 15px"></span>
                                <span style="font-size: 11; font-family: 'Roboto-Medium' !important">
                                  Ball Bearing Health Diagnostics:
                                </span>
                                <br />

                                <!-- The Predominant Condition Static Text -->
                                <span>
                                  <span style="display: inline-block; width: 40px"></span>
                                  <span>The Predominant Condition is:</span>

                                  <!-- Show Skeleton Loader or Data for Predominant Condition -->
                                  <ng-container *ngIf="!diagnosticsSummaryLoader; else showSkeletonPredominant">
                                    <span *ngIf="diagnosticsBearingFaultPredominantError != 'N/A'; else showFaultAsOne">
                                      <span class="red_color_bg">
                                        {{ diagnosticsBearingFaultPredominantError }}
                                        <span
                                        *ngIf="!setErrorStateOne"
                                        [matMenuTriggerFor]="menuFalultOne"
                                        data-toggle="dropdown"
                                        #locationMenuTrigger1="matMenuTrigger"
                                        class="hover_icon"
                                        style="cursor: pointer"
                                        (mouseenter)="locationMenuTrigger1.openMenu()"
                                        (mouseleave)="locationMenuTrigger1.closeMenu()"
                                        >
                                          <img class="infoicon" src="./assets/information-button.png" />
                                        </span>
                                      </span>
                                    </span>

                                    <ng-template #showFaultAsOne>
                                      <span class="green_color_bg" style="margin-left: 4px">None</span>
                                    </ng-template>
                                  </ng-container>

                                  <ng-template #showSkeletonPredominant>
                                    <div class="skeleton skeleton-diagnostics-text"></div>
                                  </ng-template>
                                </span>
                                <br />

                                <!-- Other Evolving Conditions Static Text -->
                                <span>
                                  <span style="display: inline-block; width: 40px"></span>
                                  <span>Other evolving conditions to observe are:</span>

                                  <!-- Show Skeleton Loader or Data for Observable Condition -->
                                  <ng-container *ngIf="!diagnosticsSummaryLoader; else showSkeletonObservable">
                                    <span *ngIf="diagnosticsBearingFaultObservableError != 'N/A'; else showFaultAs">
                                      <span class="yellow_color_bg">
                                        {{ diagnosticsBearingFaultObservableError }}
                                      </span>
                                    </span>

                                    <ng-template #showFaultAs>
                                      <span class="green_color_bg" style="margin-right: 2px">None</span>
                                    </ng-template>
                                  </ng-container>

                                  <ng-template #showSkeletonObservable>
                                    <div class="skeleton skeleton-diagnostics-text"></div>
                                  </ng-template>
                                </span>
                              </div>


                              <br />
                              <div *ngIf="assetType == 'GEAR'">
                                <span
                                  style="display: inline-block; width: 15px"
                                >
                                </span>
                                <span
                                  style="
                                    margin-right: 4px;
                                    font-size: 12;
                                    font-family: 'Roboto-Medium' !important;
                                  "
                                >
                                  Gear Teeth Health Analysis:
                                </span>
                                <br />
                                <span
                                  style="display: inline-block; width: 40px"
                                ></span
                                ><span>The Predominant Condition is: </span
                                >
                                <!-- <span
                                  *ngIf="
                                    cepsturmError != '';
                                    else cepstrumerror1
                                  "
                                  style="margin-left: 4px"
                                  class="yellow_color_bg"
                                  >{{ cepsturmError }}</span
                                > -->
                                <span *ngIf="diagnosticsSummaryLoader else showContent">
                                  <div class="skeleton skeleton-diagnostics-text"></div>
                                </span>
                                <ng-template #showContent>
                                  <span
                                    *ngIf="
                                      diagnosticsCepstrumError != 'N/A';
                                      else cepstrumerror1
                                    "
                                    style="margin-left: 4px"
                                    class="yellow_color_bg"
                                    >{{ diagnosticsCepstrumError }}</span
                                  >
                                  <ng-template #cepstrumerror1>
                                    <span
                                      *ngIf="assetType == 'GEAR'"
                                      class="green_color_bg"
                                      >None</span
                                    >
                                  </ng-template>
                                </ng-template>

                              </div>
                            </div>

                            <div class="right_block right-block-new1">
                              <div class="col-sm-3 right">
                                <div class="SA_btn">
                                  <div class="right_side">
                                    <span class="custom_select_outer"></span>

                                    <button
                                      [disabled]="loaderAddClass === 'refresh_move'"
                                      class="btn-hover"
                                      style="width: max-content;"
                                      mat-raised-button
                                      color="primary"
                                      (click)="pageReload()"
                                    >
                                      SA - On Demand
                                      <i
                                        class="material-icons icon-layout-custom"
                                        style="vertical-align: bottom; margin-left: 5px;"
                                        [ngClass]="loaderAddClass"
                                      >
                                        refresh
                                      </i>
                                    </button>
                                  </div>

                                </div>
                                <div class="amplitude_div">
                                  <div class="right_side">
                                    <span class="custom_select_outer">
                                      <select
                                        [(ngModel)]="selectedFFTUIDAnomaly"
                                        class="custom_select form-control new-select"
                                        style="width: 245px !important;"
                                        #selectValue2
                                        (change)="loadFftData(selectValue2.value, 'anomaly')"
                                        [disabled]="!trendAnalysDataAnomaly || trendAnalysDataAnomaly.length === 0"
                                        [ngStyle]="{
                                          'cursor': (!trendAnalysDataAnomaly || trendAnalysDataAnomaly.length === 0) ? 'not-allowed' : 'pointer'
                                        }"
                                      >
                                        <option
                                          *ngFor="let item of trendAnalysDataAnomaly"
                                          [value]="item.value"
                                          style="cursor: pointer;"
                                        >
                                          {{ item.SAname + " " + item.fft_time }}
                                        </option>
                                      </select>
                                    </span>
                                  </div>
                                </div>


                              </div>
                            </div>
                          </div>

                          <div class="inner_sub">
                            <div
                              class="left_block"
                              *ngIf="assetType != 'JOURNAL_BEARING'"
                            >
                              <span
                                style="
                                  font-size: 12;
                                  font-family: 'Roboto-Medium' !important;
                                "
                              >
                                Early Stage Ball Bearing Diagnostics Analysis
                                was performed at:-
                              </span>
                              <span *ngIf="ballBearingOn; else earlyBearingOn">
                                NOT APPLICABLE
                              </span>
                              <ng-template #earlyBearingOn>
                                <!-- <span>
                                  {{ earlyUpdateAt }}
                                </span> -->
                                <span *ngIf="!diagnosticsSummaryLoader; else showSkelton">
                                  {{ diagnosticsEarlyStageBallBearingUpdatedAt }}
                                </span>
                                <ng-template #showSkelton>
                                  <div class="skeleton skeleton-diagnostics-text"></div>
                                </ng-template>
                                <br />
                                <!-- <span
                                  *ngIf="
                                    ballBearingErrorMessage != '';
                                    else showFaultAs2
                                  "
                                >
                                  <span
                                    style="display: inline-block; width: 40px"
                                  ></span
                                  ><span>The Predominant Condition is: </span>
                                  <span style="background-color:#FEA934;color:black;
;"
                                    >{{ ballBearingErrorMessage }}
                                  </span>
                                </span> -->
                                <span>
                                  <span style="display: inline-block; width: 40px"></span>
                                  <span>
                                    The Predominant Condition is:
                                  </span>

                                  <!-- Show Skeleton Loader or Data -->
                                  <ng-container *ngIf="!diagnosticsSummaryLoader; else showSkeleton">
                                    <span
                                      *ngIf="
                                        diagnosticsBallBearingErrorMessage  != 'N/A';
                                        else showFaultAsOne
                                      "
                                      class="red_color_bg"
                                    >
                                      {{ diagnosticsBallBearingErrorMessage  }}
                                    </span>

                                    <ng-template #showFaultAsOne>
                                      <span class="green_color_bg" style="margin-left: 4px">None</span>
                                    </ng-template>
                                  </ng-container>
                                  <ng-template #showSkeleton>
                                    <div
                                      class="skeleton skeleton-diagnostics-text"
                                    ></div>
                                  </ng-template>
                                </span>
                                <br />
                              </ng-template>
                            </div>
                            <div class="right_block">
                              <div class="amplitude_div">
                                <div class="right_side">
                                  <p
                                    class="envelop_P"
                                    *ngIf="assetType != 'JOURNAL_BEARING'"
                                  >
                                    Envelop Analysis done on:
                                  </p>
                                  <span
                                    *ngIf="ballBearingOn; else earlyBearingOn1"
                                  >
                                    <span class="custom_select_outer">
                                      <select
                                        class="custom_select form-control"
                                        style="width: 130px !important"
                                      >
                                        <option
                                          class="dropdown-item"
                                          disabled
                                          selected
                                          value="null"
                                        ></option>
                                      </select>
                                    </span>
                                  </span>
                                  <ng-template #earlyBearingOn1>
                                    <span
                                      class="custom_select_outer"
                                      *ngIf="assetType != 'JOURNAL_BEARING'"
                                    >
                                      <select
                                        class="custom_select form-control"
                                        [(ngModel)]="fftIdforAdvance"
                                        style="width: 200px !important"
                                        #selectValue2
                                        (change)="
                                          loadFftAdvanceDiag(
                                            $event.target.value
                                          )
                                        "
                                      >
                                        <option
                                          *ngIf="fftAdvEmpty"
                                          class="dropdown-item"
                                          disabled
                                          selected
                                          value="null"
                                        >
                                          Select an Option
                                        </option>
                                        <option
                                          *ngFor="
                                            let item of AdvanceDiagFftData;
                                            let i = index
                                          "
                                          [value]="item.value"
                                        >
                                          {{ item.label }}
                                        </option>
                                      </select>
                                    </span>
                                  </ng-template>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="inner_sub" *ngIf="assetType == 'MOTOR'">
                            <div class="left_block">
                              <span
                                style="
                                  font-size: 12;
                                  font-family: 'Roboto-Medium' !important;
                                "
                              >
                                Electrical Signature Analysis for Electric
                                Motors was performed at:-
                              </span>
                              <span *ngIf="assetType == 'MOTOR'">
                                <span
                                  *ngIf="electricalLabelVal != null"
                                  style="margin-left: 2px"
                                >
                                  NOT APPLICABLE
                                </span></span
                              >
                              <!-- <ng-template #electricalerrorVal>
                                <span>NOT APPLICABLE</span>
                              </ng-template> -->
                              <br />
                              <!-- <span
                                class="green_color_bg"
                                *ngIf="ESADisabled == 'true'; else ESATrue"
                                >NOT APPLICABLE</span
                              > -->
                              <span class="green_color_bg" *ngIf="ESADisabled == 'true'; else ESATrue">{{'N/A'}}</span>
                              <!-- <ng-template #ESATrue>
                                <span
                                  style="display: inline-block; width: 40px"
                                ></span
                                ><span *ngIf="assetType == 'MOTOR'"
                                  >NOT APPLICABLE</span
                                >
                              </ng-template> -->

                              <br />
                              <div>
                                <mat-menu
                                  class="f_detail"
                                  #menuFalult="matMenu"
                                  overlapTrigger="false"
                                >
                                  <span>
                                    <ul class="read_more_ul">
                                      <li *ngFor="let sperFor of faults_info">
                                        <span class="tag">{{
                                          sperFor.tag
                                        }}</span
                                        >: {{ sperFor.summary }}
                                      </li>
                                    </ul>
                                  </span>
                                </mat-menu>
                              </div>
                            </div>
                            <div class="right_block">
                              <div class="amplitude_div">
                                <div class="right_side">
                                  <span class="custom_select_outer">
                                    <p class="envelop_P">ESA not Subscribed</p>
                                    <!-- <select [(ngModel)]="selectedFFTUIDPeriodic" class="custom_select form-control"
                                          style="width: 130px !important" #selectValue (change)="t.select('innertab-1')"
                                          (change)="
                                                                                                            loadFftData(selectValue.value, 'periodic')
                                                                                                          ">
                                          <option class="dropdown-item" disabled selected value="null">
                                            Select an Option
                                          </option>
                                          <option *ngFor="let item of trendAnalysDataPeriodic" [value]="item.value">
                                            {{ item.label }}
                                          </option>
                                        </select> -->
                                  </span>
                                  <!-- <button [disabled]="loaderAddClass === 'refresh_move'" class="btn default_btn"
                                        mat-raised-button (click)="getElectricalDropDown()">
                                        SA - On Demand
                                        <i class="material-icons icon-layout-custom"
                                          style="vertical-align: bottom;margin-left: 5px;"
                                          [ngClass]="loaderAddClass">refresh</i>
                                      </button> -->
                                </div>
                              </div>
                              <div class="amplitude_div">
                                <div class="right_side">
                                  <span class="custom_select_outer">
                                    <select
                                      [(ngModel)]="device_raw_matric_id"
                                      class="custom_select form-control"
                                      style="width: 130px !important"
                                      #selectValue2
                                      (change)="
                                        selectRawMatricId(selectValue2.value)
                                      "
                                    >
                                      <option
                                        class="dropdown-item"
                                        disabled
                                        selected
                                        value="null"
                                      >
                                        Select an Option
                                      </option>
                                      <option
                                        *ngFor="
                                          let item of electricalDropDownList
                                        "
                                        [value]="item.devicerawMatricId"
                                      >
                                        {{ item.time }}
                                      </option>
                                      Select an Option
                                    </select>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-3 faults-table">
                          <table *ngIf="diagnosticsSummaryLoader; else dataTable" class="fault_table">
                            <tr>
                              <th>Sr. No</th>
                              <th>Fault Group</th>
                              <th>Faults</th>
                              <th>Status</th>
                            </tr>
                            <tr *ngFor="let i of [].constructor(20)">
                              <td>
                                <span class="skeleton" style="width: 30px; height: 15px;"></span>
                              </td>
                              <td>
                                <span class="skeleton" style="width: 80px; height: 15px;"></span>
                              </td>
                              <td>
                                <span class="skeleton" style="width: 180px; height: 15px;"></span>
                              </td>
                              <td>
                                <span class="skeleton" style="width: 50px; height: 15px;"></span>
                              </td>
                            </tr>
                          </table>
                          <ng-template #dataTable>
                            <table
                              *ngIf="assetErrors.length > 0"
                              class="fault_table"
                            >
                              <tr>
                                <th>Sr. No</th>
                                <th>Fault Group</th>
                                <th>Faults</th>
                                <th>Status</th>
                              </tr>
                              <tr
                                *ngFor="let error of finalErrors; let i = index"
                              >
                                <td>{{ i + 1 }}</td>
                                <td>{{ error.group }}</td>
                                <td>
                                  {{ error.error }}
                                </td>
                                <td class="{{ error.color }}"></td>
                              </tr>
                            </table>
                          </ng-template>

                        </div>
                      </div>
                    </div>
                  </ng-template>
                </li>
                <li [ngbNavItem]="'innertab-1'" id="innertab-1">
                  <a ngbNavLink>Velocity Spectra</a>
                  <ng-template ngbNavContent>
                    <div class="row">
                      <div class="col-md-12 amp_chart_div">
                        <div class="col-sm-9 left">
                          <div class="amplitude_div">
                            <h5>Amplitude <span>(mm/sec)</span></h5>
                            <h6>
                              <input
                                [disabled]="
                                  assetType == 'GEAR' &&
                                  (pinion_gear_actual_rpm == undefined ||
                                    pinion_gear_actual_rpm < 0)
                                "
                                type="checkbox"
                                [(ngModel)]="rmptoggle"
                                (change)="rmpValueShowHide()"
                              />
                              1x
                            </h6>
                            <h6>
                              <input type="checkbox"
                                [(ngModel)] = "yChecksMultipleBoolean"
                                (change) = "updateYChecksMultipleStripLines()"
                              />
                              1y
                            </h6>
                            <h6>
                              <input
                                [disabled]="preDominantStripLines.length <= 0"
                                type="checkbox"
                                [(ngModel)]="pFreqtoggleVelocity"
                                (change)="bFreqShowHideVelocity()"
                              />
                              PreDominant Frequencies
                            </h6>
                            <h6>
                              <input
                                type="checkbox"
                                [disabled]="!softwareStatusMap['kurtosis']"
                                [(ngModel)] = "bearingFrequencyCheckboxBoolean"
                                (change)="updateBearingFrequencyStripLines()"
                                />
                              Bearing Frequencies
                            </h6>
                            <h6>
                              <input type="checkbox"
                                [disabled]="assetType !== 'GEAR'"
                                [(ngModel)] = "gearMeshFrequencyCheckboxBoolean"
                                (change) = "updateGearMeshFrequencyStripLines()"
                              />
                              Gear Mesh Frequency (GMF)
                            </h6>

                            <div class="right_side">
                              <div class="btn-group tab_btn_group">
                                <button
                                type="button"
                                class="btn"
                                (click)="openChartPopup()"
                                [disabled]="!softwareStatusMap['waterfall_chart']"
                               [ngClass]="{ 'waterfall_disabled': !softwareStatusMap['waterfall_chart'] }"
                              >
                                <span
                                  class=""

                                >3D</span>
                              </button>

                                <button
                                  type="button"
                                  class="btn"
                                  (click)="freqChartLayout()"
                                >
                                  <span
                                    class="sprite_icon wave_grey"
                                    [ngClass]="{ wave_blue: freqChartViewOn }"
                                  ></span>
                                </button>
                                <button
                                  type="button"
                                  class="btn"
                                  (click)="frqlistLayout()"
                                >
                                  <span
                                    class="sprite_icon list_grey"
                                    [ngClass]="{ list_blue: freqChartViewOff }"
                                  ></span>
                                </button>
                                <button
                                  type="button"
                                  class="btn"
                                  (click)="downloadChartData2('vibration')"
                                >
                                  <span
                                    class="sprite_icon download_grey"
                                    [ngClass]="{
                                      download_blue: downloadChartDataOn
                                    }"
                                  ></span>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="yStripLineMsgCont" *ngIf="yChecksMultipleBoolean">
                            <p>Click on any coordinate on the graph to display multiples of Y strip lines.</p>
                          </div>
                          <div class="newBox_Container">
                            <!-- <div class="newBox_Container_inner">
                              <div class="boxNo1">Fmax = {{fxMax}}Hz</div>
                              <div class="boxNo2">Spectrum Resolution = {{spectrumResolutionFactor}}Hz</div>
                            </div> -->
                            <div class="newBox_Container_inner">
                              <button mat-raised-button color="accent" class="info-button" style="color: white !important;">
                                Fmax = {{ fxMax }}Hz
                              </button>
                              <button mat-raised-button color="accent" class="info-button" style="color: white !important;">
                                Spectrum Resolution = {{ spectrumResolutionFactor }}Hz
                              </button>
                            </div>
                            <div>
                              <button mat-raised-button color="primary" (click)="downloadChart('freqNewChartContainer')">Download Chart Image</button>
                            </div>
                          </div>
                          <div class="line_chart_outer" *ngIf="freqChartViewOn">
                            <div
                              id="freqNewChartContainer"
                              style="
                                height: 370px;
                                width: 1336px !important;
                                margin-left: auto;
                                margin-right: auto;
                              "
                            >
                              <img
                                *ngIf="!showFFTDataChartEmpty"
                                class="chart_load"
                                src="./assets/chart_loader.gif"
                                id="loader"
                              />
                              <p *ngIf="showFFTDataChartEmpty && !selectedFFTUIDAnomaly" class="no_avl_data_msg">
                                No data available. SA - On Demand analysis not done yet.
                              </p>
                              <p *ngIf="showFFTDataChartEmpty && selectedFFTUIDAnomaly" class="no_avl_data_msg">
                                No data available.
                              </p>
                            </div>
                          </div>
                          <div class="xScale_button_container" style="justify-content: end;">
                            <button mat-stroked-button
                                    color="primary"
                                    *ngIf="xAxisScaleTypeGlobal === 1"
                                    (click)="handleXAxisScaleChange(1)">
                              Hz
                            </button>
                            <button mat-raised-button
                                    *ngIf="xAxisScaleTypeGlobal !== 1"
                                    (click)="handleXAxisScaleChange(1)">
                              Hz
                            </button>

                            <button mat-stroked-button
                                    color="primary"
                                    *ngIf="xAxisScaleTypeGlobal === 2"
                                    (click)="handleXAxisScaleChange(2)">
                              CPM
                            </button>
                            <button mat-raised-button
                                    *ngIf="xAxisScaleTypeGlobal !== 2"
                                    (click)="handleXAxisScaleChange(2)">
                              CPM
                            </button>

                            <button mat-stroked-button
                                    color="primary"
                                    *ngIf="xAxisScaleTypeGlobal === 3"
                                    (click)="handleXAxisScaleChange(3)">
                              Orders
                            </button>
                            <button mat-raised-button
                                    *ngIf="xAxisScaleTypeGlobal !== 3"
                                    (click)="handleXAxisScaleChange(3)">
                              Orders
                            </button>
                          </div>
                          <div
                            class="line_chart_outer tb"
                            *ngIf="freqChartViewOff"
                          >
                            <div class="new_header">
                              <div class="title"></div>
                            </div>
                            <div class="table-responsive">
                              <table class="table line_chart_tb diag">
                                <thead>
                                  <tr>
                                    <th rowspan="2">Frequency (Hz)</th>
                                    <th colspan="3" class="text-center">
                                      Velocity Spectra (mm/sec)
                                    </th>
                                  </tr>
                                  <tr>
                                    <td>Tangential</td>
                                    <td>Axial</td>
                                    <td>Radial</td>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <table class="table child_tb">
                                        <tr
                                          *ngFor="let datay1 of listFreqData1"
                                        >
                                          <td>{{ datay1.x }}</td>
                                        </tr>
                                      </table>
                                    </td>
                                    <td>
                                      <table class="table child_tb">
                                        <tr
                                          *ngFor="let datay1 of listFreqData1"
                                        >
                                          <td>{{ datay1.y }}</td>
                                        </tr>
                                      </table>
                                    </td>
                                    <td>
                                      <table class="table child_tb">
                                        <tr
                                          *ngFor="let datay2 of listFreqData2"
                                        >
                                          <td>{{ datay2.y }}</td>
                                        </tr>
                                      </table>
                                    </td>
                                    <td>
                                      <table class="table child_tb">
                                        <tr
                                          *ngFor="let datay3 of listFreqData3"
                                        >
                                          <td>{{ datay3.y }}</td>
                                        </tr>
                                      </table>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <p *ngIf="showFFTDataChartEmpty && !selectedFFTUIDAnomaly; else sec_msg" class="no_avl_data_msg">
                                No data available. SA - On Demand analysis not done yet.
                              </p>
                              <ng-template #sec_msg>
                                <p *ngIf="showFFTDataChartEmpty" class="no_avl_data_msg">
                                  No data available.
                                </p>
                              </ng-template>
                            </div>
                          </div>

                          <div class="amplitude_div" style="margin-top: 20px !important;">
                            <h5>
                              Vibration - Acceleration
                              <span>(m/sec<sup>2</sup>)</span>
                            </h5>
                            <div class="right_side">
                              <div class="btn-group tab_btn_group">
                                <button
                                  type="button"
                                  class="btn"
                                  (click)="accChartLayout()"
                                  hidden
                                >
                                  <span
                                    class="sprite_icon wave_grey"
                                    [ngClass]="{ wave_blue: freqChartViewOn }"
                                  ></span>
                                </button>
                                <button
                                  type="button"
                                  class="btn"
                                  (click)="acclistLayout()"
                                  hidden
                                >
                                  <span
                                    class="sprite_icon list_grey"
                                    [ngClass]="{ list_blue: freqChartViewOff }"
                                  ></span>
                                </button>
                                <button
                                  type="button"
                                  class="btn"
                                  (click)="
                                    downloadChartData2('vibration&acceleration')
                                  "
                                >
                                  <span
                                    class="sprite_icon download_grey"
                                    [ngClass]="{
                                      download_blue: downloadChartDataOn
                                    }"
                                  ></span>
                                </button>
                              </div>
                            </div>
                          </div>

                          <div
                            class="line_chart_outer tb"
                            *ngIf="accChartViewOff"
                          >
                            <div class="new_header">
                              <div class="title"></div>
                            </div>
                            <div class="table-responsive">
                              <table class="table line_chart_tb diag">
                                <thead>
                                  <tr>
                                    <th rowspan="2">Sample Count</th>
                                    <th colspan="3" class="text-center">
                                      Velocity Spectra (mm/sec)
                                    </th>
                                  </tr>
                                  <tr>
                                    <td>Tangential</td>
                                    <td>Axial</td>
                                    <td>Radial</td>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <table class="table child_tb">
                                        <tr *ngFor="let datay1 of listAccData1">
                                          <td>{{ datay1.x }}</td>
                                        </tr>
                                      </table>
                                    </td>
                                    <td>
                                      <table class="table child_tb">
                                        <tr *ngFor="let datay1 of listAccData1">
                                          <td>{{ datay1.y }}</td>
                                        </tr>
                                      </table>
                                    </td>
                                    <td>
                                      <table class="table child_tb">
                                        <tr *ngFor="let datay2 of listAccData2">
                                          <td>{{ datay2.y }}</td>
                                        </tr>
                                      </table>
                                    </td>
                                    <td>
                                      <table class="table child_tb">
                                        <tr *ngFor="let datay3 of listAccData3">
                                          <td>{{ datay3.y }}</td>
                                        </tr>
                                      </table>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div class="line_chart_outer same">
                            <div
                              id="freqAccNewChartContainer"
                              style="
                               height: 370px;
                               width: 1336px !important;
                                margin-left: auto;
                                margin-right: auto;
                              "
                            >
                              <img
                                *ngIf="!showFFTDataChartEmpty_Vibration"
                                class="chart_load"
                                src="./assets/chart_loader.gif"
                                id="loader"
                              />
                              <!-- <p
                                *ngIf="showFFTDataChartEmpty_Vibration"
                                class="no_avl_data_msg"
                              >
                                {{ vibrationNoDataMsg }}
                              </p> -->
                              <p *ngIf="showFFTDataChartEmpty_Vibration && !selectedFFTUIDAnomaly; else sec_msg" class="no_avl_data_msg">
                                No data available. SA - On Demand analysis not done yet.
                              </p>
                              <ng-template #sec_msg>
                                <p *ngIf="showFFTDataChartEmpty_Vibration" class="no_avl_data_msg">
                                  No data available.
                                </p>
                              </ng-template>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-3 right">
                          <!-- <span
                            ><strong>Spectrum was analysed at:- </strong></span
                          > -->
                          <span class="red_color_bg" *ngIf="selectedFFTUID !== undefined; else showMsg2">{{spectrumAnalysisCase}}{{diagosticsCreateAtFFT}}</span>
                          <ng-template #showMsg2>
                            <span class="red_color_bg">Machine Diagnostics Analysis is incomplete. Please run SA-On Demand for
                              further processing.</span>
                          </ng-template>

                          <br /><br />
                          <h5 class="fft_heading">Crest Factor</h5>
                          <div class="table-responsive">
                            <table class="table frequency_tb">
                              <thead>
                                <tr>
                                  <th>Radial</th>
                                  <th>Tangential</th>
                                  <th>Axial</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngIf="!cresFactorEmpty">
                                  <td>{{ xcf }}</td>
                                  <td>{{ ycf }}</td>
                                  <td>{{ zcf }}</td>
                                </tr>
                                <tr *ngIf="cresFactorEmpty">
                                  <td colspan="3">
                                    <p style="text-align: center">
                                      Not Applicable.
                                    </p>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <h5 class="fft_heading">Predominant Frequencies</h5>
                          <div class="table-responsive">
                            <table class="table frequency_tb">
                              <thead>
                                <tr>
                                  <th class="middle_align" rowspan="2">
                                    Frequency<span>(Hz)</span>
                                  </th>
                                  <th>Radial</th>
                                  <th>Tangential</th>
                                  <th>Axial</th>
                                </tr>
                                <tr>
                                  <td>mm/sec</td>
                                  <td>mm/sec</td>
                                  <td>mm/sec</td>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let xaxis of xaxisFrequency">
                                  <td>{{ xaxis.freq }}</td>
                                  <td>{{ xaxis["Acceleration 1 Z"] }}</td>
                                  <td>{{ xaxis["Acceleration 1 X"] }}</td>
                                  <td>{{ xaxis["Acceleration 1 Y"] }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </li>
                <li [ngbNavItem]="'innertab-2'" id="innertab-2">
                  <a ngbNavLink >Acceleration Spectra</a>
                  <ng-template ngbNavContent>
                    <div class="row">
                      <div class="col-md-12 amp_chart_div">
                        <div class="col-sm-9 left">
                          <div class="amplitude_div">
                            <h5>
                              Amplitude <span>(m/sec<sup>2</sup> )</span>
                            </h5>
                            <h6>
                              <input
                                [disabled]="
                                  assetType == 'GEAR' &&
                                  (pinion_gear_actual_rpm == undefined ||
                                    pinion_gear_actual_rpm < 0)
                                "
                                type="checkbox"
                                [(ngModel)]="rmptoggle"
                                (change)="rmpValueShowHide()"
                              />
                              1x
                            </h6>
                            <h6>
                              <input type="checkbox"
                                [(ngModel)] = "yChecksMultipleBoolean"
                                (change) = "updateYChecksMultipleStripLines()"
                              />
                              1y
                            </h6>
                            <h6>
                              <input
                                [disabled]="preDominantStripLines.length <= 0"
                                type="checkbox"
                                [(ngModel)]="pFreqtoggleVelocity"
                                (change)="bFreqShowHideVelocity()"
                              />
                              PreDominant Frequencies
                            </h6>
                            <h6>
                              <input
                                type="checkbox"
                                [disabled]="!softwareStatusMap['kurtosis']"
                                [(ngModel)] = "bearingFrequencyCheckboxBoolean"
                                (change)="updateBearingFrequencyStripLines()"
                                />
                              Bearing Frequencies
                            </h6>
                            <h6>
                              <input type="checkbox"
                                [disabled]="assetType !== 'GEAR'"
                                [(ngModel)] = "gearMeshFrequencyCheckboxBoolean"
                                (change) = "updateGearMeshFrequencyStripLines()"
                              />
                              Gear Mesh Frequency (GMF)
                            </h6>

                            <div class="right_side">
                              <div class="btn-group tab_btn_group">
                                <button
                                type="button"
                                class="btn"
                                (click)="freqChartLayout()"
                              >
                                <span
                                  class="sprite_icon wave_grey"
                                  [ngClass]="{ wave_blue: freqChartViewOn }"
                                ></span>
                              </button>
                                <button
                                  type="button"
                                  class="btn"
                                  (click)="frqlistLayout()"
                                >
                                  <span
                                    class="sprite_icon list_grey"
                                    [ngClass]="{ list_blue: freqChartViewOff }"
                                  ></span>
                                </button>

                                <button
                                  type="button"
                                  class="btn"
                                  (click)="downloadChartData2('acceleration')"
                                >
                                  <span
                                    class="sprite_icon download_grey"
                                    [ngClass]="{
                                      download_blue: downloadChartDataOn
                                    }"
                                  ></span>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div class="yStripLineMsgCont" *ngIf="yChecksMultipleBoolean">
                            <p>Click on any coordinateon the graph to display multiples of Y strip lines.</p>
                          </div>
                          <div class="newBox_Container">
                            <!-- <div class="newBox_Container_inner">
                              <div class="boxNo1">Fmax = {{fxMax}}Hz</div>
                              <div class="boxNo2">Spectrum Resolution = {{spectrumResolutionFactor}}Hz</div>
                            </div> -->
                            <div class="newBox_Container_inner">
                              <button mat-raised-button color="accent" class="info-button" style="color: white !important;">
                                Fmax = {{ fxMax }}Hz
                              </button>
                              <button mat-raised-button color="accent" class="info-button" style="color: white !important;">
                                Spectrum Resolution = {{ spectrumResolutionFactor }}Hz
                              </button>
                            </div>
                            <div>
                              <button  mat-raised-button color="primary" (click)="downloadChart('freqNewChartContainer')">Download Chart Image</button>
                            </div>
                          </div>
                          <div class="line_chart_outer" *ngIf="freqChartViewOn">
                            <div
                              id="freqNewChartContainer"
                              style="
                               height: 370px;
                               width: 1336px !important;
                                margin-left: auto;
                                margin-right: auto;
                              "
                            >
                              <img
                                *ngIf="!showFFTDataChartEmpty"
                                class="chart_load"
                                src="./assets/chart_loader.gif"
                                id="loader"
                              />
                              <p *ngIf="showFFTDataChartEmpty && !selectedFFTUIDAnomaly; else sec_msg" class="no_avl_data_msg">
                                No data available. SA - On Demand analysis not done yet.
                              </p>
                              <ng-template #sec_msg>
                                <p *ngIf="showFFTDataChartEmpty" class="no_avl_data_msg">
                                  No data available.
                                </p>
                              </ng-template>
                            </div>
                          </div>
                          <div class="xScale_button_container" style="justify-content: end;">
                            <button mat-stroked-button
                                    color="primary"
                                    *ngIf="xAxisScaleTypeGlobal === 1"
                                    (click)="handleXAxisScaleChange(1)">
                              Hz
                            </button>
                            <button mat-raised-button
                                    *ngIf="xAxisScaleTypeGlobal !== 1"
                                    (click)="handleXAxisScaleChange(1)">
                              Hz
                            </button>

                            <button mat-stroked-button
                                    color="primary"
                                    *ngIf="xAxisScaleTypeGlobal === 2"
                                    (click)="handleXAxisScaleChange(2)">
                              CPM
                            </button>
                            <button mat-raised-button
                                    *ngIf="xAxisScaleTypeGlobal !== 2"
                                    (click)="handleXAxisScaleChange(2)">
                              CPM
                            </button>

                            <button mat-stroked-button
                                    color="primary"
                                    *ngIf="xAxisScaleTypeGlobal === 3"
                                    (click)="handleXAxisScaleChange(3)">
                              Orders
                            </button>
                            <button mat-raised-button
                                    *ngIf="xAxisScaleTypeGlobal !== 3"
                                    (click)="handleXAxisScaleChange(3)">
                              Orders
                            </button>
                          </div>
                          <div
                            class="line_chart_outer tb"
                            *ngIf="freqChartViewOff"
                          >
                            <div class="new_header">
                              <div class="title"></div>
                            </div>
                            <div class="table-responsive">
                              <table class="table line_chart_tb diag">
                                <thead>
                                  <tr>
                                    <th rowspan="2">Frequency(Hz)</th>
                                    <th colspan="3" class="text-center">
                                      Acceleration Spectra (m/sec<sup>2</sup>)
                                    </th>
                                  </tr>
                                  <tr>
                                    <td>Tangential</td>
                                    <td>Axial</td>
                                    <td>Radial</td>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <table class="table child_tb">
                                        <tr
                                          *ngFor="let datay1 of listFreqData1"
                                        >
                                          <td>{{ datay1.x }}</td>
                                        </tr>
                                      </table>
                                    </td>
                                    <td>
                                      <table class="table child_tb">
                                        <tr
                                          *ngFor="let datay1 of listFreqData1"
                                        >
                                          <td>{{ datay1.y }}</td>
                                        </tr>
                                      </table>
                                    </td>
                                    <td>
                                      <table class="table child_tb">
                                        <tr
                                          *ngFor="let datay2 of listFreqData2"
                                        >
                                          <td>{{ datay2.y }}</td>
                                        </tr>
                                      </table>
                                    </td>
                                    <td>
                                      <table class="table child_tb">
                                        <tr
                                          *ngFor="let datay3 of listFreqData3"
                                        >
                                          <td>{{ datay3.y }}</td>
                                        </tr>
                                      </table>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <p *ngIf="showFFTDataChartEmpty && !selectedFFTUIDAnomaly; else sec_msg" class="no_avl_data_msg">
                                No data available. SA - On Demand analysis not done yet.
                              </p>
                              <ng-template #sec_msg>
                                <p *ngIf="showFFTDataChartEmpty" class="no_avl_data_msg">
                                  No data available.
                                </p>
                              </ng-template>
                            </div>
                          </div>

                          <!-- <div class="amplitude_div">
                            <h5>
                              Vibration - Acceleration
                              <span>(m/sec<sup>2</sup>)</span>
                            </h5>
                          </div> -->
                          <!-- <div class="line_chart_outer same">
                            <div id="freqAccNewChartContainer" style="
                                height: 370px;
                                width: 100%;
                                margin-left: auto;
                                margin-right: auto;
                              ">
                              <img *ngIf="!showFFTDataChartEmpty_Vibration" class="chart_load"
                                src="./assets/chart_loader.gif" id="loader" />
                              <p *ngIf="showFFTDataChartEmpty_Vibration" class="no_avl_data_msg">
                                {{ vibrationNoDataMsg }}
                              </p>
                            </div>
                          </div> -->
                          <!--

                          <div class="summary_div">
                            <h4>Machine Diagnostics Summary:</h4>
                            <div class="table-responsive">
                              <table class="table">
                                <thead>
                                  <tr>
                                    <th>Machine Parameter</th>
                                    <th>Value</th>
                                    <th>Acceptable Limits</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td colspan="3"><span class="td_heading">Vibration - Acceleration
                                        (m/sec<sup>2</sup>)</span>
                                    </td>
                                  </tr>
                                  <tr *ngFor="let acceleration of mySensFFTAcceleration">
                                    <td>{{acceleration.label}}</td>
                                    <td>{{acceleration.value}}</td>
                                    <td>0 - {{acceleration.max_range}}</td>
                                  </tr>

                                  <tr>
                                    <td colspan="3"><span class="td_heading">Vibration Velocity (mm/sec)</span></td>
                                  </tr>
                                  <tr *ngFor="let velocity of mySensFFTVelocity">
                                    <td>{{velocity.label}}</td>
                                    <td>{{velocity.value}}</td>
                                    <td>0 - {{velocity.max_range}}</td>
                                  </tr>

                                  <tr>
                                    <td colspan="3"><span class="td_heading">Temperature (°C)</span></td>
                                  </tr>
                                  <tr *ngFor="let temp of mySensFFTTemperature">
                                    <td>{{temp.name}}</td>
                                    <td *ngIf="temp.value <= 0 || temp.value > 150;else actualValue">N/A</td>
                                    <ng-template #actualValue>
                                      <td>{{temp.value}}</td>
                                    </ng-template>
                                    <td>0 - {{temp.max_range}}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div> -->
                        </div>
                        <div class="col-sm-3 right">
                          <!-- <span
                            ><strong>Spectrum was analysed at:- </strong></span
                          > -->
                          <span class="red_color_bg" *ngIf="selectedFFTUID !== undefined; else showMsg2">{{spectrumAnalysisCase}}{{diagosticsCreateAtFFT}}</span>
                          <ng-template #showMsg2>
                            <span class="red_color_bg">Machine Diagnostics Analysis is incomplete. Please run SA-On Demand for
                              further processing.</span>
                          </ng-template>
                          <br /><br />
                          <h5 class="fft_heading">Crest Factor</h5>
                          <div class="table-responsive">
                            <table class="table frequency_tb">
                              <thead>
                                <tr>
                                  <th>Radial</th>
                                  <th>Tangential</th>
                                  <th>Axial</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngIf="!cresFactorEmpty">
                                  <td>{{ xcf }}</td>
                                  <td>{{ ycf }}</td>
                                  <td>{{ zcf }}</td>
                                </tr>
                                <tr *ngIf="cresFactorEmpty">
                                  <td colspan="3">
                                    <p style="text-align: center">
                                      Not Applicable.
                                    </p>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <h5 class="fft_heading">Predominant Frequencies</h5>
                          <div class="table-responsive">
                            <table class="table frequency_tb">
                              <thead>
                                <tr>
                                  <th class="middle_align" rowspan="2">
                                    Frequency<span>(Hz)</span>
                                  </th>
                                  <th>Radial</th>
                                  <th>Tangential</th>
                                  <th>Axial</th>
                                </tr>
                                <tr>
                                  <td>m/sec<sup>2</sup></td>
                                  <td>m/sec<sup>2</sup></td>
                                  <td>m/sec<sup>2</sup></td>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let xaxis of xaxisFrequency">
                                  <td>{{ xaxis.freq }}</td>
                                  <td>{{ xaxis["Acceleration 1 Z"] }}</td>
                                  <td>{{ xaxis["Acceleration 1 X"] }}</td>
                                  <td>{{ xaxis["Acceleration 1 Y"] }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </li>
                <li [ngbNavItem]="'innertab-3'" id="innertab-3" *ngIf="[2,3].includes(master_product_type)">
                  <a ngbNavLink>Ultrasonic Spectra</a>
                  <ng-template ngbNavContent>
                    <div class="row">
                      <div class="col-md-12 amp_chart_div">
                        <div class="col-sm-9 left">
                          <div class="amplitude_div">
                            <h5>Ultrasonic Spectra <span>(dB-A)</span></h5>
                            <div class="right_side">
                              <div class="btn-group tab_btn_group">
                                <button
                                  type="button"
                                  class="btn"
                                  (click)="ultraChartLayout()"
                                >
                                  <span
                                    class="sprite_icon wave_grey"
                                    [ngClass]="{ wave_blue: ultraChartViewOn }"
                                  ></span>
                                </button>
                                <button
                                  type="button"
                                  class="btn"
                                  (click)="ultralistLayout()"
                                >
                                  <span
                                    class="sprite_icon list_grey"
                                    [ngClass]="{ list_blue: ultraChartViewOff }"
                                  ></span>
                                </button>
                                <button
                                  type="button"
                                  class="btn"
                                  (click)="downloadChartData2('ultrasonic')"
                                >
                                  <span
                                    class="sprite_icon download_grey"
                                    [ngClass]="{
                                      download_blue: downloadUltraChartDataOn
                                    }"
                                  ></span>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div
                            class="line_chart_outer same"
                            *ngIf="ultraChartViewOn"
                          >
                            <div
                              id="ultrasoundFFTChartContainer"
                              style="
                                height: 370px;
                                width: 1336px !important;
                                margin-left: auto;
                                margin-right: auto;
                              "
                            >
                              <img
                                *ngIf="!showUltrasoundChartEmpty_Vibration"
                                class="chart_load"
                                src="./assets/chart_loader.gif"
                                id="loader"
                              />
                              <!-- <p
                                *ngIf="showUltrasoundChartEmpty_Vibration"
                                class="no_avl_data_msg"
                              >
                                {{ vibrationNoDataMsg }}
                              </p> -->
                              <p *ngIf="showUltrasoundChartEmpty_Vibration && !selectedFFTUIDAnomaly; else sec_msg" class="no_avl_data_msg">
                                No data available. SA - On Demand analysis not done yet.
                              </p>
                              <ng-template #sec_msg>
                                <p *ngIf="showUltrasoundChartEmpty_Vibration" class="no_avl_data_msg">
                                  No data available.
                                </p>
                              </ng-template>
                            </div>
                          </div>

                          <div
                            class="line_chart_outer tb"
                            *ngIf="ultraChartViewOff"
                          >
                            <div class="new_header">
                              <div class="title"></div>
                            </div>
                            <div class="table-responsive">
                              <table class="table line_chart_tb diag">
                                <thead>
                                  <tr>
                                    <th rowspan="2">Frequency(Hz)</th>
                                    <th colspan="3" class="text-center">
                                      Ultrasonic Spectra (dBV)
                                    </th>
                                  </tr>
                                  <tr>
                                    <td>dBV</td>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <table class="table child_tb">
                                        <tr
                                          *ngFor="let datay1 of listUltraData"
                                        >
                                          <td>{{ datay1.x }}</td>
                                        </tr>
                                      </table>
                                    </td>
                                    <td>
                                      <table class="table child_tb">
                                        <tr
                                          *ngFor="let datay1 of listUltraData"
                                        >
                                          <td>{{ datay1.y }}</td>
                                        </tr>
                                      </table>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <p
                                *ngIf="showUltrasoundChartEmpty_Vibration"
                                class="no_avl_data_msg"
                              >
                                {{ vibrationNoDataMsg }}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-3 right">
                          <!-- <span
                            ><strong>Spectrum was analysed at:- </strong></span
                          > -->
                          <span class="red_color_bg" *ngIf="selectedFFTUID !== undefined; else showMsg2">{{spectrumAnalysisCase}}{{diagosticsCreateAtFFT}}</span>
                          <ng-template #showMsg2>
                            <span class="red_color_bg">Machine Diagnostics Analysis is incomplete. Please run SA-On Demand for
                              further processing.</span>
                          </ng-template>
                          <br /><br />
                          <h5 class="fft_heading">Crest Factor</h5>
                          <div class="table-responsive">
                            <table class="table frequency_tb">
                              <thead>
                                <tr>
                                  <th>Radial</th>
                                  <th>Tangential</th>
                                  <th>Axial</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngIf="!cresFactorEmpty">
                                  <td>{{ xcf }}</td>
                                  <td>{{ ycf }}</td>
                                  <td>{{ zcf }}</td>
                                </tr>
                                <tr *ngIf="cresFactorEmpty">
                                  <td colspan="3">
                                    <p style="text-align: center">
                                      Not Applicable.
                                    </p>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <h5 class="fft_heading">Predominant Frequencies</h5>
                          <div class="table-responsive">
                            <table class="table frequency_tb">
                              <thead>
                                <tr>
                                  <th class="middle_align" rowspan="2">
                                    Frequency<span>(Hz)</span>
                                  </th>
                                  <th>Ultrasonic Spectra</th>
                                </tr>
                                <tr>
                                  <td>dB-A</td>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let xaxis of predUltraSoundFrq">
                                  <td>{{ xaxis.sno }}</td>
                                  <td>{{ xaxis.val }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </li >

                <li [ngbNavItem]="'innertab-4'"
                  id="innertab-4"
                  *ngIf="assetType == 'MOTOR'"
                  [disabled]="dc_motor"
                >
                  <a ngbNavLink>Magnetic Field Spectra</a>
                  <ng-template ngbNavContent>
                    <div class="row">
                      <div class="col-md-12 amp_chart_div">
                        <div class="col-sm-9 left">
                          <div class="amplitude_div">
                            <h5>
                              Magnetic Field Spectra<span> ( Gauss )</span>
                            </h5>
                            <div class="right_side">
                              <div class="btn-group tab_btn_group">
                                <button
                                  type="button"
                                  class="btn"
                                  (click)="magChartLayout()"
                                >
                                  <span
                                    class="sprite_icon wave_grey"
                                    [ngClass]="{ wave_blue: magChartViewOn }"
                                  ></span>
                                </button>
                                <button
                                  type="button"
                                  class="btn"
                                  (click)="maglistLayout()"
                                >
                                  <span
                                    class="sprite_icon list_grey"
                                    [ngClass]="{ list_blue: magChartViewOff }"
                                  ></span>
                                </button>
                                <button
                                  type="button"
                                  class="btn"
                                  (click)="downloadChartData2('magnetic')"
                                >
                                  <span
                                    class="sprite_icon download_grey"
                                    [ngClass]="{
                                      download_blue: downloadMagChartDataOn
                                    }"
                                  ></span>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div
                            class="line_chart_outer same"
                            *ngIf="magChartViewOn"
                          >
                            <div
                              id="magnetiFieldSpectraChartContainer"
                              style="
                               height: 370px;
                               width: 1336px !important;
                                margin-left: auto;
                                margin-right: auto;
                              "
                            >
                              <img
                                *ngIf="!showMagnetFieldChartEmpty"
                                class="chart_load"
                                src="./assets/chart_loader.gif"
                                id="loader"
                              />
                              <p *ngIf="showMagnetFieldChartEmpty && !selectedFFTUIDAnomaly; else sec_msg" class="no_avl_data_msg">
                                No data available. SA - On Demand analysis not done yet.
                              </p>
                              <ng-template #sec_msg>
                                <p *ngIf="showMagnetFieldChartEmpty" class="no_avl_data_msg">
                                  No data available.
                                </p>
                              </ng-template>
                            </div>
                          </div>

                          <div
                            class="line_chart_outer tb"
                            *ngIf="magChartViewOff"
                          >
                            <div class="new_header">
                              <div class="title"></div>
                            </div>
                            <div class="table-responsive">
                              <table class="table line_chart_tb diag">
                                <thead>
                                  <tr>
                                    <th rowspan="2">Frequency(Hz)</th>
                                    <th colspan="3" class="text-center">
                                      Magnetic Field Spectra (Gs)
                                    </th>
                                  </tr>
                                  <tr>
                                    <td>x</td>
                                    <td>y</td>
                                    <td>z</td>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <table class="table child_tb">
                                        <tr *ngFor="let datay1 of listMagData1">
                                          <td>{{ datay1.x }}</td>
                                        </tr>
                                      </table>
                                    </td>
                                    <td>
                                      <table class="table child_tb">
                                        <tr *ngFor="let datay1 of listMagData1">
                                          <td>{{ datay1.y }}</td>
                                        </tr>
                                      </table>
                                    </td>
                                    <td>
                                      <table class="table child_tb">
                                        <tr *ngFor="let datay2 of listMagData2">
                                          <td>{{ datay2.y }}</td>
                                        </tr>
                                      </table>
                                    </td>
                                    <td>
                                      <table class="table child_tb">
                                        <tr *ngFor="let datay3 of listMagData3">
                                          <td>{{ datay3.y }}</td>
                                        </tr>
                                      </table>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <p
                                *ngIf="showMagnetFieldChartEmpty"
                                class="no_avl_data_msg"
                              >
                                {{ magnetFieldNoDataMsg }}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-3 right">
                          <!-- <span
                            ><strong>Spectrum was analysed at:- </strong></span
                          > -->
                          <span class="red_color_bg" *ngIf="selectedFFTUID !== undefined; else showMsg2">{{spectrumAnalysisCase}}{{diagosticsCreateAtFFT}}</span>
                          <ng-template #showMsg2>
                            <span class="red_color_bg">Machine Diagnostics Analysis is incomplete. Please run SA-On Demand for
                              further processing.</span>
                          </ng-template>
                          <br /><br />
                          <h5 class="fft_heading">Crest Factor</h5>
                          <div class="table-responsive">
                            <table class="table frequency_tb">
                              <thead>
                                <tr>
                                  <th>Radial</th>
                                  <th>Tangential</th>
                                  <th>Axial</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngIf="!cresFactorEmpty">
                                  <td>{{ xcf }}</td>
                                  <td>{{ ycf }}</td>
                                  <td>{{ zcf }}</td>
                                </tr>
                                <tr *ngIf="cresFactorEmpty">
                                  <td colspan="3">
                                    <p style="text-align: center">
                                      Not Applicable.
                                    </p>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <h5 class="fft_heading">Predominant Frequencies</h5>
                          <div class="table-responsive">
                            <table class="table frequency_tb">
                              <thead>
                                <tr>
                                  <th class="middle_align" rowspan="2">
                                    Frequency<span>(Hz)</span>
                                  </th>
                                  <th>x</th>
                                  <th>y</th>
                                  <th>z</th>
                                </tr>
                                <tr>
                                  <td>Gauss</td>
                                  <td>Gauss</td>
                                  <td>Gauss</td>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let xaxis of magneticPredFreq">
                                  <td>{{ xaxis.freq }}</td>
                                  <td>{{ xaxis.X }}</td>
                                  <td>{{ xaxis.Y }}</td>
                                  <td>{{ xaxis.Z }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </li>

                <!---cepstrum spectra-->
                <li [ngbNavItem]="'innertab-6'" id="innertab-6" *ngIf="assetType == 'GEAR'" [disabled]="!softwareStatusMap['cepstrum']">
                  <a ngbNavLink>Cepstrum Spectra</a>
                  <ng-template ngbNavContent>
                    <div class="row">
                      <div class="col-md-12 amp_chart_div">
                        <div class="col-sm-9 left">
                          <div class="amplitude_div">
                            <h5>Cepstrum Spectra</h5>
                            <div class="right_side">
                              <div class="btn-group tab_btn_group">
                                <button
                                  type="button"
                                  class="btn"
                                  (click)="cepChartLayout()"
                                >
                                  <span
                                    class="sprite_icon wave_grey"
                                    [ngClass]="{ wave_blue: cepStrumViewOn }"
                                  ></span>
                                </button>
                                <button
                                  type="button"
                                  class="btn"
                                  (click)="cepstrumListLayout()"
                                >
                                  <span
                                    class="sprite_icon list_grey"
                                    [ngClass]="{ list_blue: cepStrumViewOff }"
                                  ></span>
                                </button>
                                <button
                                  type="button"
                                  class="btn"
                                  (click)="downloadChartData2('cepstrum')"
                                >
                                  <span
                                    class="sprite_icon download_grey"
                                    [ngClass]="{
                                      download_blue: downloadMagChartDataOn
                                    }"
                                  ></span>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div
                            class="line_chart_outer same"
                            *ngIf="cepStrumViewOn"
                          >
                            <div
                              id="cepstrumChartId"
                              style="
                               height: 370px;
                               width: 1336px !important;
                                margin-left: auto;
                                margin-right: auto;
                              "
                            >
                              <img
                                *ngIf="!showCepstrumFieldChartEmpty"
                                class="chart_load"
                                src="./assets/chart_loader.gif"
                                id="loader"
                              />
                              <!-- <p
                                *ngIf="showCepstrumFieldChartEmpty"
                                class="no_avl_data_msg"
                              >
                                Advance Gearbox analysis indicates a good
                                gear-tooth health.
                              </p> -->

                              <p *ngIf="showCepstrumFieldChartEmpty && !selectedFFTUIDAnomaly; else sec_msg" class="no_avl_data_msg">
                                No data available. SA - On Demand analysis not done yet.
                              </p>
                              <ng-template #sec_msg>
                                <p *ngIf="showCepstrumFieldChartEmpty" class="no_avl_data_msg">
                                  No data available.
                                </p>
                              </ng-template>

                            </div>
                          </div>
                          <div
                            class="line_chart_outer tb"
                            *ngIf="cepStrumViewOff"
                          >
                            <div class="new_header">
                              <div class="title"></div>
                            </div>
                            <div class="table-responsive">
                              <table class="table line_chart_tb diag">
                                <thead>
                                  <tr>
                                    <th rowspan="2">Quefrency(Sec)</th>
                                    <th colspan="3" class="text-center">
                                      Cepstrum Spectra Field
                                    </th>
                                  </tr>
                                  <tr>
                                    <td>x</td>
                                    <td>y</td>
                                    <td>z</td>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <table class="table child_tb">
                                        <tr *ngFor="let datay1 of cepListData1">
                                          <td>{{ datay1.x }}</td>
                                        </tr>
                                      </table>
                                    </td>
                                    <td>
                                      <table class="table child_tb">
                                        <tr *ngFor="let datay1 of cepListData1">
                                          <td>{{ datay1.y }}</td>
                                        </tr>
                                      </table>
                                    </td>
                                    <td>
                                      <table class="table child_tb">
                                        <tr *ngFor="let datay2 of cepListData2">
                                          <td>{{ datay2.y }}</td>
                                        </tr>
                                      </table>
                                    </td>
                                    <td>
                                      <table class="table child_tb">
                                        <tr *ngFor="let datay3 of cepListData3">
                                          <td>{{ datay3.y }}</td>
                                        </tr>
                                      </table>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <!-- <div class="issue_div">
                            <div class="inner">
                              <div class="left_side">
                                <h5>
                                  Advanced Gearbox Diagnostics Analysis was performed at:
                                  <span>{{ fftLabelValue }}</span>
                                </h5>
                                <h5 *ngIf="cepsturmError != ''; else showFaultAsOne">
                                  The System Diagnosed Early-stage Issue:
                                  <span class="yellow_color_bg">{{ cepsturmError }}
                                    <span *ngIf="!setErrorStateOne" [matMenuTriggerFor]="menuFalultOne"
                                      data-toggle="dropdown" #locationMenuTrigger1="matMenuTrigger" class="hover_icon"
                                      style="cursor: pointer" (mouseenter)="
                                          locationMenuTrigger1.openMenu()
                                        " (mouseleave)="
                                          locationMenuTrigger1.closeMenu()
                                        "><img class="infoicon" src="./assets/information-button.png" /></span>
                                  </span>
                                </h5>
                                <ng-template #showFaultAsOne>
                                  <h5>
                                    The System Diagnosed Early-stage Issue:
                                    <span class="green_color_bg">N/A (Machine is currently healthy)</span>
                                  </h5>
                                </ng-template>
                                <div>
                                  <mat-menu class="f_detail" #menuFalultOne="matMenu">
                                    <ul class="read_more_ul">
                                      <li *ngFor="let sperFor of faults_info_one">
                                        <span class="tag">{{
                                          sperFor.tag
                                          }}</span>
                                        : {{ sperFor.summary }}
                                      </li>
                                    </ul>
                                  </mat-menu>
                                </div>
                                <h5 *ngIf="_observe_value != ''; else showFaultAs">
                                  The conditions to observe are:
                                  <span class="yellow_color_bg">{{ _observe_value }}
                                    <span *ngIf="!setErrorStateTwo" [matMenuTriggerFor]="menuFalult"
                                      #locationMenuTrigger="matMenuTrigger" data-toggle="dropdown" class="hover_icon"
                                      style="cursor: pointer" (mouseenter)="
                                          locationMenuTrigger.openMenu()
                                        " (mouseleave)="
                                          locationMenuTrigger.closeMenu()
                                        "><img class="infoicon" src="./assets/information-button.png" /></span>
                                  </span>
                                </h5>
                                <ng-template #showFaultAs>
                                  <h5>
                                    The conditions to observe are:
                                    <span class="yellow_color_bg">N/A</span>
                                  </h5>
                                </ng-template>
                                <div>
                                  <mat-menu class="f_detail" #menuFalult="matMenu" overlapTrigger="false">
                                    <span>
                                      <ul class="read_more_ul">
                                        <li *ngFor="let sperFor of faults_info">
                                          <span class="tag">{{
                                            sperFor.tag
                                            }}</span>: {{ sperFor.summary }}
                                        </li>
                                      </ul>
                                    </span>
                                  </mat-menu>
                                </div>
                              </div>
                              <div class="right_side">
                                <a [class.disabled]="onoffStatus === 2" *ngIf="hideDownloadBtn && onoffStatus === 2"
                                  class="download" (click)="getDeviceReport()">
                                  <span class="sprite_icon download_grey m_r_5" style="color: #80868b;"></span><span
                                    style="color: #80868b;">Download Report</span>
                                </a>
                                <a *ngIf="hideDownloadBtn && (onoffStatus === 0 || onoffStatus === 1)" class="download"
                                  (click)="getDeviceReport()">
                                  <span class="sprite_icon download_blue m_r_5"></span>Download Report
                                </a>
                                <span *ngIf="hideDownloadBtn === false" style="color: green">
                                  {{ showReportMsg }}
                                </span>
                              </div>
                            </div>
                          </div> -->
                        </div>

                        <div class="col-sm-3 right">
                          <div class="amplitude_div">
                            <!-- <div class="right_side"> -->
                            <!-- <span
                              ><strong
                                >Spectrum was analysed at:-
                              </strong></span
                            > -->
                            <span class="red_color_bg" *ngIf="selectedFFTUID !== undefined; else showMsg2">{{spectrumAnalysisCase}}{{diagosticsCreateAtFFT}}</span>
                          <ng-template #showMsg2>
                            <span class="red_color_bg">Machine Diagnostics Analysis is incomplete. Please run SA-On Demand for
                              further processing.</span>
                          </ng-template>
                            <br /><br />
                            <!-- <span class="custom_select_outer">
                                <select [(ngModel)]="selectedFFTUIDPeriodic" class="custom_select form-control"
                                  style="width: 130px !important" #selectValue (change)="t.select('innertab-1')"
                                  (change)="
                                      loadFftData(selectValue.value, 'periodic')
                                    ">
                                  <option class="dropdown-item" disabled selected value="null">
                                    Select an Option
                                  </option>
                                  <option *ngFor="let item of trendAnalysDataPeriodic" [value]="item.value">
                                    {{ item.label }}
                                  </option>
                                </select>
                              </span> -->
                            <!-- <button [disabled]="loaderAddClass === 'refresh_move'" class="btn default_btn"
                                mat-raised-button (click)="pageReload()">
                                Cepstrum SA:
                                <i class="material-icons icon-layout-custom" style="
                                      vertical-align: bottom;
                                      margin-left: 5px;
                                    " [ngClass]="loaderAddClass">refresh</i>
                              </button> -->
                            <!-- </div> -->
                          </div>
                          <!-- <div class="amplitude_div" style="margin-left:200px; margin-top:-45px">
                            <div class="right_side">

                              <span class="custom_select_outer">
                                <select [(ngModel)]="selectedFFTUIDAnomaly" class="custom_select form-control"
                                  style="width: 130px !important" #selectValue2
                                  (change)="loadFftData(selectValue2.value, 'anomaly')"
                                  (change)="insideTabChange('innertab-6')">
                                  <option class="dropdown-item" disabled selected value="null">
                                    Select an Option
                                  </option>
                                  <option *ngFor="let item of trendAnalysDataAnomaly" [value]="item.value">
                                    {{"Cepstrum SA:"+ item.label }}
                                  </option>
                                </select>
                              </span>
                            </div>
                          </div> -->
                          <h5 class="fft_heading">Crest Factor</h5>
                          <div class="table-responsive">
                            <table class="table frequency_tb">
                              <thead>
                                <tr>
                                  <th>Radial</th>
                                  <th>Tangential</th>
                                  <th>Axial</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngIf="!cresFactorEmpty">
                                  <td>{{ xcf }}</td>
                                  <td>{{ ycf }}</td>
                                  <td>{{ zcf }}</td>
                                </tr>
                                <tr *ngIf="cresFactorEmpty">
                                  <td colspan="3">
                                    <p style="text-align: center">
                                      Not Applicable.
                                    </p>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>

                        <div class="col-sm-3 right">

                          <h5 class="fft_heading">Predominant Frequencies</h5>
                          <div class="table-responsive">
                            <table class="table frequency_tb">
                              <thead>
                                <tr>
                                  <th class="middle_align" rowspan="2">
                                    Quefrency<span>(Sec)</span>
                                  </th>
                                  <th>Radial</th>
                                  <th>Tangential</th>
                                  <th>Axial</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let xaxis of cepStrumPredFreq">
                                  <td>{{ xaxis.freq }}</td>
                                  <td>{{ xaxis.X }}</td>
                                  <td>{{ xaxis.Y }}</td>
                                  <td>{{ xaxis.Z }}</td>
                                </tr>
                                <tr *ngIf="cepstrumProdEmpty">
                                  <td colspan="5">
                                    <p style="text-align: center">
                                      Not Applicable.
                                    </p>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </li>
                <li [ngbNavItem]="'innertab-7'"
                  id="innertab-7"
                  [disabled]="!softwareStatusMap['kurtosis']"
                  >
                  <!-- [disabled]="!softwareStatusMap['kurtosis'] && !AdvanceDiagnosticsDisabled " -->
                  <!-- [matTooltip]="
                    !softwareStatusMap['kurtosis']
                      ? null
                      : AdvanceDiagnosticsDisabled ?'Provide the accurate ball bearing numbers in the Edit screen to enable this tab':null
                  " -->
                  <a ngbNavLink> Bearing Analysis </a>
                  <ng-template ngbNavContent>
                    <div class="fixed_status_bar">
                      <div class="info_box_outer">
                        <div class="info_box">
                          <h4 *ngIf="!monitoringDeviceDetailsLoader; else loading">
                            {{ monitoringDeviceDetails?.companyName?.company_name || "N/A" }}
                          </h4>
                          <ng-template #loading>
                            <div class="skeleton skeleton-service-text-device-details"></div>
                          </ng-template>
                          <h6>Customer</h6>
                        </div>
                        <div class="info_box">
                          <h4 *ngIf="!monitoringDeviceDetailsLoader; else loading">
                            {{ monitoringDeviceDetails?.assetDetails?.site_name || "N/A" }}
                          </h4>
                          <ng-template #loading>
                            <div class="skeleton skeleton-service-text-device-details"></div>
                          </ng-template>
                          <h6>Site</h6>
                        </div>
                        <div class="info_box">
                          <h4 *ngIf="!monitoringDeviceDetailsLoader; else loading">
                            {{ monitoringDeviceDetails?.assetDetails?.application_name || "N/A" }}
                          </h4>
                          <ng-template #loading>
                            <div class="skeleton skeleton-service-text-device-details"></div>
                          </ng-template>
                          <h6>Application</h6>
                        </div>
                        <div class="info_box">
                          <div class="inner">
                            <div class="lft">
                              <!-- <h4>{{ monitoringDeviceDetails?.assetDetails?.motor_make || "N/A" }}</h4>
                              <h6>Machine Make</h6> -->
                              <h4 *ngIf="!monitoringDeviceDetailsLoader; else loading">
                                {{ monitoringDeviceDetails?.assetDetails?.motor_make || "N/A" }}
                              </h4>
                              <ng-template #loading>
                                <div class="skeleton skeleton-service-text-device-details"></div>
                              </ng-template>
                              <h6>Machine Make</h6>
                            </div>
                            <div
                              class="rgt"
                              (click)="goToImageLink(_imgUrl)"
                              style="cursor: pointer"
                            >
                              <img
                                [src]="_imgUrl"
                                alt="User"
                                class="thumb"
                                onerror="this.src='./assets/img-new/assets.png'"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="info_box">
                          <h4 *ngIf="!monitoringDeviceDetailsLoader; else loading">
                            {{ monitoringDeviceDetails?.assetDetails?.motor_serial_no || "N/A" }}
                          </h4>
                          <ng-template #loading>
                            <div class="skeleton skeleton-service-text-device-details"></div>
                          </ng-template>
                          <h6>Machine Serial Number</h6>
                        </div>
                        <div class="info_box">
                          <h4 *ngIf="!monitoringDeviceDetailsLoader; else loading">
                            {{ monitoringDeviceDetails?.assetDetails?.name || "N/A" }}
                          </h4>
                          <ng-template #loading>
                            <div class="skeleton skeleton-service-text-device-details"></div>
                          </ng-template>
                          <h6>Asset Name</h6>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="new_header header_absolute">
                        <div class="btn-group tab_btn_group custom-pb-5">
                          <!-- Hourly -->
                          <button *ngIf="kurtColor1 === 'active'"
                                  mat-raised-button
                                  color="primary"
                                  (click)="selectKurtosisNumber('Hourly')">
                            Hourly
                          </button>
                          <button *ngIf="kurtColor1 !== 'active'"
                                  mat-stroked-button
                                  color="primary"
                                  (click)="selectKurtosisNumber('Hourly')">
                            Hourly
                          </button>

                          <!-- Daily -->
                          <button *ngIf="kurtColor2 === 'active'"
                                  mat-raised-button
                                  color="primary"
                                  (click)="selectKurtosisNumber('Daily')">
                            Daily
                          </button>
                          <button *ngIf="kurtColor2 !== 'active'"
                                  mat-stroked-button
                                  color="primary"
                                  (click)="selectKurtosisNumber('Daily')">
                            Daily
                          </button>

                          <!-- Weekly -->
                          <button *ngIf="kurtColor3 === 'active'"
                                  mat-raised-button
                                  color="primary"
                                  (click)="selectKurtosisNumber('Weekly')">
                            Weekly
                          </button>
                          <button *ngIf="kurtColor3 !== 'active'"
                                  mat-stroked-button
                                  color="primary"
                                  (click)="selectKurtosisNumber('Weekly')">
                            Weekly
                          </button>
                        </div>

                        <div class="absolute_inner">
                          <div class="title">Kurtosis (Trend)</div>
                          <div class="tools">
                            <div class="btn-group tab_btn_group">
                              <button
                                type="button"
                                class="btn"
                                (click)="preKurtosisLayout()"
                              >
                                <span
                                  class="sprite_icon wave_grey"
                                  [ngClass]="{ wave_blue: predictiveKurtOn }"
                                ></span>
                              </button>
                              <button
                                type="button"
                                class="btn"
                                (click)="preKurtlistLayout()"
                              >
                                <span
                                  class="sprite_icon list_grey"
                                  [ngClass]="{
                                    list_blue: preKurtosisListLayoutOn
                                  }"
                                ></span>
                              </button>
                              <button
                                type="button"
                                class="btn"
                                (click)="downloadChartData7()"
                              >
                                <span
                                  class="sprite_icon download_grey"
                                  [ngClass]="{
                                    download_blue: downloadChartDataOn
                                  }"
                                ></span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="line_chart_outer p_t_20"
                        *ngIf="predictiveKurtOn"
                      >
                          <img
                            *ngIf="KurtNumloader"
                            class="chart_load"
                            src="./assets/chart_loader.gif"
                            id="loader"
                          />
                        <div
                          class="trand_chart_box"
                          id="predictiveKurtChartContainer"
                        >
                          <p
                            *ngIf="emptyMsgKurtNum === false"
                            style="
                              text-align: center;
                              font-size: 16px;
                              vertical-align: middle;
                              line-height: 300px;
                              color: #838383;
                            "
                          >
                            Machine is healthy and Advanced Diagnostic is not
                            required.
                          </p>
                        </div>
                      </div>

                      <div
                        class="line_chart_outer tb"
                        *ngIf="preKurtosisListLayoutOn"
                      >
                        <div class="new_header">
                          <div class="title"></div>
                        </div>
                        <div class="table-responsive">
                          <!-- <table class="table line_chart_tb" mat-table [dataSource]="listPredKurtData1">

                            <ng-container matColumnDef="time">
                              <th mat-header-cell *matHeaderCellDef>Time Stamp</th>
                              <td mat-cell *matCellDef="let element">{{element.d}}</td>
                            </ng-container>
                            <ng-container matColumnDef="radial">
                              <th mat-header-cell *matHeaderCellDef>Radial</th>
                              <td mat-cell *matCellDef="let element">{{element.c1}}</td>
                            </ng-container>
                            <ng-container matColumnDef="tangential">
                              <th mat-header-cell *matHeaderCellDef>Tangential</th>
                              <td mat-cell *matCellDef="let element">{{element.c2}}</td>
                            </ng-container>
                            <ng-container matColumnDef="axial">
                              <th mat-header-cell *matHeaderCellDef>Axial</th>
                              <td mat-cell *matCellDef="let element">{{element.c3}}</td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                          </table> -->
                          <table class="table line_chart_tb">
                            <thead>
                              <tr>
                                <th>Time Stamp</th>
                                <th>Radial</th>
                                <th>Tangential</th>
                                <th>Axial</th>
                              </tr>
                            </thead>
                            <tbody *ngIf="emptyMsgKurtNum; else elseBlock">
                              <tr *ngFor="let element of listPredKurtData1">
                                <td>{{ element.d }}</td>
                                <td>{{ element.c1 }}</td>
                                <td>{{ element.c2 }}</td>
                                <td>{{ element.c3 }}</td>
                              </tr>
                            </tbody>
                            <tbody>
                              <ng-template #elseBlock>
                                <tr>
                                  <td colspan="4" class="errorDisplay">
                                    Machine is healthy and Advanced Diagnostic
                                    is not required.
                                  </td>
                                </tr>
                              </ng-template>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <!-- <div
                        *ngFor="
                          let element of listPredKurtData1;
                          let last = last
                        "
                      >
                        <ng-container
                          *ngIf="
                            last &&
                            (element.c1 <= 4 ||
                              element.c2 <= 4 ||
                              element.c3 <= 4)
                          "
                        >
                          <h5>
                            Bearings are healthy based on advance bearing health
                            analysis.
                          </h5>
                        </ng-container>
                      </div> -->
                      <div *ngIf="ballBearingErrorMessage != ''; else noerror">
                        <h5><span style="background-color: #FEA934;">{{ballBearingErrorMessage}}</span></h5>
                      </div>
                      <ng-template #noerror>
                          <h5>
                            Bearings are healthy based on advance bearing health
                            analysis.
                          </h5>
                      </ng-template>
                      <div class="col-md-12" style="display: inline-block">
                        <div
                          class="col-sm-5"
                          style="
                            display: inline-block;
                            position: relative;
                            top: 30px;
                          "
                        >
                          <!-- <div class="amplitude_div" style="display:inline-block">
                            <div class="right_side">
                             <span class="custom_select_outer">
                              <select [(ngModel)]="selectedFFTUIDPeriodic" class="custom_select form-control"
                                style="width: 130px !important" #selectValue (change)="t.select('innertab-1')"
                                (change)="
                              loadFftData(selectValue.value, 'periodic')
                            " [disabled]="true">
                                <option class="dropdown-item" disabled selected value="null">
                                  Select an Option
                                </option>
                                <option *ngFor="let item of trendAnalysDataPeriodic" [value]="item.value">
                                  {{ item.label }}
                                </option>
                              </select>
                            </span> -->
                          <!-- <button [disabled]="loaderAddClass === 'refresh_move'" class="btn default_btn"
                              mat-raised-button (click)="fftForAdvanceDiagnostics()">
                              SA - On Demand
                              <i class="material-icons icon-layout-custom" style="
                              vertical-align: bottom;
                              margin-left: 5px;
                            " [ngClass]="loaderAddClass">refresh</i>
                            </button>
                            </div>
                          </div> -->

                          <div class="col-sm-3" style="display: inline-block">
                            <h5 class="fft_heading">Kurtosis Number</h5>
                            <div
                              class="table-responsive"
                              style="width: 412px; margin-bottom: 2rem"
                            >
                              <table class="table frequency_tb">
                                <thead>
                                  <tr>
                                    <th>Radial</th>
                                    <th>Tangential</th>
                                    <th>Axial</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr *ngIf="!advCrestFactor">
                                    <td>{{ x_kurtosis }}</td>
                                    <td>{{ y_kurtosis }}</td>
                                    <td>{{ z_kurtosis }}</td>
                                  </tr>
                                  <tr *ngIf="advCrestFactor">
                                    <td colspan="3">
                                      <p style="text-align: center">
                                        No data available.
                                      </p>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="new_header" style="width: 75%">
                        <div
                          class=""
                          style="
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                          "
                        >
                          <div class="title font_20 m_b_0">
                            Envelop Analysis
                          </div>
                          <div *ngIf="fftCreateAt" class="title font_20 m_b_0">
                            Spectrum was done on:
                            {{ fftCreateAt }}
                          </div>
                        </div>
                        <!-- <div class="lf_rg_detail">
                          <ul>
                            <li *ngIf="maxRPMValue === null">
                              Rated RPM: <span>{{ _rated_rpm }}</span>
                            </li>
                            <li *ngIf="maxRPMValue !== null">
                              Min Rated RPM: <span>{{ minRPMValue }}</span>
                            </li>
                            <li *ngIf="maxRPMValue !== null">
                              Max Rated RPM: <span>{{ maxRPMValue }}</span>
                            </li>
                            <li>
                              Actual RPM: <span>{{ _actualrpm }}</span>
                            </li>
                            <li>
                              Rated Line Freq: <span>{{ _line_frequency }}</span>
                            </li>
                            <li>
                              Operating Line Freq:
                              <span>{{ OperatingLineFrequency }}</span>
                            </li>
                            <li>
                              KW Rating: <span>{{ kwrating }}</span>
                            </li>
                          </ul>
                        </div> -->
                      </div>
                      <ul ngbNav
                      #ctdTabset="ngbNav"
                      class="custom_tab nav-v nav-tabs"
                        [activeId]="1" class="simple_custom_tab">
                        <li [ngbNavItem]="1">
                          <a ngbNavLink
                            >Envelop analysis</a
                          >
                          <ng-template ngbNavContent>
                            <div class="row">
                              <div class="col-md-12 amp_chart_div" style="padding-left: 10px; padding-right: 10px;">
                                <div class="col-md-9">
                                  <div class="amplitude_div">
                                    <h5>Envelop Analysis</h5>
                                    <h6>
                                      <input
                                        [disabled]="
                                          (assetType == 'GEAR' &&
                                            pinion_gear_actual_rpm == 0) ||
                                          envelopAnalysisError != undefined
                                        "
                                        type="checkbox"
                                        [(ngModel)]="rmptoggleEnvelop"
                                        (change)="rmpValueShowHideEnvelop()"
                                        [matTooltip]="
                                          (assetType == 'GEAR' &&
                                            pinion_gear_actual_rpm == 0) ||
                                          envelopAnalysisError
                                            ? 'Envelop analysis is not done yet.'
                                            : ''
                                        "
                                      />
                                      1x
                                    </h6>
                                    <h6>
                                      <input
                                        [disabled]="
                                          bearingStripLine.length < 0 ||
                                          envelopAnalysisError
                                        "
                                        type="checkbox"
                                        [(ngModel)]="bFreqtoggleEnvelop"
                                        (change)="bFreqValueShowHideEnvelop()"
                                        [matTooltip]="
                                          bearingStripLine.length < 0 ||
                                          envelopAnalysisError
                                            ? 'Envelop Analysis is not done yet.'
                                            : ''
                                        "
                                      />
                                      Bearing Frequencies
                                    </h6>
                                    <div class="right_side">
                                      <div class="btn-group tab_btn_group">
                                        <button
                                          type="button"
                                          class="btn"
                                          (click)="KurtosisLayout()"
                                        >
                                          <span
                                            class="sprite_icon wave_grey"
                                            [ngClass]="{
                                              wave_blue: diagKurtOn
                                            }"
                                          ></span>
                                        </button>
                                        <button
                                          type="button"
                                          class="btn"
                                          (click)="KurtosislistLayout()"
                                        >
                                          <span
                                            class="sprite_icon list_grey"
                                            [ngClass]="{
                                              list_blue: diagKurtOff
                                            }"
                                          ></span>
                                        </button>
                                        <button
                                          type="button"
                                          class="btn"
                                          (click)="
                                            downloadChartData2('Kurtosis')
                                          "
                                        >
                                          <span
                                            class="sprite_icon download_grey"
                                            [ngClass]="{
                                              download_blue:
                                                downloadMagChartDataOn
                                            }"
                                          ></span>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="line_chart_outer same"
                                    *ngIf="diagKurtOn"
                                  >
                                    <div
                                      id="KurtosisSpectraChartContainer"
                                      style="
                                        height: 370px;
                                        width: 100%;
                                        margin-left: auto;
                                        margin-right: auto;
                                      "
                                    >
                                      <img
                                        *ngIf="showDiagnosticChartEmpty"
                                        class="chart_load"
                                        src="./assets/chart_loader.gif"
                                        id="loader"
                                      />
                                      <p
                                        *ngIf="emptyMsgAlertKurt2"
                                        class="no_avl_data_msg"
                                      >
                                        {{ envelopAnalysisError }}
                                      </p>
                                    </div>
                                  </div>

                                  <div
                                    class="line_chart_outer tb"
                                    *ngIf="diagKurtOff"
                                  >
                                    <div class="new_header">
                                      <div class="title"></div>
                                    </div>
                                    <div class="table-responsive">
                                      <table class="table line_chart_tb diag">
                                        <thead>
                                          <tr>
                                            <th rowspan="2">Frequency(Hz)</th>
                                            <th colspan="3" class="text-center">
                                              Envelop Analysis
                                            </th>
                                          </tr>
                                          <tr>
                                            <td>Radial</td>
                                            <td>Tangential</td>
                                            <td>Axial</td>
                                          </tr>
                                        </thead>

                                        <tbody
                                          *ngIf="
                                            !emptyMsgAlertKurt2;
                                            else elseBlock
                                          "
                                        >
                                          <tr>
                                            <td>
                                              <table class="table child_tb">
                                                <tr
                                                  *ngFor="
                                                    let datay1 of datadiagKurtPoints1
                                                  "
                                                >
                                                  <td>{{ datay1.x }}</td>
                                                </tr>
                                              </table>
                                            </td>
                                            <td>
                                              <table class="table child_tb">
                                                <tr
                                                  *ngFor="
                                                    let datay1 of datadiagKurtPoints1
                                                  "
                                                >
                                                  <td>{{ datay1.y }}</td>
                                                </tr>
                                              </table>
                                            </td>
                                            <td>
                                              <table class="table child_tb">
                                                <tr
                                                  *ngFor="
                                                    let datay2 of datadiagKurtPoints2
                                                  "
                                                >
                                                  <td>{{ datay2.y }}</td>
                                                </tr>
                                              </table>
                                            </td>
                                            <td>
                                              <table class="table child_tb">
                                                <tr
                                                  *ngFor="
                                                    let datay3 of datadiagKurtPoints3
                                                  "
                                                >
                                                  <td>{{ datay3.y }}</td>
                                                </tr>
                                              </table>
                                            </td>
                                          </tr>
                                        </tbody>
                                        <tbody>
                                          <ng-template #elseBlock>
                                            <tr>
                                              <td colspan="4">
                                                <p
                                                  style="
                                                    height: 275px;
                                                    width: 100%;
                                                    margin-left: auto;
                                                    margin-right: auto;
                                                    margin-top: 76px;
                                                    text-align: center;
                                                  "
                                                >
                                                  {{ envelopAnalysisError }}
                                                </p>
                                              </td>
                                            </tr>
                                          </ng-template>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>

                                <!-- <div class="col-sm-3 right">

                                  <div class="amplitude_div">
                                    <div class="right_side">
                                      <span class="custom_select_outer">
                                        <select [(ngModel)]="selectedFFTUIDPeriodic" class="custom_select form-control"
                                          style="width: 130px !important" #selectValue (change)="t.select('innertab-1')"
                                          (change)="
                                        loadFftData(selectValue.value, 'periodic')
                                      " [disabled]="true">
                                          <option class="dropdown-item" disabled selected value="null">
                                            Select an Option
                                          </option>
                                          <option *ngFor="let item of trendAnalysDataPeriodic" [value]="item.value">
                                            {{ item.label }}
                                          </option>
                                        </select>
                                      </span>
                                      <button [disabled]="loaderAddClass === 'refresh_move'" class="btn default_btn"
                                        mat-raised-button (click)="fftForAdvanceDiagnostics()">
                                        SA - On Demand
                                        <i class="material-icons icon-layout-custom" style="
                                        vertical-align: bottom;
                                        margin-left: 5px;
                                      " [ngClass]="loaderAddClass">refresh</i>
                                      </button>
                                    </div>
                                  </div>
                                  <div class="amplitude_div">
                                    <div class="right_side">
                                      <span class="custom_select_outer">
                                        <select  class="custom_select form-control"
                                          style="width: 130px !important" #selectValue2 (change)="t.select('innertab-1')"
                                          (change)="
                                          loadFftAdvanceDiag(selectValue2.value)
                                      ">
                                          <option *ngIf="fftAdvEmpty" class="dropdown-item" disabled selected value="null">
                                            Select an Option
                                          </option>
                                          <option *ngFor="let item of AdvanceDiagFftData; let i=index" [value]="item.value">
                                            {{ item.label }}
                                          </option>
                                        </select>
                                      </span>
                                    </div>
                                  </div>
                                  <h5 class="fft_heading"> Kurtosis Number</h5>
                                  <div class="table-responsive">
                                    <table class="table frequency_tb">
                                      <thead>
                                        <tr>
                                          <th>x</th>
                                          <th>y</th>
                                          <th>z</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr *ngIf="!advCrestFactor">
                                          <td>{{x_kurtosis}}</td>
                                          <td>{{y_kurtosis}}</td>
                                          <td>{{z_kurtosis}}</td>
                                        </tr>
                                        <tr *ngIf="advCrestFactor">
                                          <td colspan="3">
                                            <p style="text-align: center; ">No data available.</p>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                  <h5 class="fft_heading">Predominant Frequencies</h5>
                                  <div class="table-responsive">
                                    <table class="table frequency_tb">
                                      <thead>
                                        <tr>
                                          <th class="middle_align" rowspan="2">
                                            Frequency<span>(Hz)</span>
                                          </th>
                                          <th>x</th>
                                          <th>y</th>
                                          <th>z</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr class="no_avl_data_msg_predom" *ngIf="
                                        chartBoxVisibility == false;
                                        else preDomData
                                      ">
                                          <td colspan="4">{{ errmsg }}</td>
                                        </tr>
                                        <ng-template #preDomData>
                                          <tr *ngFor="let xaxis of xaxisFrequency">
                                            <td>{{ xaxis.frequency }}</td>
                                            <td>{{ xaxis.x }}</td>
                                            <td>{{ xaxis.y }}</td>
                                            <td>{{ xaxis.z }}</td>
                                          </tr>
                                        </ng-template>
                                      </tbody>
                                    </table>
                                  </div>
                                </div> -->
                                <div
                                  class="col-sm-3 right"
                                  style="margin-top: -562px"
                                >
                                  <h4 class="fft_heading">
                                    Bearing Frequencies
                                  </h4>
                                  <table class="table frequency_tb">
                                    <tbody>
                                      <tr
                                        *ngIf="
                                          bearingFreqVal == '';
                                          else showffttable
                                        "
                                      >
                                        <td
                                          colspan="4"
                                          style="
                                            font-size: 20px;
                                            font-weight: 900;
                                          "
                                        >
                                          No bearing number is provided during
                                          configuration.
                                        </td>
                                      </tr>
                                      <tr
                                        #showffttable
                                        *ngFor="let val of bearingFreqVal"
                                      >
                                        <td colspan="4">
                                          <table style="width: 100%">
                                            <tbody>
                                              <tr>
                                                <td colspan="4">
                                                  <span class="inner_h">{{
                                                    val.label
                                                  }}</span>
                                                </td>
                                              </tr>

                                              <tr>
                                                <td>Outer Race</td>
                                                <td>Inner Race</td>
                                                <td>Ball Cage</td>
                                                <td>Ball Spin</td>
                                              </tr>
                                              <tr class="no_border_tr">
                                                <td
                                                  *ngFor="let v of val.values"
                                                >
                                                  {{ v }}
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </ng-template>
                        </li>

                      </ul>
                      <div [ngbNavOutlet]="ctdTabset"></div>
                    </div>
                  </ng-template>
                </li>
                <li [ngbNavItem]="'innertab-8'"
                  #myDiv
                  id="innertab-8"
                  *ngIf="!production && assetType == 'MOTOR'"
                  [disabled]="ESADisabled"
                >
                  <a ngbNavLink
                    >Electrical Signature Analysis</a
                  >
                  <ng-template ngbNavContent>
                    <div class="fixed_status_bar">
                      <div class="info_box_outer">
                        <div class="info_box">
                          <h4>{{ company_name }}</h4>
                          <h6>Customer</h6>
                        </div>
                        <div class="info_box">
                          <h4>{{ monitorInfo?.site_name || "N/A" }}</h4>
                          <h6>Site</h6>
                        </div>
                        <div class="info_box">
                          <h4>{{ monitorInfo?.application_name || "N/A" }}</h4>
                          <h6>Application</h6>
                        </div>
                        <div class="info_box">
                          <div class="inner">
                            <div class="lft">
                              <h4>{{ monitorInfo?.machine_make || "N/A" }}</h4>
                              <h6>Machine Make</h6>
                            </div>
                            <div
                              class="rgt"
                              (click)="goToImageLink(_imgUrl)"
                              style="cursor: pointer"
                            >
                              <img
                                [src]="_imgUrl"
                                alt="User"
                                class="thumb"
                                onerror="this.src='./assets/img-new/assets.png'"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="info_box">
                          <h4>
                            {{ monitorInfo?.motor_serial_number || "N/A" }}
                          </h4>
                          <h6>Machine Serial Number</h6>
                        </div>
                        <div class="info_box">
                          <h4 *ngIf="!monitoringDeviceDetailsLoader; else loading">
                            {{ monitoringDeviceDetails?.assetDetails?.name || "N/A" }}
                          </h4>
                          <ng-template #loading>
                            <div class="skeleton skeleton-service-text-device-details"></div>
                          </ng-template>
                          <h6>Asset Name</h6>
                        </div>
                      </div>
                    </div>

                    <div class="inner_gauge_box">
                      <div
                        class="new_header"
                        *ngIf="
                          assetType === 'FAN_BLOWER' ||
                          assetType === 'PUMP' ||
                          assetType === 'COMPRESSOR' ||
                          assetType === 'JOURNAL_BEARING'
                        "
                      >
                        <div class="title font_20 m_b_0">
                          Electrical- Amplitude Frequency Chart
                        </div>
                      </div>

                      <div class="new_header" *ngIf="assetType === 'MOTOR'">
                        <div class="title font_20 m_b_0">
                          Electrical- Amplitude Frequency Chart
                        </div>
                      </div>
                      <div class="new_header" *ngIf="assetType === 'GEAR'">
                        <div class="title font_20 m_b_0">
                          Electrical- Amplitude Frequency Chart
                        </div>
                      </div>

                      <ul
                        #t="ngbTabset"
                        class="simple_custom_tab"
                        (tabChange)="insideTabChange($event.nextId)"
                      >
                        <li id="electricalTab-1">
                          <ng-template ngbTabTitle
                            >Electrical Analysis</ng-template
                          >
                          <ng-template ngbNavContent>
                            <div class="row">
                              <div class="col-md-12 amp_chart_div">
                                <div class="col-sm-9 left">
                                  <div class="amplitude_div">
                                    <h5>Amplitude <span>(mA)</span></h5>
                                    <div class="right_side">
                                      <div class="btn-group tab_btn_group">
                                        <button
                                          type="button"
                                          class="btn"
                                          (click)="electricalAnalysis()"
                                        >
                                          <span
                                            class="sprite_icon wave_grey"
                                            [ngClass]="{
                                              wave_blue: freqChartViewOn
                                            }"
                                          ></span>
                                        </button>
                                        <button
                                          type="button"
                                          class="btn"
                                          (click)="electricalLayout()"
                                        >
                                          <span
                                            class="sprite_icon list_grey"
                                            [ngClass]="{
                                              list_blue: freqChartViewOff
                                            }"
                                          ></span>
                                        </button>
                                        <button
                                          type="button"
                                          class="btn"
                                          (click)="
                                            downloadChartData2('electricalData')
                                          "
                                        >
                                          <span
                                            class="sprite_icon download_grey"
                                            [ngClass]="{
                                              download_blue: downloadChartDataOn
                                            }"
                                          ></span>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="line_chart_outer"
                                    *ngIf="electricalChartViewOn"
                                  >
                                    <div
                                      id="electricalChartContainer"
                                      style="
                                        height: 370px;
                                        width: 100%;
                                        margin-left: auto;
                                        margin-right: auto;
                                      "
                                    >
                                      <img
                                        *ngIf="!electricalChartLoader"
                                        class="chart_load"
                                        src="./assets/chart_loader.gif"
                                        id="loader"
                                      />
                                      <!-- <p
                                        *ngIf="electricalMessage"
                                        class="no_avl_data_msg"
                                      >
                                        No data available.
                                      </p> -->
                                      <!-- <p *ngIf="electricalMessage && !selectedFFTUIDAnomaly" class="no_avl_data_msg">
                                        No data available. SA - On Demand analysis not done yet.
                                      </p>
                                      <p *ngIf="electricalMessage && selectedFFTUIDAnomaly" class="no_avl_data_msg">
                                        No data available.
                                      </p> -->

                                      <p *ngIf="electricalMessage && !selectedFFTUIDAnomaly; else sec_msg" class="no_avl_data_msg">
                                        No data available. SA - On Demand analysis not done yet.
                                      </p>
                                      <ng-template #sec_msg>
                                        <p *ngIf="electricalMessage" class="no_avl_data_msg">
                                          No data available.
                                        </p>
                                      </ng-template>
                                    </div>
                                  </div>

                                  <div
                                    class="line_chart_outer tb"
                                    *ngIf="electricalChartViewOff"
                                  >
                                    <div class="new_header">
                                      <div class="title"></div>
                                    </div>
                                    <div class="table-responsive">
                                      <table class="table line_chart_tb diag">
                                        <thead>
                                          <tr>
                                            <th rowspan="2">Frequency(Hz)</th>
                                            <th colspan="3" class="text-center">
                                              Electrical Signature Analysis (mA)
                                            </th>
                                          </tr>
                                          <tr>
                                            <td>mA</td>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <table class="table child_tb">
                                                <tr
                                                  *ngFor="
                                                    let datay1 of listElectricalData
                                                  "
                                                >
                                                  <td>{{ datay1.x }}</td>
                                                </tr>
                                              </table>
                                            </td>
                                            <td>
                                              <table class="table child_tb">
                                                <tr
                                                  *ngFor="
                                                    let datay1 of listElectricalData
                                                  "
                                                >
                                                  <td>{{ datay1.y }}</td>
                                                </tr>
                                              </table>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                      <p
                                        *ngIf="
                                          showUltrasoundChartEmpty_Vibration
                                        "
                                        class="no_avl_data_msg"
                                      >
                                        {{ vibrationNoDataMsg }}
                                      </p>
                                    </div>
                                  </div>

                                  <div class="amplitude_div">
                                    <h5>Electric Current</h5>
                                    <div class="right_side">
                                      <div class="btn-group tab_btn_group">
                                        <button
                                          type="button"
                                          class="btn"
                                          hidden
                                        >
                                          <span
                                            class="sprite_icon wave_grey"
                                            [ngClass]="{
                                              wave_blue: freqChartViewOn
                                            }"
                                          ></span>
                                        </button>
                                        <button
                                          type="button"
                                          class="btn"
                                          hidden
                                        >
                                          <span
                                            class="sprite_icon list_grey"
                                            [ngClass]="{
                                              list_blue: freqChartViewOff
                                            }"
                                          ></span>
                                        </button>
                                        <button
                                          type="button"
                                          class="btn"
                                          (click)="
                                            downloadChartData2('currentData')
                                          "
                                        >
                                          <span
                                            class="sprite_icon download_grey"
                                            [ngClass]="{
                                              download_blue: downloadChartDataOn
                                            }"
                                          ></span>
                                        </button>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="line_chart_outer same">
                                    <div
                                      id="currentVibrationChart"
                                      style="
                                        height: 370px;
                                        width: 100%;
                                        margin-left: auto;
                                        margin-right: auto;
                                      "
                                    >
                                      <img
                                        *ngIf="!currentChartLoader"
                                        class="chart_load"
                                        src="./assets/chart_loader.gif"
                                        id="loader"
                                      />
                                      <p
                                        *ngIf="currentChartLoader"
                                        class="no_avl_data_msg"
                                      >
                                        {{ vibrationNoDataMsg }}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-sm-3 right">
                                  <h5 class="fft_heading">
                                    Predominant Frequencies
                                  </h5>
                                  <div class="table-responsive">
                                    <table class="table frequency_tb">
                                      <thead>
                                        <tr>
                                          <th class="middle_align" rowspan="2">
                                            Frequency<span>(Hz)</span>
                                          </th>
                                          <th>Electrical Signature Analysis</th>
                                        </tr>
                                        <tr>
                                          <td>mA</td>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr
                                          *ngFor="
                                            let xaxis of predElectricalFrq
                                          "
                                        >
                                          <td>{{ xaxis.frequency }}</td>
                                          <td>{{ xaxis.magnitude }}</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </ng-template>
                          <div [ngbNavOutlet]="ctdTabset"></div>
                        </li>
                      </ul>
                    </div>
                  </ng-template>
                </li>
                <!-- remove for dsp envelop analysis -->

                <!-- end envelop analysis -->
              </ul>
              <div [ngbNavOutlet]="ctdTabset"></div>
            </div>
          </ng-template>
        </li>

                  <li
            [ngbNavItem]="'tab-3'"
            id="tab-3"
            [matTooltip]="
              !softwareStatusMap['predictive'] ? 'Trending & Predictive service is not subscribed' :
              null
            "
            [ngClass]="{ 'opacity-50': !softwareStatusMap['predictive'] }"
          >
            <a
              ngbNavLink
              (click)="!softwareStatusMap['predictive']
                ? (role === 'USER'
                    ? $event.stopImmediatePropagation()
                    : checkSubscriptionController($event, 'predictive')
                  )
                : null
              "
              [attr.title]="!softwareStatusMap['predictive'] ? 'Trending & Predictive service is not subscribed' : null"
              [style.opacity]="!softwareStatusMap['predictive'] ? 0.6 : 1"
              [style.pointer-events]="role === 'USER' && !softwareStatusMap['predictive'] ? 'none' : 'auto'"
            >
              Trending & Predictive Maintenance
            </a>
          <ng-template ngbNavContent>
            <div class="fixed_status_bar">
              <div class="info_box_outer">
                <div class="info_box">
                  <h4>{{ company_name }}</h4>
                  <h6>Customer</h6>
                </div>
                <div class="info_box">
                  <h4>{{ monitorInfo?.site_name || "N/A" }}</h4>
                  <h6>Site</h6>
                </div>
                <div class="info_box">
                  <h4>{{ monitorInfo?.application_name || "N/A" }}</h4>
                  <h6>Application</h6>
                </div>
                <div class="info_box">
                  <div class="inner">
                    <div class="lft">
                      <h4>{{ monitorInfo?.machine_make || "N/A" }}</h4>
                      <h6>Machine Make</h6>
                    </div>
                    <div
                      class="rgt"
                      (click)="goToImageLink(_imgUrl)"
                      style="cursor: pointer"
                    >
                      <img
                        [src]="_imgUrl"
                        alt="User"
                        class="thumb"
                        onerror="this.src='./assets/img-new/assets.png'"
                      />
                    </div>
                  </div>
                </div>
                <div class="info_box">
                  <h4>{{ monitorInfo?.motor_serial_number || "N/A" }}</h4>
                  <h6>Machine Serial Number</h6>
                </div>
                <div class="info_box">
                  <h4 *ngIf="!monitoringDeviceDetailsLoader; else loading">
                    {{ monitoringDeviceDetails?.assetDetails?.name || "N/A" }}
                  </h4>
                  <ng-template #loading>
                    <div class="skeleton skeleton-service-text-device-details"></div>
                  </ng-template>
                  <h6>Asset Name</h6>
                </div>
              </div>
            </div>

            <div class="inner_gauge_box">
              <div class="btn-group tab_btn_group">
                <!-- Hourly -->
                <button
                  *ngIf="tabColorP1 === 'active'"
                  type="button"
                  mat-raised-button
                  color="primary"
                  >
                  Hourly
                </button>
                <button
                  *ngIf="tabColorP1 !== 'active'"
                  type="button"
                  mat-stroked-button
                  color="primary"
                  (click)="selectItemFilter('Hourly')">
                  Hourly
                </button>

                <!-- Daily -->
                <button
                  *ngIf="tabColorP2 === 'active'"
                  type="button"
                  mat-raised-button
                  color="primary"
                  >
                  Daily
                </button>
                <button
                  *ngIf="tabColorP2 !== 'active'"
                  type="button"
                  mat-stroked-button
                  color="primary"
                  (click)="selectItemFilter('Daily')">
                  Daily
                </button>

                <!-- Weekly -->
                <button
                  *ngIf="tabColorP3 === 'active'"
                  type="button"
                  mat-raised-button
                  color="primary"
                  >
                  Weekly
                </button>
                <button
                  *ngIf="tabColorP3 !== 'active'"
                  type="button"
                  mat-stroked-button
                  color="primary"
                  (click)="selectItemFilter('Weekly')">
                  Weekly
                </button>

                <!-- Monthly -->
                <button
                  *ngIf="tabColorP4 === 'active'"
                  type="button"
                  mat-raised-button
                  color="primary"
                  >
                  Monthly
                </button>
                <button
                  *ngIf="tabColorP4 !== 'active'"
                  type="button"
                  mat-stroked-button
                  color="primary"
                  (click)="selectItemFilter('Monthly')">
                  Monthly
                </button>

                <!-- Quarterly -->
                <button
                  *ngIf="tabColorP5 === 'active'"
                  type="button"
                  mat-raised-button
                  color="primary"
                  >
                  Quarterly
                </button>
                <button
                  *ngIf="tabColorP5 !== 'active'"
                  type="button"
                  mat-stroked-button
                  color="primary"
                  (click)="selectItemFilter('Quaterly')">
                  Quarterly
                </button>
              </div>


              <div class="new_header header_absolute">
                <div class="absolute_inner">
                  <div class="title">
                    Vibration - Acceleration Trend<span>
                      (m/sec<sup>2</sup>)</span
                    >
                  </div>
                  <div class="tools">
                    <div class="btn-group tab_btn_group">
                      <button
                        type="button"
                        class="btn"
                        (click)="pregridLayout('two')"
                      >
                        <span
                          class="sprite_icon wave_grey"
                          [ngClass]="{ wave_blue: chartLayoutOnVibration }"
                        ></span>
                      </button>
                      <button
                        type="button"
                        class="btn"
                        (click)="prelistLayout('two')"
                      >
                        <span
                          class="sprite_icon list_grey"
                          [ngClass]="{ list_blue: listLayoutOnVibration }"
                        ></span>
                      </button>
                      <button
                        type="button"
                        class="btn"
                        (click)="downloadChartData8()"
                      >
                        <span
                          class="sprite_icon download_grey"
                          [ngClass]="{ download_blue: downloadChartDataOn }"
                        ></span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="ab_percent_error">
                <div
                  *ngIf="statusVibrationPredictionValues === false"
                  class="err"
                >
                  Absolute Percentage Error :
                  <span>{{ absolutePercentageVibration || 0 }}%</span>
                </div>
              </div>

              <div *ngIf="statusVibrationPredictionValues === false">
                <div class="actual_predict" *ngIf="chartLayoutOnVibration">
                  <div class="in">
                    <div class="lf">ACTUAL TREND</div>
                    <div class="rg">PREDICTED TREND</div>
                  </div>
                </div>
              </div>

              <div
                class="inopt_outer"
                *ngIf="statusVibrationPredictionValues === true"
              >
                <div class="ab_percent_error_inopt">
                  <div class="err" style="color: #ff0303">
                    Not Enough Data Available To Predict
                  </div>
                </div>
                <div class="actual_predict_inopt">
                  <div class="inn">
                    <div class="lft">ACTUAL TREND</div>
                    <div class="rgt">PREDICTED TREND</div>
                  </div>
                </div>
              </div>
              <div class="">

                <div
                  class="line_chart_outer p_t_20"
                  style="display: flex; align-items: center; justify-content: center;"
                  *ngIf="chartLayoutOnVibration"
                >
                <div class="loader1" style="position: absolute;">
                  <img
                  *ngIf="emptyMessageAlert"
                  class="chart_load_1"
                  src="./assets/chart_loader.gif"
                />
                </div>

                  <div
                    id="chartContainerVelocity"
                    class="trand_chart_box"
                    *ngIf="divoff"
                  >
                    <!-- <img
                      *ngIf="emptyMessageAlert"
                      class="chart_load"
                      src="./assets/chart_loader.gif"
                      id="loader"
                    /> -->
                  </div>
                  <p
                    *ngIf="divoff === false"
                    style="
                      text-align: center;
                      font-size: 16px;
                      vertical-align: middle;
                      line-height: 300px;
                      color: #838383;
                    "
                  >
                    No data available for last 24 hour
                  </p>
                </div>
              </div>

              <div class="line_chart_outer tb" *ngIf="listLayoutOnVibration">
                <div class="new_header">
                  <div class="title"></div>
                </div>
                <div class="table-responsive">
                  <table class="table line_chart_tb">
                    <thead>
                      <tr>
                        <th class="middle_align" rowspan="2">Time Stamp</th>
                        <th colspan="6" class="text-center">Acceleration</th>
                      </tr>
                      <tr>
                        <td>Tangential</td>
                        <td>Axial</td>
                        <td>Radial</td>
                        <td>Prediction X</td>
                        <td>Prediction Y</td>
                        <td>Prediction Z</td>
                      </tr>
                    </thead>

                    <tbody *ngIf="divoff; else elseBlock">
                      <tr *ngFor="let time of arrObjVibrationPred">
                        <td>{{ time.d }}</td>
                        <td>{{ time?.c1 || "-" }}</td>
                        <td>{{ time?.c2 || "-" }}</td>
                        <td>{{ time?.c3 || "-" }}</td>
                        <td>{{ time?.c4 || "-" }}</td>
                        <td>{{ time?.c5 || "-" }}</td>
                        <td>{{ time?.c6 || "-" }}</td>
                      </tr>
                    </tbody>
                    <tbody>
                      <ng-template #elseBlock>
                        <tr>
                          <td colspan="7" class="errorDisplay">
                            No data available for last 24 Hour!
                          </td>
                        </tr>
                      </ng-template>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="new_header header_absolute">
                <div class="absolute_inner">
                  <div class="title">
                    Vibration - Velocity Trend <span> (mm/sec)</span>
                  </div>
                  <div class="tools">
                    <div class="btn-group tab_btn_group">
                      <button
                        type="button"
                        class="btn"
                        (click)="pregridLayout('one')"
                      >
                        <span
                          class="sprite_icon wave_grey"
                          [ngClass]="{ wave_blue: predictiveAccOn }"
                        ></span>
                      </button>
                      <button
                        type="button"
                        class="btn"
                        (click)="prelistLayout('one')"
                      >
                        <span
                          class="sprite_icon list_grey"
                          [ngClass]="{ list_blue: preAccListLayoutOn }"
                        ></span>
                      </button>
                      <button
                        type="button"
                        class="btn"
                        (click)="downloadChartData5()"
                      >
                        <span
                          class="sprite_icon download_grey"
                          [ngClass]="{ download_blue: downloadChartDataOn }"
                        ></span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="ab_percent_error">
                <div
                  *ngIf="statusVelocityPredictionValues === false"
                  class="err"
                >
                  Absolute Percentage Error :
                  <span>{{ absolutePercentageVelocity || 0 }}%</span>
                </div>
              </div>

              <div *ngIf="statusVelocityPredictionValues === false">
                <div class="actual_predict" *ngIf="predictiveAccOn">
                  <div class="in">
                    <div class="lf">ACTUAL TREND</div>
                    <div class="rg">PREDICTED TREND</div>
                  </div>
                </div>
              </div>

              <div
                class="inopt_outer"
                *ngIf="statusVelocityPredictionValues === true"
              >
                <div class="ab_percent_error_inopt">
                  <div class="err" style="color: #ff0303">
                    Not Enough Data Available To Predict
                  </div>
                </div>
                <div class="actual_predict_inopt">
                  <div class="inn">
                    <div class="lft">ACTUAL TREND</div>
                    <div class="rgt">PREDICTED TREND</div>
                  </div>
                </div>
              </div>

              <div class="">
              <div class="line_chart_outer p_t_20"
                   style="display: flex; align-items: center; justify-content: center;"
                   *ngIf="predictiveAccOn">
                   <div class="loader1" style="position: absolute;">
                  <img
                  *ngIf="emptyMessageAlert3"
                  src="./assets/chart_loader.gif"
                />
                </div>
                <div
                  *ngIf="vibrationVelocityTrendDiv"
                  id="predVelocityChartContainer"
                  class="trand_chart_box"
                >

                </div>
                <p
                  *ngIf="vibrationVelocityTrendDiv === false"
                  style="
                    text-align: center;
                    font-size: 16px;
                    vertical-align: middle;
                    line-height: 300px;
                    color: #838383;
                  "
                >
                  No data available for last 24 hour
                </p>
              </div>
            </div>

              <div class="line_chart_outer tb" *ngIf="preAccListLayoutOn">
                <div class="new_header">
                  <div class="title"></div>
                </div>
                <div class="table-responsive">
                  <table class="table line_chart_tb">
                    <thead>
                      <tr>
                        <th class="middle_align" rowspan="2">Time Stamp</th>
                        <th colspan="6" class="text-center">Acceleration</th>
                      </tr>
                      <tr>
                        <td>Tangential</td>
                        <td>Axial</td>
                        <td>Radial</td>
                        <td>Prediction X</td>
                        <td>Prediction Y</td>
                        <td>Prediction Z</td>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- <tbody *ngIf="emptyMessageAlert3; else elseBlock"> -->
                      <tr *ngFor="let time of tableVelocityTrendPred">
                        <td>{{ time.d }}</td>
                        <td>{{ time?.c1 || "-" }}</td>
                        <td>{{ time?.c2 || "-" }}</td>
                        <td>{{ time?.c3 || "-" }}</td>
                        <td>{{ time?.c4 || "-" }}</td>
                        <td>{{ time?.c5 || "-" }}</td>
                        <td>{{ time?.c6 || "-" }}</td>
                      </tr>
                    </tbody>
                    <!-- <tbody>
                      <ng-template #elseBlock>
                        <tr>
                          <td colspan="7" class="errorDisplay">
                            No data available for last 24 Hour!
                          </td>
                        </tr>
                      </ng-template>
                    </tbody> -->
                  </table>
                </div>
              </div>

              <div class="new_header header_absolute" *ngIf="[2,3].includes(master_product_type)">
                <div class="absolute_inner">
                  <div class="title">
                    Machine Acoustics Trend <span> (dB) </span>
                  </div>
                  <div class="tools">
                    <div class="btn-group tab_btn_group">
                      <button
                        type="button"
                        class="btn"
                        (click)="preMachineAcousticsGridLayout()"
                      >
                        <span
                          class="sprite_icon wave_grey"
                          [ngClass]="{ wave_blue: predictiveAcousticsChartOn }"
                        ></span>
                      </button>
                      <button
                        type="button"
                        class="btn"
                        (click)="preMachineAcousticsListLayout()"
                      >
                        <span
                          class="sprite_icon list_grey"
                          [ngClass]="{ list_blue: predictiveAcousticsListOn }"
                        ></span>
                      </button>
                      <button
                        type="button"
                        class="btn"
                        (click)="downloadAcousticsChartData()"
                      >
                        <span
                          class="sprite_icon download_grey"
                          [ngClass]="{ download_blue: downloadChartDataOn }"
                        ></span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="ab_percent_error" *ngIf="[2,3].includes(master_product_type)">
                <div
                  *ngIf="statusAcousticsPredictionValues === false"
                  class="err"
                >
                  Absolute Percentage Error :
                  <span>{{ absolutePercentageAcoustics || 0 }}%</span>
                </div>
              </div>
              <div *ngIf="statusAcousticsPredictionValues === false && [2,3].includes(master_product_type)">
                <div class="actual_predict" *ngIf="predictiveAccOn">
                  <div class="in">
                    <div class="lf">ACTUAL TREND</div>
                    <div class="rg">PREDICTED TREND</div>
                  </div>
                </div>
              </div>
              <div
                class="inopt_outer"
                *ngIf="statusAcousticsPredictionValues === true && [2,3].includes(master_product_type)"
              >
                <div class="ab_percent_error_inopt">
                  <div class="err_indent" style="color: #ff0303">
                    Not Enough Data Available To Predict
                  </div>
                </div>
                <div class="actual_predict_inopt">
                  <div class="inn">
                    <div class="lft">ACTUAL TREND</div>
                    <div class="rgt">PREDICTED TREND</div>
                  </div>
                </div>
              </div>
             <div *ngIf="[2,3].includes(master_product_type)">
              <div
              class="line_chart_outer p_t_20"
              *ngIf="predictiveAcousticsChartOn"
              style="display: flex; align-items: center; justify-content: center;"
            >
            <div class="loader1" style="position: absolute;">
              <img
                  *ngIf="emptyMessageAlertAcoustics"
                  src="./assets/chart_loader.gif"
                />
            </div>
              <div
                *ngIf="trendMachineAcousitcsOnOff"
                class="trand_chart_box"
                id="trendMachineAcousticsChart"
              >

              </div>
              <p
                *ngIf="trendMachineAcousitcsOnOff === false"
                style="
                  text-align: center;
                  font-size: 16px;
                  vertical-align: middle;
                  line-height: 300px;
                  color: #838383;
                "
              >
                No data available for last 24 hour
              </p>
            </div>
             </div>

              <div
                class="line_chart_outer tb"
                *ngIf="predictiveAcousticsListOn && [2,3].includes(master_product_type)"
              >
                <div class="new_header">
                  <div class="title"></div>
                </div>
                <div class="table-responsive">
                  <table class="table line_chart_tb">
                    <thead>
                      <tr>
                        <th class="middle_align" rowspan="2">Time Stamp</th>
                        <th colspan="6" class="text-center">
                          Machine Acoustics Trend
                        </th>
                      </tr>
                      <tr>
                        <td>Delta Ultrasound</td>
                        <td>Not Available</td>
                        <td>Not Available</td>
                        <td>Delta Ultrasound Prediction</td>
                        <td>Not Available</td>
                        <td>Not Available</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let time of listPredAcousticsData1">
                        <td>{{ time.d }}</td>
                        <td>{{ time?.c1 || "-" }}</td>
                        <td>{{ time?.c2 || "-" }}</td>
                        <td>{{ time?.c3 || "-" }}</td>
                        <td>{{ time?.c4 || "-" }}</td>
                        <td>{{ time?.c5 || "-" }}</td>
                        <td>{{ time?.c6 || "-" }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="new_header header_absolute">
                <div class="absolute_inner">
                  <div class="title">Temperature Trend <span>(°C)</span></div>
                  <div class="tools">
                    <div class="btn-group tab_btn_group">
                      <button
                        type="button"
                        class="btn"
                        (click)="preTempgridLayout()"
                      >
                        <span
                          class="sprite_icon wave_grey"
                          [ngClass]="{ wave_blue: predictiveTempOn }"
                        ></span>
                      </button>
                      <button
                        type="button"
                        class="btn"
                        (click)="preTemplistLayout()"
                      >
                        <span
                          class="sprite_icon list_grey"
                          [ngClass]="{ list_blue: preTempListLayoutOn }"
                        ></span>
                      </button>
                      <button
                        type="button"
                        class="btn"
                        (click)="downloadChartData6()"
                      >
                        <span
                          class="sprite_icon download_grey"
                          [ngClass]="{ download_blue: downloadChartDataOn }"
                        ></span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="ab_percent_error">
                <div *ngIf="statusTempPredictionValues === false" class="err">
                  Absolute Percentage Error :
                  <span>{{ absolutePercentageTemp || 0 }}%</span>
                </div>
              </div>

              <div *ngIf="statusTempPredictionValues === false">
                <div class="actual_predict" *ngIf="predictiveAccOn">
                  <div class="in">
                    <div class="lf">ACTUAL TREND</div>
                    <div class="rg">PREDICTED TREND</div>
                  </div>
                </div>
              </div>

              <div
                class="inopt_outer"
                *ngIf="statusTempPredictionValues === true"
              >
                <div class="ab_percent_error_inopt">
                  <div class="err" style="color: #ff0303">
                    Not Enough Data Available To Predict
                  </div>
                </div>
                <div class="actual_predict_inopt">
                  <div class="inn">
                    <div class="lft">ACTUAL TREND</div>
                    <div class="rgt">PREDICTED TREND</div>
                  </div>
                </div>
              </div>

             <div class="">
              <div class="line_chart_outer p_t_20"
                   style="display: flex; align-items: center; justify-content: center;"
                        *ngIf="predictiveTempOn">
                <div class="loader1" style="position: absolute;">
                  <img
                  *ngIf="emptyMsgAlert2"
                  src="./assets/chart_loader.gif"
                />
                </div>
                <div
                  *ngIf="predictiveChartContainerOnOff"
                  class="trand_chart_box"
                  id="predictiveChartContainer"
                >

                </div>
                <p
                  *ngIf="predictiveChartContainerOnOff === false"
                  style="
                    text-align: center;
                    font-size: 16px;
                    vertical-align: middle;
                    line-height: 300px;
                    color: #838383;
                  "
                >
                  No data available for last 24 hour
                </p>
              </div>
             </div>

              <div class="line_chart_outer tb" *ngIf="preTempListLayoutOn">
                <div class="new_header">
                  <div class="title"></div>
                </div>
                <div class="table-responsive">
                  <table class="table line_chart_tb">
                    <thead>
                      <tr>
                        <th class="middle_align" rowspan="2">Time Stamp</th>
                        <th colspan="6" class="text-center">Temperature</th>
                      </tr>
                      <tr>
                        <td>DE Bearing</td>
                        <td>Machine Skin</td>
                        <td>NDE Bearing</td>
                        <td>Prediction X</td>
                        <td>Prediction Y</td>
                        <td>Prediction Z</td>
                      </tr>
                    </thead>
                    <tbody *ngIf="!emptyMsgAlert2; else elseBlock">
                      <tr *ngFor="let time of listPredTempData1">
                        <td>{{ time.d }}</td>
                        <td>{{ time?.c1 || "-" }}</td>
                        <td>{{ time?.c2 || "-" }}</td>
                        <td>{{ time?.c3 || "-" }}</td>
                        <td>{{ time?.c4 || "-" }}</td>
                        <td>{{ time?.c5 || "-" }}</td>
                        <td>{{ time?.c6 || "-" }}</td>
                      </tr>
                    </tbody>
                    <tbody>
                      <ng-template #elseBlock>
                        <tr>
                          <td colspan="7" class="errorDisplay">
                            No data available for last 24 Hour!
                          </td>
                        </tr>
                      </ng-template>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="line_chart_outer tb" *ngIf="preKurtListLayoutOn">
                <div class="new_header">
                  <div class="title"></div>
                </div>
                <div class="table-responsive">
                  <table class="table line_chart_tb">
                    <thead>
                      <tr>
                        <th class="middle_align" rowspan="2">Time Stamp</th>
                        <th colspan="6" class="text-center">Acceleration</th>
                      </tr>
                      <tr>
                        <td>Radial</td>
                        <td>Tangential</td>
                        <td>Axial</td>
                        <td>Prediction X</td>
                        <td>Prediction Y</td>
                        <td>Prediction Z</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let time of listPredKurtData1">
                        <td>{{ time.d }}</td>
                        <td>{{ time?.c1 || "-" }}</td>
                        <td>{{ time?.c2 || "-" }}</td>
                        <td>{{ time?.c3 || "-" }}</td>
                        <td>{{ time?.c4 || "-" }}</td>
                        <td>{{ time?.c5 || "-" }}</td>
                        <td>{{ time?.c6 || "-" }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!-- Commented Machine Health Indices Trend Graph Section -->
              <!-- <div class="new_header header_absolute">
                <div class="absolute_inner">
                  <div class="title">
                    Machine Health Indices Trend <span> (%) </span>
                  </div>
                  <div class="tools">
                    <div class="btn-group tab_btn_group">
                      <button
                        type="button"
                        class="btn"
                        (click)="showIndicesChart()"
                      >
                        <span
                          class="sprite_icon wave_grey"
                          [ngClass]="{ wave_blue: indicesChartOn }"
                        ></span>
                      </button>
                      <button
                        type="button"
                        class="btn"
                        (click)="showIndicesTable()"
                      >
                        <span
                          class="sprite_icon list_grey"
                          [ngClass]="{ list_blue: indicesTableOn }"
                        ></span>
                      </button>
                      <button
                        type="button"
                        class="btn"
                        (click)="downloadIndicesCsv()"
                      >
                        <span
                          class="sprite_icon download_grey"
                          [ngClass]="{ download_blue: downloadChartDataOn }"
                        ></span>
                      </button>
                    </div>
                  </div>
                </div>
              </div> -->
              <!-- <div class="ab_percent_error">
                <div
                  *ngIf="statusHealthIndicesPredictionValues === false"
                  class="err"
                >
                  Absolute Percentage Error :
                  <span>{{ absolutePercentageIndices || 0 }}%</span>
                </div>
              </div> -->
              <!-- <div *ngIf="statusHealthIndicesPredictionValues === false">
                <div class="actual_predict" *ngIf="predictiveAccOn">
                  <div class="in">
                    <div class="lf">ACTUAL TREND</div>
                    <div class="rg">PREDICTED TREND</div>
                  </div>
                </div>
              </div> -->
              <!-- <div
                class="inopt_outer"
                *ngIf="statusHealthIndicesPredictionValues === true"
              >
                <div class="ab_percent_error_inopt">
                  <div class="err_indent" style="color: #ff0303">
                    Not Enough Data Available To Predict
                  </div>
                </div>
                <div class="actual_predict_inopt">
                  <div class="inn">
                    <div class="lft">ACTUAL TREND</div>
                    <div class="rgt">PREDICTED TREND</div>
                  </div>
                </div>
              </div> -->

              <!-- <div class="">
                <div class="line_chart_outer p_t_20"
                style="display: flex; align-items: center; justify-content: center;"
                *ngIf="indicesChartOn">
                <div class="loader1" style="position: absolute;">
                    <img
                    *ngIf="emptyMessageAlert4"
                    src="./assets/chart_loader.gif"
                  />
                  </div>
                  <div
                    *ngIf="machineHealthIndicesOnOff"
                    class="trand_chart_box"
                    id="machineHealthIndicesChart"
                  >

                  </div>
                  <p
                    *ngIf="machineHealthIndicesOnOff === false"
                    style="
                      text-align: center;
                      font-size: 16px;
                      vertical-align: middle;
                      line-height: 300px;
                      color: #838383;
                    "
                  >
                    No data available for last 24 hour
                  </p>
                </div>
              </div> -->

              <div class="line_chart_outer tb" *ngIf="indicesTableOn">
                <div class="new_header">
                  <div class="title"></div>
                </div>
                <div class="table-responsive">
                  <table class="table line_chart_tb">
                    <thead>
                      <tr>
                        <th class="middle_align" rowspan="2">Time Stamp</th>
                        <th colspan="8" class="text-center">
                          Machine Health Indices Trend (%)
                        </th>
                      </tr>
                      <tr>
                        <td>Mechanical Health</td>
                        <td>Electrical Health</td>
                        <td>Bearings Health</td>
                        <td>Thermal Health</td>
                        <td>Prediction W</td>
                        <td>Prediction X</td>
                        <td>Prediction Y</td>
                        <td>Prediction Z</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let time of tableDataHealthIndices">
                        <td>{{ time.d }}</td>
                        <td>{{ time?.c1 || "-" }}</td>
                        <td>{{ time?.c2 || "-" }}</td>
                        <td>{{ time?.c3 || "-" }}</td>
                        <td>{{ time?.c4 || "-" }}</td>
                        <td>{{ time?.c5 || "-" }}</td>
                        <td>{{ time?.c6 || "-" }}</td>
                        <td>{{ time?.c7 || "-" }}</td>
                        <td>{{ time?.c8 || "-" }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="line_chart_outer tb" *ngIf="preOrienListLayoutOn">
                <div class="new_header">
                  <div class="title"></div>
                </div>
                <div class="table-responsive">
                  <table class="table line_chart_tb">
                    <thead>
                      <tr>
                        <th class="middle_align" rowspan="2">Time Stamp</th>
                        <th colspan="6" class="text-center">Orientation</th>
                      </tr>
                      <tr>
                        <td>DE Bearing</td>
                        <td>Machine Skin</td>
                        <td>NDE Bearing</td>
                        <td>Prediction X</td>
                        <td>Prediction Y</td>
                        <td>Prediction Z</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let time of listPredOrinData1">
                        <td>{{ time.d }}</td>
                        <td>{{ time?.c1 || "-" }}</td>
                        <td>{{ time?.c2 || "-" }}</td>
                        <td>{{ time?.c3 || "-" }}</td>
                        <td>{{ time?.c4 || "-" }}</td>
                        <td>{{ time?.c5 || "-" }}</td>
                        <td>{{ time?.c6 || "-" }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="new_header">
                <div class="title">
                  Individual Unacceptable Condition Trend Charts
                </div>
              </div>

              <div class="btn-group tab_btn_group">
                <button
                  type="button"
                  [ngClass]="tabTwoColor1"
                  [disabled]="tabTwoColor1 === activeMechanicalTab"
                  class="btn"
                  (click)="selectIndividualFilter('Mechanical')"
                >
                  Mechanical
                </button>
                <button
                  type="button"
                  [ngClass]="tabTwoColor2"
                  [disabled]="tabTwoColor2 === activeElectricalStatorTab"
                  class="btn"
                  (click)="selectIndividualFilter('Electrical Stator')"
                >
                  Electrical Stator
                </button>
                <button
                  type="button"
                  [ngClass]="tabTwoColor3"
                  [disabled]="tabTwoColor3 === activateElectricalRotorTab"
                  class="btn"
                  (click)="selectIndividualFilter('Electrical Rotor')"
                >
                  Electrical Rotor
                </button>

                <button
                  *ngIf="
                    driveType === 'DIRECT' || driveType === 'NONE';
                    else btn_belt_system
                  "
                  type="button"
                  [disabled]="true"
                  class="btn"
                >
                  Belt System
                </button>
                <ng-template #btn_belt_system>
                  <button
                    type="button"
                    [ngClass]="tabTwoColor4"
                    [disabled]="tabTwoColor4 === activateBeltSystemTab"
                    class="btn"
                    (click)="selectIndividualFilter('Belt System')"
                  >
                    Belt System
                  </button>
                </ng-template>

                <button
                  type="button"
                  [ngClass]="tabTwoColor5"
                  [disabled]="tabTwoColor5 === activateBearingTab"
                  class="btn"
                  (click)="selectIndividualFilter('Bearing')"
                >
                  Bearing
                </button>

                <button
                  *ngIf="
                    assetType === 'MOTOR' && driveType === 'DIRECT';
                    else gear_actual_btn
                  "
                  type="button"
                  [ngClass]="tabTwoColor6"
                  [disabled]="true"
                  class="btn"
                >
                  Gear
                </button>
                <ng-template #gear_actual_btn>
                  <button
                    type="button"
                    [ngClass]="tabTwoColor6"
                    [disabled]="tabTwoColor6 === activateGearTab"
                    class="btn"
                    (click)="selectIndividualFilter('Gear')"
                  >
                    Gear
                  </button>
                </ng-template>

                <button
                  *ngIf="
                    assetType === 'MOTOR' && driveType === 'DIRECT';
                    else journal_bearing_btn
                  "
                  type="button"
                  [ngClass]="tabTwoColor7"
                  [disabled]="true"
                  class="btn"
                >
                  Journal Bearing
                </button>
                <ng-template #journal_bearing_btn>
                  <button
                    type="button"
                    [ngClass]="tabTwoColor7"
                    [disabled]="tabTwoColor7 === activateJournalTab"
                    class="btn"
                    (click)="selectIndividualFilter('Journal Bearing')"
                  >
                    Journal Bearing
                  </button>
                </ng-template>
              </div>

              <div class="trend_chart_outer">
                <div class="indi_err" *ngIf="emptyIndivisualCharts">
                  <span style="color: gray; font-size: 14px"
                    >No Charts Available</span
                  >
                </div>
                <div
                  *ngFor="let data of mainChartIndiArr; let idx = index"
                  class="trend_chart_inner"
                  (click)="openModal(data.modal)"
                >
                  <div class="inner_part">
                    <div class="wrap">
                      <div class="head">{{ data.fault_group }}</div>
                      <div class="trend_chart" *ngIf="data.empty; else showMsg">
                        <img
                          class="chart-img-custom"
                          style="object-fit: cover !important"
                          [src]="data.imgUrl"
                          onerror="this.src='./assets/img-new/full-moon.png'"
                        />
                        <jw-modal id="{{ data.modal }}">
                          <button
                            style="
                              position: absolute;
                              right: 10px;
                              top: 0px;
                              z-index: 9999999;
                            "
                            mat-button
                            (click)="closeModal(data.modal)"
                          >
                            Close
                          </button>
                          <div class="head">
                            {{ data.fault_group
                            }}<span
                              class="not_enough"
                              *ngIf="unbalanceStatusPredValues === true"
                              >Not Enough Data Available To Predict</span
                            >
                          </div>
                          <div class="container">
                            <div class="row">
                              <div class="col-sm chart-container">
                                <p
                                  *ngIf="data.absolute_percentage != undefined"
                                  class="show_absolute_pred"
                                >
                                  Absolute Percentage Error :
                                  {{ data.absolute_percentage }}%
                                </p>
                                <img
                                  class="indicateArr"
                                  src="./assets/arrow-indi.png"
                                />
                                <img
                                  class="predictionArc"
                                  src="./assets/curved-prediction.png"
                                />
                                <div
                                  id="{{ data.chartID }}"
                                  class="doughnut_chart_style"
                                ></div>
                                <img
                                  class="actualArc"
                                  src="./assets/curved-actual.png"
                                />
                              </div>
                              <div class="col-sm">
                                <div
                                  class="table-responsive table_custom_style"
                                >
                                  <table class="table">
                                    <thead>
                                      <tr>
                                        <th scope="col" colspan="2">
                                          Status Legend
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td>Machine Offline</td>
                                        <td>
                                          <div class="gray_s"></div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Good Health</td>
                                        <td>
                                          <div class="green_s"></div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Unsatisfactory</td>
                                        <td>
                                          <div class="yellow_s"></div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Unacceptable</td>
                                        <td>
                                          <div class="red_s"></div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Out for service</td>
                                        <td>
                                          <div class="outForService"></div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Not enough data to Predict</td>
                                        <td>
                                          <div class="no_pred_data"></div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Asset Idle</td>
                                        <td>
                                          <div class="no_data"></div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="bottom_title"
                            *ngIf="valueTypeTrend === 'hour'"
                          >
                            <b>Hourly</b> Actual & Predicted Performance
                          </div>
                          <div
                            class="bottom_title"
                            *ngIf="valueTypeTrend === 'day'"
                          >
                            <b>Daily</b> Actual & Predicted Performance
                          </div>
                          <div
                            class="bottom_title"
                            *ngIf="valueTypeTrend === 'week'"
                          >
                            <b>Weekly</b> Actual & Predicted Performance
                          </div>
                          <div
                            class="bottom_title"
                            *ngIf="valueTypeTrend === 'month'"
                          >
                            <b>Monthly</b> Actual & Predicted Performance
                          </div>
                          <div
                            class="bottom_title"
                            *ngIf="valueTypeTrend === 'quaterly'"
                          >
                            <b>Quaterly</b> Actual & Predicted Performance
                          </div>
                        </jw-modal>
                      </div>
                      <ng-template #showMsg>
                        <div class="trend_chart_outer">
                          <div class="inner_part">
                            <div class="wrap">
                              <div class="head">Not Available</div>
                              <div class="trend_chart">
                                <img
                                  class="chart-img-custom"
                                  style="object-fit: cover !important"
                                  src="./assets/img-new/full-moon.png"
                                  onerror="this.src='./assets/img-new/full-moon.png'"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>

              <div class="summary_div">
                <h4>Trend Analysis Summary:</h4>
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Machine Parameter</th>
                        <th>Min</th>
                        <th>Max</th>
                        <th>Average</th>
                        <th>Acceptable Limits</th>
                        <th class="text-center">Status</th>
                        <th>Recommendation</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td colspan="7">
                          <span class="td_heading"
                            >Vibration - Acceleration (m/sec<sup>2</sup>)</span
                          >
                        </td>
                      </tr>
                      <tr>
                        <td>Tangential</td>
                        <td>{{ trend_analysis_acc_new.xmin }}</td>
                        <td>{{ trend_analysis_acc_new.xmax }}</td>
                        <td>{{ trend_analysis_acc_new.xavg }}</td>
                        <td>{{ trend_analysis_acc_new.range }}</td>
                        <td class="text-center">
                          <span
                            *ngIf="
                              trend_analysis_acc_new.messagex ===
                              'No Action Needed'
                            "
                            class="sprite_icon square_green"
                          ></span>
                          <span
                            *ngIf="
                              trend_analysis_acc_new.messagex ===
                              'Attention Reqiured'
                            "
                            class="sprite_icon tri_yellow"
                          ></span>
                          <span
                            *ngIf="
                              trend_analysis_acc_new.messagex ===
                              'Immediate Action Required'
                            "
                            class="sprite_icon tri_red"
                          ></span>
                        </td>
                        <td>{{ trend_analysis_acc_new.messagex }}</td>
                      </tr>
                      <tr>
                        <td>Radial</td>
                        <td>{{ trend_analysis_acc_new.ymin }}</td>
                        <td>{{ trend_analysis_acc_new.ymax }}</td>
                        <td>{{ trend_analysis_acc_new.yavg }}</td>
                        <td>{{ trend_analysis_acc_new.range }}</td>
                        <td class="text-center">
                          <span
                            *ngIf="
                              trend_analysis_acc_new.messagey ===
                              'No Action Needed'
                            "
                            class="sprite_icon square_green"
                          ></span>
                          <span
                            *ngIf="
                              trend_analysis_acc_new.messagey ===
                              'Attention Reqiured'
                            "
                            class="sprite_icon tri_yellow"
                          ></span>
                          <span
                            *ngIf="
                              trend_analysis_acc_new.messagey ===
                              'Immediate Action Required'
                            "
                            class="sprite_icon tri_red"
                          ></span>
                        </td>
                        <td>{{ trend_analysis_acc_new.messagey }}</td>
                      </tr>
                      <tr>
                        <td>Axial</td>
                        <td>{{ trend_analysis_acc_new.zmin }}</td>
                        <td>{{ trend_analysis_acc_new.zmax }}</td>
                        <td>{{ trend_analysis_acc_new.zavg }}</td>
                        <td>{{ trend_analysis_acc_new.range }}</td>
                        <td class="text-center">
                          <span
                            *ngIf="
                              trend_analysis_acc_new.messagez ===
                              'No Action Needed'
                            "
                            class="sprite_icon square_green"
                          ></span>
                          <span
                            *ngIf="
                              trend_analysis_acc_new.messagez ===
                              'Attention Reqiured'
                            "
                            class="sprite_icon tri_yellow"
                          ></span>
                          <span
                            *ngIf="
                              trend_analysis_acc_new.messagez ===
                              'Immediate Action Required'
                            "
                            class="sprite_icon tri_red"
                          ></span>
                        </td>
                        <td>{{ trend_analysis_acc_new.messagez }}</td>
                      </tr>

                      <tr>
                        <td colspan="7">
                          <span class="td_heading"
                            >Vibration - Velocity (mm/sec)</span
                          >
                        </td>
                      </tr>
                      <tr>
                        <td>Tangential</td>
                        <td>{{ trend_analysis.xmin }}</td>
                        <td>{{ trend_analysis.xmax }}</td>
                        <td>{{ trend_analysis.xavg }}</td>
                        <td>{{ trend_analysis.range }}</td>
                        <td class="text-center">
                          <span
                            *ngIf="
                              trend_analysis.messagex === 'No Action Needed'
                            "
                            class="sprite_icon square_green"
                          ></span>
                          <span
                            *ngIf="
                              trend_analysis.messagex === 'Attention Reqiured'
                            "
                            class="sprite_icon tri_yellow"
                          ></span>
                          <span
                            *ngIf="
                              trend_analysis.messagex ===
                              'Immediate Action Required'
                            "
                            class="sprite_icon tri_red"
                          ></span>
                        </td>
                        <td>{{ trend_analysis.messagex }}</td>
                      </tr>
                      <tr>
                        <td>Radial</td>
                        <td>{{ trend_analysis.ymin }}</td>
                        <td>{{ trend_analysis.ymax }}</td>
                        <td>{{ trend_analysis.yavg }}</td>
                        <td>{{ trend_analysis.range }}</td>
                        <td class="text-center">
                          <span
                            *ngIf="
                              trend_analysis.messagey === 'No Action Needed'
                            "
                            class="sprite_icon square_green"
                          ></span>
                          <span
                            *ngIf="
                              trend_analysis.messagey === 'Attention Reqiured'
                            "
                            class="sprite_icon tri_yellow"
                          ></span>
                          <span
                            *ngIf="
                              trend_analysis.messagey ===
                              'Immediate Action Required'
                            "
                            class="sprite_icon tri_red"
                          ></span>
                        </td>
                        <td>{{ trend_analysis.messagey }}</td>
                      </tr>
                      <tr>
                        <td>Axial</td>
                        <td>{{ trend_analysis.zmin }}</td>
                        <td>{{ trend_analysis.zmax }}</td>
                        <td>{{ trend_analysis.zavg }}</td>
                        <td>{{ trend_analysis.range }}</td>
                        <td class="text-center">
                          <span
                            *ngIf="
                              trend_analysis.messagez === 'No Action Needed'
                            "
                            class="sprite_icon square_green"
                          ></span>
                          <span
                            *ngIf="
                              trend_analysis.messagez === 'Attention Reqiured'
                            "
                            class="sprite_icon tri_yellow"
                          ></span>
                          <span
                            *ngIf="
                              trend_analysis.messagez ===
                              'Immediate Action Required'
                            "
                            class="sprite_icon tri_red"
                          ></span>
                        </td>
                        <td>{{ trend_analysis.messagez }}</td>
                      </tr>

                      <tr>
                        <td colspan="7">
                          <span class="td_heading">Temperature (°C)</span>
                        </td>
                      </tr>
                      <tr>
                        <td>DE Bearing</td>
                        <td>{{ trendTempanalysis.xmin }}</td>
                        <td>{{ trendTempanalysis.xmax }}</td>
                        <td>{{ trendTempanalysis.xavg }}</td>
                        <td>{{ trendTempanalysis.range }}</td>
                        <td class="text-center">
                          <span
                            *ngIf="
                              trendTempanalysis.messagex === 'No Action Needed'
                            "
                            class="sprite_icon square_green"
                          ></span>
                          <span
                            *ngIf="
                              trendTempanalysis.messagex ===
                              'Attention Reqiured'
                            "
                            class="sprite_icon tri_yellow"
                          ></span>
                          <span
                            *ngIf="
                              trendTempanalysis.messagex ===
                              'Immediate Action Required'
                            "
                            class="sprite_icon tri_red"
                          ></span>
                        </td>
                        <td>{{ trendTempanalysis.messagex }}</td>
                      </tr>
                      <tr>
                        <td>Machine Skin</td>
                        <td>{{ trendTempanalysis.ymin }}</td>
                        <td>{{ trendTempanalysis.ymax }}</td>
                        <td>{{ trendTempanalysis.yavg }}</td>
                        <td>{{ trendTempanalysis.range }}</td>
                        <td class="text-center">
                          <span
                            *ngIf="
                              trendTempanalysis.messagey === 'No Action Needed'
                            "
                            class="sprite_icon square_green"
                          ></span>
                          <span
                            *ngIf="
                              trendTempanalysis.messagey ===
                              'Attention Reqiured'
                            "
                            class="sprite_icon tri_yellow"
                          ></span>
                          <span
                            *ngIf="
                              trendTempanalysis.messagey ===
                              'Immediate Action Required'
                            "
                            class="sprite_icon tri_red"
                          ></span>
                        </td>
                        <td>{{ trendTempanalysis.messagey }}</td>
                      </tr>
                      <tr>
                        <td>NDE Bearing</td>
                        <td>{{ trendTempanalysis.zmin }}</td>
                        <td>{{ trendTempanalysis.zmax }}</td>
                        <td>{{ trendTempanalysis.zavg }}</td>
                        <td>{{ trendTempanalysis.range }}</td>
                        <td class="text-center">
                          <span
                            *ngIf="
                              trendTempanalysis.messagez === 'No Action Needed'
                            "
                            class="sprite_icon square_green"
                          ></span>
                          <span
                            *ngIf="
                              trendTempanalysis.messagez ===
                              'Attention Reqiured'
                            "
                            class="sprite_icon tri_yellow"
                          >
                          </span>
                          <span
                            *ngIf="
                              trendTempanalysis.messagez ===
                              'Immediate Action Required'
                            "
                            class="sprite_icon tri_red"
                          ></span>
                        </td>
                        <td>{{ trendTempanalysis.messagez }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="overall_status">
                  Overall Machine Status:<span>{{ MachineStatus }}</span>
                </div>
                <div class="overall_status">
                  Recommended Action:<span>{{ RecommendedAction }}</span>
                </div>
              </div>
            </div>
          </ng-template>
        </li>
      </ul>
      @if (showRequestTokenModal) {
        <div class="modal-overlay">
          <div class="modal-carwd">
            <div class="modal-header">
              <mat-icon class="modal-icon" color="primary">help_outline</mat-icon>
              <h3 class="modal-title">{{ modalTitle }}</h3>
            </div>
            <div class="modal-body">
              <p>{{ modalMessage }}</p>
            </div>
            <div class="modal-footer">
            <button mat-stroked-button (click)="closeRequestTokenModal()" style="color: red !important; border: 1px solid red !important;">Cancel</button>
            @if (!ON_PREM) {
              @if (isMailReceived) {
                <button mat-raised-button color="primary" disabled>Token Request Sent</button>
              } @else {
                <button mat-raised-button color="primary" (click)="requestTokenFromAdmin()" [disabled]="sendingRequestToken">
                  {{ sendingRequestToken ? 'Sending...' : 'Request Token' }}
                </button>
              }
            }
          </div>
          </div>
        </div>
      }


      <div [ngbNavOutlet]="ctdTabset"></div>
    </div>
  </div>
</div>
